export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Datetime: any;
  Json: any;
  Upload: any;
};

export type Activity = {
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  pageInfo: PageInfo;
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Activity>;
};

export enum AllowPublicContentBy {
  AdminTopicsUserPosts = 'ADMIN_TOPICS_USER_POSTS',
  All = 'ALL',
  OnlyAdmins = 'ONLY_ADMINS'
}

export enum AnalyticsEvent {
  RequestIntegration = 'REQUEST_INTEGRATION'
}

export type AncestorSearchResult = {
  __typename?: 'AncestorSearchResult';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Annotation = PublicAnnotationFields & {
  __typename?: 'Annotation';
  author: User;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  detail?: Maybe<AuditLogDetail>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  type: AuditLogType;
  user: User;
};

export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  edges?: Maybe<Array<Maybe<AuditLogEdge>>>;
  pageInfo: PageInfo;
};

export type AuditLogDetail = {
  __typename?: 'AuditLogDetail';
  approverId?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  draft?: Maybe<Scalars['Boolean']>;
  from?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  invitationId?: Maybe<Scalars['String']>;
  inviterId?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['String']>;
  privacy?: Maybe<Scalars['String']>;
  provisionId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  team?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  topicId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AuditLogEdge = {
  __typename?: 'AuditLogEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AuditLog>;
};

export enum AuditLogType {
  GroupDelete = 'GROUP_DELETE',
  IntegrationAdd = 'INTEGRATION_ADD',
  IntegrationDelete = 'INTEGRATION_DELETE',
  IntegrationUpdate = 'INTEGRATION_UPDATE',
  LoginFailure = 'LOGIN_FAILURE',
  LoginMagic = 'LOGIN_MAGIC',
  LoginSso = 'LOGIN_SSO',
  LoginSuccess = 'LOGIN_SUCCESS',
  MassExport = 'MASS_EXPORT',
  OrganizationDelete = 'ORGANIZATION_DELETE',
  PostDelete = 'POST_DELETE',
  ResetRequest = 'RESET_REQUEST',
  ResetSuccess = 'RESET_SUCCESS',
  SeriesDelete = 'SERIES_DELETE',
  TemplateDelete = 'TEMPLATE_DELETE',
  TopicDelete = 'TOPIC_DELETE',
  UserCreate = 'USER_CREATE',
  UserDeactivate = 'USER_DEACTIVATE',
  UserReactivate = 'USER_REACTIVATE',
  UserUpdate = 'USER_UPDATE'
}

export enum AuthenticationMode {
  SsoAndGuestPassword = 'SSO_AND_GUEST_PASSWORD',
  SsoAndPassword = 'SSO_AND_PASSWORD',
  SsoOnly = 'SSO_ONLY'
}

export type BillingCoupon = {
  __typename?: 'BillingCoupon';
  amountOff?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Float']>;
};

export type BillingPlan = {
  __typename?: 'BillingPlan';
  amount: Scalars['Int'];
  id: Scalars['ID'];
};

export type BillingPricing = {
  __typename?: 'BillingPricing';
  business: BillingTier;
  free: BillingTier;
  guestCount: Scalars['Int'];
  startup: BillingTier;
  userCount: Scalars['Int'];
};

export type BillingSummary = {
  __typename?: 'BillingSummary';
  chargeAutomatically?: Maybe<Scalars['Boolean']>;
  coupon?: Maybe<BillingCoupon>;
  customer: BillingSummaryCustomer;
  id: Scalars['ID'];
  overageBill: BillingSummaryBill;
  pendingActionUrl?: Maybe<Scalars['String']>;
  periodEndAt?: Maybe<Scalars['Datetime']>;
  plan?: Maybe<BillingSummaryPlan>;
  planBill: BillingSummaryBill;
  seatCount: Scalars['Int'];
  seatLimit?: Maybe<Scalars['Int']>;
  source?: Maybe<BillingSummarySource>;
  startAt?: Maybe<Scalars['Datetime']>;
  status: BillingSummaryStatus;
  trialEndAt?: Maybe<Scalars['Datetime']>;
  userCount: Scalars['Int'];
};

export type BillingSummaryBill = {
  __typename?: 'BillingSummaryBill';
  amount: Scalars['Int'];
  billAt: Scalars['Datetime'];
};

export type BillingSummaryCustomer = {
  __typename?: 'BillingSummaryCustomer';
  balance?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type BillingSummaryPlan = {
  __typename?: 'BillingSummaryPlan';
  id: Scalars['ID'];
  interval: PlanInterval;
  name: Scalars['String'];
  tier: PlanTier;
  type: PlanType;
};

export type BillingSummarySource = {
  __typename?: 'BillingSummarySource';
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  id: Scalars['ID'];
  last4: Scalars['String'];
};

export enum BillingSummaryStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  CanceledAndActive = 'CANCELED_AND_ACTIVE',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type BillingTier = {
  __typename?: 'BillingTier';
  monthly: BillingPlan;
  yearly: BillingPlan;
};

export type Comment = PublicCommentFields & {
  __typename?: 'Comment';
  author: User;
  content: Scalars['Json'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  reactions: Array<CommentReaction>;
  thread: Thread;
};

export type CommentNotification = Notification & {
  __typename?: 'CommentNotification';
  actor?: Maybe<User>;
  comment?: Maybe<Comment>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  metadata: NotificationMetadata;
  status: NotificationStatus;
  type: NotificationType;
};

export type CommentReaction = PublicCommentReactionFields & {
  __typename?: 'CommentReaction';
  author: User;
  commentId: Scalars['ID'];
  emoji: Scalars['String'];
  id: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type CommentSearchResult = {
  __typename?: 'CommentSearchResult';
  comment: Comment;
  content?: Maybe<Scalars['Json']>;
};

export type CreatedCommentActivity = Activity & {
  __typename?: 'CreatedCommentActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  createdComment?: Maybe<Comment>;
};

export type CreatedHistoryActivity = Activity & {
  __typename?: 'CreatedHistoryActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  createdHistory?: Maybe<History>;
};

export type CreatedTopicActivity = Activity & {
  __typename?: 'CreatedTopicActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  createdTopic?: Maybe<Topic>;
};

export type CustomDomain = {
  __typename?: 'CustomDomain';
  active: Scalars['Boolean'];
  default: Scalars['Boolean'];
  hostname: Scalars['String'];
};

export type DebugAskSearchResult = {
  __typename?: 'DebugAskSearchResult';
  prompt: Scalars['String'];
  response: Scalars['String'];
  searchResults: Array<PostSearchResult>;
  source?: Maybe<Post>;
};

export enum DraftsFilter {
  All = 'ALL',
  Archived = 'ARCHIVED',
  Mine = 'MINE',
  Shared = 'SHARED'
}

export enum DraftsOrder {
  Alphabetical = 'ALPHABETICAL',
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyUpdated = 'RECENTLY_UPDATED',
  RecentlyViewed = 'RECENTLY_VIEWED'
}

export enum ExportFormat {
  Docx = 'DOCX',
  Markdown = 'MARKDOWN'
}

export enum ExportPrivacy {
  Open = 'OPEN',
  Private = 'PRIVATE',
  Secret = 'SECRET'
}

export type ExportResult = {
  __typename?: 'ExportResult';
  url: Scalars['String'];
};

export type ExternalAccessToken = {
  __typename?: 'ExternalAccessToken';
  authorizationUrl: Scalars['String'];
  publishableKey: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type ExternalPost = SlimExternalPostFields & {
  __typename?: 'ExternalPost';
  editUrl: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  platform: Scalars['String'];
  readUrl: Scalars['String'];
};

export type ExternalPostPlatform = {
  __typename?: 'ExternalPostPlatform';
  id: Scalars['String'];
  posts?: Maybe<PostConnection>;
  postsCount: Scalars['Int'];
};


export type ExternalPostPlatformPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ExternalPostsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExternalPostsOrder>;
};


export type ExternalPostPlatformPostsCountArgs = {
  filter?: InputMaybe<ExternalPostsFilter>;
};

export enum ExternalPostsFilter {
  All = 'ALL',
  Archived = 'ARCHIVED',
  Published = 'PUBLISHED',
  Template = 'TEMPLATE',
  Verified = 'VERIFIED'
}

export enum ExternalPostsOrder {
  Alphabetical = 'ALPHABETICAL',
  Popularity = 'POPULARITY',
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyUpdated = 'RECENTLY_UPDATED',
  RecentlyViewed = 'RECENTLY_VIEWED'
}

export enum ExternalSearchMode {
  Personal = 'PERSONAL',
  TeamWide = 'TEAM_WIDE'
}

export type ExternalSearchPlatform = {
  __typename?: 'ExternalSearchPlatform';
  installModes: Array<ExternalSearchMode>;
  personalAuthUrl?: Maybe<Scalars['String']>;
  personalAuthorized: Scalars['Boolean'];
  platform: Scalars['String'];
  teamAuthUrl?: Maybe<Scalars['String']>;
  teamAuthorized: Scalars['Boolean'];
};

export type ExternalSearchSource = {
  __typename?: 'ExternalSearchSource';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FillerActivity = Activity & {
  __typename?: 'FillerActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  filler?: Maybe<Scalars['Boolean']>;
};

export type GitRepo = {
  __typename?: 'GitRepo';
  name: Scalars['String'];
  owner: Scalars['String'];
};

export enum GitRepoPlatform {
  Github = 'GITHUB',
  Gitlab = 'GITLAB'
}

export type GithubWikiImportResult = {
  __typename?: 'GithubWikiImportResult';
  errorMessage?: Maybe<Scalars['String']>;
  imported?: Maybe<Array<Maybe<Post>>>;
  repo?: Maybe<GitRepo>;
};

export type Group = PublicGroupFields & {
  __typename?: 'Group';
  allUsers: Array<User>;
  banner?: Maybe<Image>;
  children: Array<Group>;
  description: Scalars['Json'];
  id: Scalars['ID'];
  members: Array<User>;
  membershipTopics: Array<Topic>;
  name: Scalars['String'];
  owners: Array<User>;
  parents: Array<Group>;
  requestors: Array<User>;
};

export type GroupGroupSubscription = {
  __typename?: 'GroupGroupSubscription';
  child?: Maybe<Group>;
  parent?: Maybe<Group>;
};

export type GroupSearchResult = {
  __typename?: 'GroupSearchResult';
  description?: Maybe<Scalars['Json']>;
  group: Group;
  name?: Maybe<Scalars['String']>;
};

export enum GroupUserRole {
  Member = 'MEMBER',
  Owner = 'OWNER',
  Requestor = 'REQUESTOR'
}

export type GroupUserSubscription = {
  __typename?: 'GroupUserSubscription';
  group?: Maybe<Group>;
  user?: Maybe<User>;
};

export type History = SlimHistoryFields & {
  __typename?: 'History';
  authors: Array<User>;
  delta: Scalars['Json'];
  diff: Scalars['Json'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  post: Post;
  snapshot: Scalars['Json'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
};

export type HistoryNotification = Notification & {
  __typename?: 'HistoryNotification';
  actor?: Maybe<User>;
  history?: Maybe<History>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  metadata: NotificationMetadata;
  status: NotificationStatus;
  type: NotificationType;
};

export type Identity = {
  __typename?: 'Identity';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  platform: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  original?: Maybe<Scalars['String']>;
  thumb?: Maybe<Scalars['String']>;
};

export enum ImportExtension {
  Csv = 'CSV',
  Html = 'HTML',
  Md = 'MD',
  Zip = 'ZIP'
}

export enum ImportSource {
  Confluence = 'CONFLUENCE',
  File = 'FILE',
  Guru = 'GURU',
  Notion = 'NOTION'
}

export type ImportedFile = {
  __typename?: 'ImportedFile';
  filename?: Maybe<Scalars['String']>;
  post: Post;
};

export enum InsightLeaderboardType {
  Readers = 'READERS',
  Writers = 'WRITERS'
}

export type InsightMetric = {
  __typename?: 'InsightMetric';
  date: Scalars['Datetime'];
  quantity: Scalars['Int'];
};

export type InsightMetrics = {
  __typename?: 'InsightMetrics';
  change?: Maybe<Scalars['Float']>;
  metrics?: Maybe<Array<Maybe<InsightMetric>>>;
  total: Scalars['Int'];
};

export enum InsightMetricsType {
  Reads = 'READS',
  Views = 'VIEWS'
}

export type InsightSearch = {
  __typename?: 'InsightSearch';
  averageClickPosition?: Maybe<Scalars['Float']>;
  clickCount?: Maybe<Scalars['Int']>;
  clickThroughRate?: Maybe<Scalars['Float']>;
  conversionCount?: Maybe<Scalars['Int']>;
  conversionRate?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  hitCount?: Maybe<Scalars['Int']>;
  query: Scalars['String'];
  trackedSearchCount?: Maybe<Scalars['Int']>;
};

export type InsightSearchConnection = {
  __typename?: 'InsightSearchConnection';
  edges?: Maybe<Array<Maybe<InsightSearchEdge>>>;
  pageInfo: PageInfo;
};

export type InsightSearchEdge = {
  __typename?: 'InsightSearchEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InsightSearch>;
};

export enum InsightSearchMetricsType {
  Searchers = 'SEARCHERS',
  Searches = 'SEARCHES'
}

export enum InsightTopPostsOrder {
  Reads = 'READS',
  Views = 'VIEWS'
}

export enum InsightTopSearchesOrder {
  AverageClickPosition = 'AVERAGE_CLICK_POSITION',
  ClickThroughRate = 'CLICK_THROUGH_RATE',
  ConversionRate = 'CONVERSION_RATE',
  TrackedSearchCount = 'TRACKED_SEARCH_COUNT'
}

export enum InsightTopSearchesType {
  Default = 'DEFAULT',
  NoClicks = 'NO_CLICKS',
  NoResults = 'NO_RESULTS'
}

export type InsightUser = {
  __typename?: 'InsightUser';
  quantity: Scalars['Int'];
  rank: Scalars['Int'];
  user: User;
};

export type InsightUserConnection = {
  __typename?: 'InsightUserConnection';
  edges?: Maybe<Array<Maybe<InsightUserEdge>>>;
  pageInfo: PageInfo;
};

export type InsightUserEdge = {
  __typename?: 'InsightUserEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InsightUser>;
};

export type Integration = {
  __typename?: 'Integration';
  externalId: Scalars['String'];
  features?: Maybe<IntegrationFeatures>;
  id: Scalars['ID'];
  organization: Organization;
  platform: Scalars['String'];
  settings?: Maybe<IntegrationSettings>;
  status: IntegrationStatus;
};

export type IntegrationExtraInput = {
  email?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
};

export enum IntegrationFeatureStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Unsupported = 'UNSUPPORTED'
}

export type IntegrationFeatures = {
  __typename?: 'IntegrationFeatures';
  externalUsers?: Maybe<IntegrationFeatureStatus>;
  mention?: Maybe<IntegrationFeatureStatus>;
  profiles?: Maybe<IntegrationFeatureStatus>;
  repoSync?: Maybe<IntegrationFeatureStatus>;
  saml?: Maybe<IntegrationFeatureStatus>;
  scim?: Maybe<IntegrationFeatureStatus>;
  sso?: Maybe<IntegrationFeatureStatus>;
  teamSearch?: Maybe<IntegrationFeatureStatus>;
};

export type IntegrationLink = {
  __typename?: 'IntegrationLink';
  externalId: Scalars['String'];
  externalTitle: Scalars['String'];
  id: Scalars['ID'];
  insertedBy: User;
  preview?: Maybe<Image>;
  title?: Maybe<Scalars['String']>;
  type: MentionType;
};

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  enableAllParents?: Maybe<Scalars['Boolean']>;
  enableEnrich?: Maybe<Scalars['Boolean']>;
  enableScim?: Maybe<Scalars['Boolean']>;
  enableSearch?: Maybe<IntegrationSettingsSearch>;
  enableSso?: Maybe<Scalars['Boolean']>;
  enabledParents?: Maybe<Array<Scalars['ID']>>;
  enabledSearchSources?: Maybe<Array<Scalars['ID']>>;
  idpMetadata?: Maybe<Scalars['String']>;
  importOwnerId?: Maybe<Scalars['String']>;
  scimToken?: Maybe<Scalars['String']>;
  syncingRepos?: Maybe<Array<SyncingRepo>>;
};

export type IntegrationSettingsInput = {
  enableAllParents?: InputMaybe<Scalars['Boolean']>;
  enableEnrich?: InputMaybe<Scalars['Boolean']>;
  enableScim?: InputMaybe<Scalars['Boolean']>;
  enableSearch?: InputMaybe<IntegrationSettingsSearch>;
  enableSso?: InputMaybe<Scalars['Boolean']>;
  enabledParents?: InputMaybe<Array<Scalars['ID']>>;
  enabledSearchSources?: InputMaybe<Array<Scalars['ID']>>;
  idpMetadata?: InputMaybe<Scalars['String']>;
  importOwnerId?: InputMaybe<Scalars['ID']>;
  syncingRepos?: InputMaybe<Array<SyncingRepoInput>>;
};

export enum IntegrationSettingsSearch {
  All = 'ALL',
  Custom = 'CUSTOM',
  Disabled = 'DISABLED',
  Public = 'PUBLIC'
}

export enum IntegrationStatus {
  Error = 'ERROR',
  Normal = 'NORMAL',
  Upgrade = 'UPGRADE'
}

export type Invitation = {
  __typename?: 'Invitation';
  acceptedAt?: Maybe<Scalars['Datetime']>;
  acceptedUser?: Maybe<User>;
  avatar?: Maybe<Image>;
  email: Scalars['String'];
  id: Scalars['ID'];
  inviter?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  provision?: Maybe<Provision>;
  source: InvitationSource;
  status: InvitationStatus;
  statusBy?: Maybe<User>;
  type: ProvisionType;
};

export type InvitationNotification = Notification & {
  __typename?: 'InvitationNotification';
  actor?: Maybe<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  invitation?: Maybe<Invitation>;
  metadata: NotificationMetadata;
  status: NotificationStatus;
  type: NotificationType;
};

export enum InvitationSource {
  Post = 'POST'
}

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type JoinedUserActivity = Activity & {
  __typename?: 'JoinedUserActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  joinedUser?: Maybe<User>;
};

export type Mention = {
  __typename?: 'Mention';
  assignee?: Maybe<MentionUser>;
  breadcrumbs?: Maybe<Array<Maybe<Scalars['String']>>>;
  content?: Maybe<MentionContent>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importable: Scalars['Boolean'];
  participants?: Maybe<Array<Maybe<MentionUser>>>;
  preview?: Maybe<MentionPreview>;
  status?: Maybe<MentionStatus>;
  statusDate?: Maybe<Scalars['Datetime']>;
  tags?: Maybe<Array<Maybe<MentionTag>>>;
  title: Scalars['String'];
  type: MentionType;
  url?: Maybe<Scalars['String']>;
};

export type MentionContent = MentionContentDelta | MentionContentHighlights | MentionContentSlack;

export type MentionContentDelta = {
  __typename?: 'MentionContentDelta';
  delta?: Maybe<Scalars['Json']>;
};

export type MentionContentHighlights = {
  __typename?: 'MentionContentHighlights';
  highlights?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MentionContentSlack = {
  __typename?: 'MentionContentSlack';
  channel?: Maybe<SlackChannel>;
  message?: Maybe<SlackMessage>;
  next?: Maybe<SlackMessage>;
  previous?: Maybe<SlackMessage>;
};

export type MentionPreview = {
  __typename?: 'MentionPreview';
  content?: Maybe<Scalars['Json']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export enum MentionStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Due = 'DUE',
  Merged = 'MERGED',
  Opened = 'OPENED',
  Sent = 'SENT',
  Updated = 'UPDATED'
}

export type MentionTag = {
  __typename?: 'MentionTag';
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum MentionType {
  AirtableTable = 'AIRTABLE_TABLE',
  AsanaTask = 'ASANA_TASK',
  BoxFile = 'BOX_FILE',
  ClickupTask = 'CLICKUP_TASK',
  ConfluenceContent = 'CONFLUENCE_CONTENT',
  ConfluenceOther = 'CONFLUENCE_OTHER',
  ConfluenceSpace = 'CONFLUENCE_SPACE',
  ConfluenceUser = 'CONFLUENCE_USER',
  DropboxFile = 'DROPBOX_FILE',
  DropboxFolder = 'DROPBOX_FOLDER',
  FigmaFile = 'FIGMA_FILE',
  FreshdeskTicket = 'FRESHDESK_TICKET',
  GithubIssue = 'GITHUB_ISSUE',
  GithubPr = 'GITHUB_PR',
  GitlabIssue = 'GITLAB_ISSUE',
  GitlabMerge = 'GITLAB_MERGE',
  GoogleDriveAudio = 'GOOGLE_DRIVE_AUDIO',
  GoogleDriveDoc = 'GOOGLE_DRIVE_DOC',
  GoogleDriveImage = 'GOOGLE_DRIVE_IMAGE',
  GoogleDriveOther = 'GOOGLE_DRIVE_OTHER',
  GoogleDriveSheet = 'GOOGLE_DRIVE_SHEET',
  GoogleDriveSlide = 'GOOGLE_DRIVE_SLIDE',
  GoogleDriveVideo = 'GOOGLE_DRIVE_VIDEO',
  GuruCard = 'GURU_CARD',
  HeightTask = 'HEIGHT_TASK',
  JiraIssue = 'JIRA_ISSUE',
  LinearIssue = 'LINEAR_ISSUE',
  LucidDocument = 'LUCID_DOCUMENT',
  MiroBoard = 'MIRO_BOARD',
  MondayBoard = 'MONDAY_BOARD',
  MondayPulse = 'MONDAY_PULSE',
  QuipChat = 'QUIP_CHAT',
  QuipDocument = 'QUIP_DOCUMENT',
  QuipSlides = 'QUIP_SLIDES',
  QuipSpreadsheet = 'QUIP_SPREADSHEET',
  QuipThread = 'QUIP_THREAD',
  ShortcutEpic = 'SHORTCUT_EPIC',
  ShortcutStory = 'SHORTCUT_STORY',
  SlackChannelMessage = 'SLACK_CHANNEL_MESSAGE',
  SlackDirectMessage = 'SLACK_DIRECT_MESSAGE',
  SlackGroupMessage = 'SLACK_GROUP_MESSAGE',
  SlackOther = 'SLACK_OTHER',
  TodoistTask = 'TODOIST_TASK',
  TrelloCard = 'TRELLO_CARD',
  WrikeTask = 'WRIKE_TASK',
  ZendeskArticle = 'ZENDESK_ARTICLE',
  ZendeskTicket = 'ZENDESK_TICKET'
}

export type MentionUser = {
  __typename?: 'MentionUser';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  role?: Maybe<Scalars['String']>;
};

export type Notification = {
  actor?: Maybe<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  metadata: NotificationMetadata;
  status: NotificationStatus;
  type: NotificationType;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Notification>;
};

export type NotificationMetadata = {
  __typename?: 'NotificationMetadata';
  message?: Maybe<Scalars['String']>;
};

export enum NotificationReadStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationStatus {
  Aborted = 'ABORTED',
  New = 'NEW',
  Read = 'READ',
  Sent = 'SENT'
}

export enum NotificationType {
  CommentCreate = 'COMMENT_CREATE',
  CommentMention = 'COMMENT_MENTION',
  CommentReply = 'COMMENT_REPLY',
  CommentResolve = 'COMMENT_RESOLVE',
  InviteAccept = 'INVITE_ACCEPT',
  PostArchive = 'POST_ARCHIVE',
  PostEdit = 'POST_EDIT',
  PostPublish = 'POST_PUBLISH',
  PostShare = 'POST_SHARE',
  PostThank = 'POST_THANK',
  ReactionCreate = 'REACTION_CREATE',
  VerificationExpired = 'VERIFICATION_EXPIRED',
  VerificationReminder = 'VERIFICATION_REMINDER',
  VerificationRequest = 'VERIFICATION_REQUEST'
}

export type ObjectWithId = {
  id: Scalars['ID'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  completedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['ID'];
  skippedAt?: Maybe<Scalars['Datetime']>;
  step?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
};

export type Organization = ObjectWithId & PublicOrganizationFields & {
  __typename?: 'Organization';
  auditLogs?: Maybe<AuditLogConnection>;
  billingStatus?: Maybe<BillingSummaryStatus>;
  customDomains: Array<CustomDomain>;
  effectiveHost: Scalars['String'];
  email: Scalars['String'];
  externalUsers: Array<ExternalUser>;
  groups: Array<Group>;
  host: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  integrations: Array<Integration>;
  invitations: Array<Invitation>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isTrialEnded?: Maybe<Scalars['Boolean']>;
  isTrialEndingSoon?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Image>;
  name: Scalars['String'];
  notifications?: Maybe<NotificationConnection>;
  periodEndAt?: Maybe<Scalars['Datetime']>;
  planTier?: Maybe<PlanTier>;
  posts: Array<SlimPost>;
  provisions: Array<Provision>;
  readNotifications?: Maybe<NotificationConnection>;
  referralCode?: Maybe<Scalars['String']>;
  series: Array<Series>;
  settings?: Maybe<OrganizationSettings>;
  summary?: Maybe<Scalars['Json']>;
  topics: Array<Topic>;
  trialEndAt?: Maybe<Scalars['Datetime']>;
  unreadNotifications?: Maybe<NotificationConnection>;
  users: Array<User>;
  webhooks?: Maybe<Array<Maybe<Webhook>>>;
};


export type OrganizationAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  types?: InputMaybe<Array<InputMaybe<AuditLogType>>>;
  user?: InputMaybe<Scalars['ID']>;
};


export type OrganizationNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrganizationReadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrganizationUnreadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrganizationUsersArgs = {
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationSettings = PublicOrganizationSettingsFields & {
  __typename?: 'OrganizationSettings';
  allowPublicContentBy?: Maybe<AllowPublicContentBy>;
  allowSsoUserCreation?: Maybe<Scalars['Boolean']>;
  allowUserGroupCreation?: Maybe<Scalars['Boolean']>;
  allowUserRootTopic?: Maybe<Scalars['Boolean']>;
  allowedEmbedHosts?: Maybe<Array<Maybe<Scalars['String']>>>;
  authentication?: Maybe<AuthenticationMode>;
  requireInviteApproval?: Maybe<Scalars['Boolean']>;
  seatLimit?: Maybe<Scalars['Int']>;
};

export type OrganizationSettingsInput = {
  allowPublicContentBy?: InputMaybe<AllowPublicContentBy>;
  allowSsoUserCreation?: InputMaybe<Scalars['Boolean']>;
  allowUserGroupCreation?: InputMaybe<Scalars['Boolean']>;
  allowUserRootTopic?: InputMaybe<Scalars['Boolean']>;
  allowedEmbedHosts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authentication?: InputMaybe<AuthenticationMode>;
  requireInviteApproval?: InputMaybe<Scalars['Boolean']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum PlanInterval {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum PlanTier {
  Business = 'BUSINESS',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Startup = 'STARTUP'
}

export enum PlanType {
  Custom = 'CUSTOM',
  Legacy = 'LEGACY',
  Standard = 'STANDARD'
}

export type Post = PublicPostFields & RootPostFields & SlimPostFields & {
  __typename?: 'Post';
  annotations: Array<Annotation>;
  archivedAt?: Maybe<Scalars['Datetime']>;
  archiver?: Maybe<User>;
  backlinks: Array<PostBacklink>;
  banner?: Maybe<Image>;
  content: Scalars['Json'];
  contributors: Array<User>;
  externalPost?: Maybe<ExternalPost>;
  histories: Array<SlimHistory>;
  history?: Maybe<History>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  isEditing?: Maybe<Scalars['Boolean']>;
  lastHistory?: Maybe<SlimHistory>;
  linkAccess: PostLinkAccess;
  owner: User;
  publicUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  reads: Scalars['Int'];
  score?: Maybe<Scalars['Float']>;
  series?: Maybe<Series>;
  seriesOrder?: Maybe<Scalars['Int']>;
  sharing?: Maybe<PostDirectShare>;
  thankers: Array<User>;
  thanks: Scalars['Int'];
  threads: Array<Thread>;
  title: Scalars['String'];
  topics: Array<Topic>;
  type: PostType;
  updatedAt: Scalars['Datetime'];
  userViewedAt?: Maybe<Scalars['Datetime']>;
  verification?: Maybe<Verification>;
  verificationEntries: Array<VerificationEntry>;
  verifiedAt?: Maybe<Scalars['Datetime']>;
  version: Scalars['Int'];
  viewers: Array<User>;
  views: Scalars['Int'];
};


export type PostHistoryArgs = {
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
};


export type PostThreadsArgs = {
  historical?: InputMaybe<Scalars['Boolean']>;
};

export type PostBacklink = Group | Post | Topic | User;

export type PostConnection = {
  __typename?: 'PostConnection';
  edges?: Maybe<Array<Maybe<PostEdge>>>;
  pageInfo: PageInfo;
};

export type PostDirectShare = {
  __typename?: 'PostDirectShare';
  editorGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  editorIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  viewerGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  viewerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Post>;
};

export type PostEdgesConnection = {
  __typename?: 'PostEdgesConnection';
  edges?: Maybe<Array<Maybe<PostEdgesEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PostEdgesEdge = {
  __typename?: 'PostEdgesEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Post>;
};

export type PostGroupShareSubscription = {
  __typename?: 'PostGroupShareSubscription';
  group?: Maybe<Group>;
  role?: Maybe<PostShareRole>;
};

export enum PostLinkAccess {
  Disabled = 'DISABLED',
  Internal = 'INTERNAL',
  Public = 'PUBLIC',
  PublicEdit = 'PUBLIC_EDIT'
}

export type PostMetrics = {
  __typename?: 'PostMetrics';
  id: Scalars['ID'];
  post: Post;
  reads: Scalars['Int'];
  views: Scalars['Int'];
};

export type PostMetricsConnection = {
  __typename?: 'PostMetricsConnection';
  edges?: Maybe<Array<Maybe<PostMetricsEdge>>>;
  pageInfo: PageInfo;
};

export type PostMetricsEdge = {
  __typename?: 'PostMetricsEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PostMetrics>;
};

export type PostNotification = Notification & {
  __typename?: 'PostNotification';
  actor?: Maybe<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  metadata: NotificationMetadata;
  post?: Maybe<Post>;
  status: NotificationStatus;
  type: NotificationType;
};

export type PostSearchResult = {
  __typename?: 'PostSearchResult';
  ancestors: Array<AncestorSearchResult>;
  content?: Maybe<Scalars['Json']>;
  highlight?: Maybe<Scalars['Json']>;
  highlightIndex?: Maybe<Scalars['Int']>;
  post: Post;
  resultId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum PostShareRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type PostShareSubscription = {
  __typename?: 'PostShareSubscription';
  role?: Maybe<PostShareRole>;
  user?: Maybe<User>;
};

export enum PostType {
  Post = 'POST',
  Template = 'TEMPLATE'
}

export type PostUpload = {
  __typename?: 'PostUpload';
  url?: Maybe<Scalars['String']>;
};

export type Provision = {
  __typename?: 'Provision';
  favoritePosts: Array<Post>;
  favoriteTopics: Array<Topic>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isSsoDefault: Scalars['Boolean'];
  name: Scalars['String'];
  posts: Array<Post>;
  secret: Scalars['String'];
  topics: Array<Topic>;
  type: ProvisionType;
  urlEnabled: Scalars['Boolean'];
};

export type ProvisionChange = {
  action: ProvisionChangeAction;
  relation: ProvisionChangeRelation;
  targetId: Scalars['ID'];
};

export enum ProvisionChangeAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export enum ProvisionChangeRelation {
  FavoritePost = 'FAVORITE_POST',
  FavoriteTopic = 'FAVORITE_TOPIC',
  Group = 'GROUP',
  PostEditor = 'POST_EDITOR',
  PostViewer = 'POST_VIEWER',
  Topic = 'TOPIC'
}

export type ProvisionChangesInput = {
  changes: Array<ProvisionChange>;
  type?: InputMaybe<ProvisionType>;
};

export enum ProvisionType {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  User = 'USER'
}

export type PublicAnnotation = PublicAnnotationFields & {
  __typename?: 'PublicAnnotation';
  author: PublicUser;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
};

export type PublicAnnotationFields = {
  author: PublicUserFields;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
};

export type PublicComment = PublicCommentFields & {
  __typename?: 'PublicComment';
  author: PublicUser;
  content: Scalars['Json'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  reactions: Array<PublicCommentReaction>;
  thread: PublicThread;
};

export type PublicCommentFields = {
  author: PublicUserFields;
  content: Scalars['Json'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  reactions: Array<PublicCommentReactionFields>;
  thread: PublicThreadFields;
};

export type PublicCommentReaction = PublicCommentReactionFields & {
  __typename?: 'PublicCommentReaction';
  author: PublicUser;
  commentId: Scalars['ID'];
  emoji: Scalars['String'];
  id: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type PublicCommentReactionFields = {
  author: PublicUserFields;
  commentId: Scalars['ID'];
  emoji: Scalars['String'];
  id: Scalars['ID'];
  threadId: Scalars['ID'];
};

export type PublicGroup = PublicGroupFields & {
  __typename?: 'PublicGroup';
  banner?: Maybe<Image>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PublicGroupFields = {
  banner?: Maybe<Image>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PublicInvitation = {
  __typename?: 'PublicInvitation';
  acceptedAt?: Maybe<Scalars['Datetime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  provision?: Maybe<PublicProvision>;
  status: InvitationStatus;
  type: ProvisionType;
};

export type PublicOrganization = ObjectWithId & PublicOrganizationFields & {
  __typename?: 'PublicOrganization';
  effectiveHost: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<Image>;
  name: Scalars['String'];
  settings?: Maybe<PublicOrganizationSettings>;
};

export type PublicOrganizationFields = {
  effectiveHost: Scalars['String'];
  host: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<Image>;
  name: Scalars['String'];
  settings?: Maybe<PublicOrganizationSettingsFields>;
};

export type PublicOrganizationSettings = PublicOrganizationSettingsFields & {
  __typename?: 'PublicOrganizationSettings';
  allowedEmbedHosts?: Maybe<Array<Maybe<Scalars['String']>>>;
  authentication?: Maybe<AuthenticationMode>;
};

export type PublicOrganizationSettingsFields = {
  allowedEmbedHosts?: Maybe<Array<Maybe<Scalars['String']>>>;
  authentication?: Maybe<AuthenticationMode>;
};

export type PublicPost = PublicPostFields & RootPostFields & {
  __typename?: 'PublicPost';
  annotations: Array<PublicAnnotation>;
  banner?: Maybe<Image>;
  content: Scalars['Json'];
  id: Scalars['ID'];
  linkAccess: PostLinkAccess;
  publicUrl?: Maybe<Scalars['String']>;
  series?: Maybe<PublicSeries>;
  seriesOrder?: Maybe<Scalars['Int']>;
  threads: Array<PublicThread>;
  title: Scalars['String'];
  topics: Array<PublicTopic>;
  version: Scalars['Int'];
};


export type PublicPostThreadsArgs = {
  historical?: InputMaybe<Scalars['Boolean']>;
};

export type PublicPostFields = {
  annotations: Array<PublicAnnotationFields>;
  content: Scalars['Json'];
  id: Scalars['ID'];
  linkAccess: PostLinkAccess;
  publicUrl?: Maybe<Scalars['String']>;
  series?: Maybe<PublicSeriesFields>;
  seriesOrder?: Maybe<Scalars['Int']>;
  threads: Array<PublicThreadFields>;
  title: Scalars['String'];
  topics: Array<PublicTopicFields>;
  version: Scalars['Int'];
};

export type PublicPostSearchResult = {
  __typename?: 'PublicPostSearchResult';
  content?: Maybe<Scalars['Json']>;
  highlight?: Maybe<Scalars['Json']>;
  highlightIndex?: Maybe<Scalars['Int']>;
  post: PublicPost;
  title?: Maybe<Scalars['String']>;
};

export type PublicProvision = {
  __typename?: 'PublicProvision';
  id: Scalars['ID'];
  type: ProvisionType;
};

export type PublicReaction = PublicReactionFields & {
  __typename?: 'PublicReaction';
  author: PublicUser;
  emoji: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  thread: PublicThread;
};

export type PublicReactionFields = {
  author: PublicUserFields;
  emoji: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  thread: PublicThreadFields;
};

export type PublicSearchResult = PublicPostSearchResult | PublicTopicSearchResult;

export type PublicSearchResultConnection = {
  __typename?: 'PublicSearchResultConnection';
  ancestorIds: Array<Scalars['ID']>;
  edges?: Maybe<Array<Maybe<PublicSearchResultEdge>>>;
  pageInfo: PageInfo;
  queryId?: Maybe<Scalars['String']>;
};

export type PublicSearchResultEdge = {
  __typename?: 'PublicSearchResultEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PublicSearchResult>;
};

export type PublicSeries = ObjectWithId & PublicSeriesFields & {
  __typename?: 'PublicSeries';
  id: Scalars['ID'];
  name: Scalars['String'];
  posts: Array<PublicPost>;
};

export type PublicSeriesFields = {
  id: Scalars['ID'];
  name: Scalars['String'];
  posts: Array<PublicPostFields>;
};

export type PublicThread = PublicThreadFields & {
  __typename?: 'PublicThread';
  author?: Maybe<PublicUser>;
  autoresolveAt?: Maybe<Scalars['Datetime']>;
  comments: Array<PublicComment>;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  post: PublicPost;
  reactions: Array<PublicReaction>;
  resolveStatus?: Maybe<ThreadResolveStatus>;
  resolvedAt?: Maybe<Scalars['Datetime']>;
  resolver?: Maybe<PublicUser>;
  type?: Maybe<ThreadType>;
};

export type PublicThreadFields = {
  author?: Maybe<PublicUserFields>;
  autoresolveAt?: Maybe<Scalars['Datetime']>;
  comments: Array<PublicCommentFields>;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  post: PublicPostFields;
  reactions: Array<PublicReactionFields>;
  resolveStatus?: Maybe<ThreadResolveStatus>;
  resolvedAt?: Maybe<Scalars['Datetime']>;
  resolver?: Maybe<PublicUserFields>;
  type?: Maybe<ThreadType>;
};

export type PublicTopic = ObjectWithId & PublicTopicFields & {
  __typename?: 'PublicTopic';
  ancestors: Array<PublicTopic>;
  descendants?: Maybe<PublicTopicConnection>;
  description: Scalars['Json'];
  id: Scalars['ID'];
  name: Scalars['String'];
  posts: Array<PublicPost>;
  privacy: TopicPrivacy;
};


export type PublicTopicDescendantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PublicTopicConnection = {
  __typename?: 'PublicTopicConnection';
  edges?: Maybe<Array<Maybe<PublicTopicEdge>>>;
  pageInfo: PageInfo;
};

export type PublicTopicEdge = {
  __typename?: 'PublicTopicEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PublicTopic>;
};

export type PublicTopicFields = {
  ancestors: Array<PublicTopicFields>;
  description?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  privacy: TopicPrivacy;
};

export type PublicTopicSearchResult = {
  __typename?: 'PublicTopicSearchResult';
  description?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  topic: PublicTopic;
};

export type PublicUser = ObjectWithId & PublicUserFields & {
  __typename?: 'PublicUser';
  avatar?: Maybe<Image>;
  id: Scalars['ID'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type PublicUserFields = {
  avatar?: Maybe<Image>;
  id: Scalars['ID'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type PublishedPostActivity = Activity & {
  __typename?: 'PublishedPostActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  publishedPost?: Maybe<Post>;
};

export type Reaction = PublicReactionFields & {
  __typename?: 'Reaction';
  author: User;
  emoji: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  thread: Thread;
};

export type ReactionNotification = Notification & {
  __typename?: 'ReactionNotification';
  actor?: Maybe<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  metadata: NotificationMetadata;
  reaction?: Maybe<Reaction>;
  status: NotificationStatus;
  type: NotificationType;
};

export type RegistrationResult = {
  __typename?: 'RegistrationResult';
  organization: Organization;
  passwordToken: Scalars['String'];
  redirectPath?: Maybe<Scalars['String']>;
};

export type ReorganizeOperation = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  operationName: ReorganizeOperationName;
  order?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  pinnedOrder?: InputMaybe<Scalars['Int']>;
  postId?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  temporaryId?: InputMaybe<Scalars['ID']>;
  topicId?: InputMaybe<Scalars['ID']>;
};

export enum ReorganizeOperationName {
  AddTopicToPost = 'ADD_TOPIC_TO_POST',
  CreateTopic = 'CREATE_TOPIC',
  DeletePost = 'DELETE_POST',
  DeleteTopic = 'DELETE_TOPIC',
  PinPost = 'PIN_POST',
  RemoveTopicFromPost = 'REMOVE_TOPIC_FROM_POST',
  UnpinPost = 'UNPIN_POST',
  UpdatePost = 'UPDATE_POST',
  UpdateTopic = 'UPDATE_TOPIC'
}

export type RepliedCommentActivity = Activity & {
  __typename?: 'RepliedCommentActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  repliedComment?: Maybe<Comment>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acceptInvitation?: Maybe<Session>;
  addComment: PublicCommentFields;
  addGroupToGroup: Group;
  addGroupToPost: Group;
  addGroupToTopic: Group;
  addReaction: PublicReactionFields;
  addTopicToPost: Topic;
  addUserToGroup: User;
  addUserToPost: User;
  addUserToTopic: User;
  applyProvision: Array<User>;
  approveInvitation: Invitation;
  approveMultipleInvitations: Scalars['Boolean'];
  cancelBilling: BillingSummary;
  clearDefaultCustomDomain: Organization;
  completeUploadedImport: Scalars['Boolean'];
  createAnnotation: PublicAnnotationFields;
  createComment: PublicThreadFields;
  createCommentReaction: PublicCommentReactionFields;
  createCustomDomain: CustomDomain;
  createGroup: Group;
  createIntegrationLink: IntegrationLink;
  createPasswordToken: Scalars['ID'];
  createPost: Post;
  createProvision: Provision;
  createReaction: PublicThreadFields;
  createSamlIntegration: Integration;
  createSeries: Series;
  createStaticTokenIntegration: Integration;
  createSuggestion: PublicThreadFields;
  createTopic: Topic;
  createVerification: Verification;
  createVisitor: VisitorSession;
  createWebhook?: Maybe<Webhook>;
  deactivateUser: User;
  deleteAnnotation: PublicAnnotationFields;
  deleteComment: PublicCommentFields;
  deleteCommentReaction: PublicCommentReactionFields;
  deleteCustomDomain: CustomDomain;
  deleteGroup?: Maybe<Group>;
  deleteIntegration?: Maybe<Integration>;
  deleteIntegrationLink: IntegrationLink;
  deleteInvitation?: Maybe<Invitation>;
  deleteOrganization: Organization;
  deletePost?: Maybe<Post>;
  deleteProvision: Provision;
  deleteReaction: PublicReactionFields;
  deleteSeries?: Maybe<Series>;
  deleteThread: PublicThreadFields;
  deleteTopic?: Maybe<Topic>;
  deleteVerification?: Maybe<Verification>;
  deleteWebhook?: Maybe<Webhook>;
  duplicatePost: Post;
  exportAll: ExportResult;
  favoritePost: Post;
  favoriteTopic: Topic;
  generateImportUploadUrl: Scalars['String'];
  importExternal: Post;
  importFiles: Array<ImportedFile>;
  importGithubWikis?: Maybe<Array<Maybe<GithubWikiImportResult>>>;
  invite: Invitation;
  logout: Scalars['Boolean'];
  magicLogin: Session;
  markNotifications: Array<Notification>;
  passwordLogin: Session;
  pinPost: Topic;
  postMention: Post;
  reactivateUser: User;
  readPost: Post;
  regenerateProvisionSecret: Provision;
  regenerateScimToken: Integration;
  regenerateUserApiToken: Scalars['String'];
  regenerateWebhookSecret?: Maybe<Webhook>;
  register: RegistrationResult;
  registerWithProvision: Session;
  removeExternalSearch?: Maybe<Scalars['Boolean']>;
  removeGroupFromGroup: Group;
  removeGroupFromPost: Group;
  removeGroupFromTopic: Group;
  removeTopicFromPost: Topic;
  removeUserFromGroup: User;
  removeUserFromPost: User;
  removeUserFromTopic: User;
  reorderTopics: Array<Topic>;
  reorganize?: Maybe<Scalars['Boolean']>;
  requestGroupAccess: Group;
  requestGroupCreation: Scalars['Boolean'];
  requestPasswordToken?: Maybe<Scalars['Boolean']>;
  requestPostAccess: User;
  requestTopicAccess: User;
  requestVerification: Verification;
  resendInvitation: Invitation;
  resendVerificationEmail: Scalars['Boolean'];
  resetPassword: Session;
  resolveThread: PublicThreadFields;
  setActive: Scalars['Boolean'];
  setDefaultCustomDomain: Organization;
  startTrial: BillingSummary;
  thankPost: Post;
  track?: Maybe<Scalars['Boolean']>;
  transferPostOwnership: User;
  unpinPost: Topic;
  unresolveThread: PublicThreadFields;
  unthankPost: Post;
  updateAnnotation: PublicAnnotationFields;
  updateBilling: BillingSummary;
  updateComment: PublicCommentFields;
  updateGroup: Group;
  updateGroupInPost: Group;
  updateGroupInTopic: User;
  updateIntegration: Integration;
  updateIntegrationLink: IntegrationLink;
  updateOnboarding: Onboarding;
  updateOrganization: Organization;
  updatePassword: Session;
  updatePost: Post;
  updatePostContent: Post;
  updateProvision: Provision;
  updateSeries: Series;
  updateSuggestion: PublicThreadFields;
  updateTopic: Topic;
  updateUser: User;
  updateUserInGroup: User;
  updateUserInPost: User;
  updateUserInTopic: User;
  updateUserSettings: UserSettings;
  updateVerification: Verification;
  updateVisitor: VisitorUser;
  updateWebhook?: Maybe<Webhook>;
  uploadPostAttachment: PostUpload;
  uploadPostImage: PostUpload;
  verifyCustomDomain: CustomDomain;
  verifyPost: VerificationEntry;
  verifyReferral: Scalars['String'];
};


export type RootMutationTypeAcceptInvitationArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
  password: Scalars['String'];
};


export type RootMutationTypeAddCommentArgs = {
  content: Scalars['String'];
  notifyGroups?: Scalars['Boolean'];
  threadId: Scalars['ID'];
};


export type RootMutationTypeAddGroupToGroupArgs = {
  childId: Scalars['ID'];
  parentId: Scalars['ID'];
};


export type RootMutationTypeAddGroupToPostArgs = {
  groupId: Scalars['ID'];
  postId: Scalars['ID'];
  role: PostShareRole;
};


export type RootMutationTypeAddGroupToTopicArgs = {
  groupId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypeAddReactionArgs = {
  emoji: Scalars['String'];
  threadId: Scalars['ID'];
};


export type RootMutationTypeAddTopicToPostArgs = {
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypeAddUserToGroupArgs = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeAddUserToPostArgs = {
  postId: Scalars['ID'];
  role: PostShareRole;
  userId: Scalars['ID'];
};


export type RootMutationTypeAddUserToTopicArgs = {
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeApplyProvisionArgs = {
  provisionId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type RootMutationTypeApproveInvitationArgs = {
  approve: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type RootMutationTypeApproveMultipleInvitationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type RootMutationTypeCancelBillingArgs = {
  details?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCompleteUploadedImportArgs = {
  url: Scalars['String'];
};


export type RootMutationTypeCreateAnnotationArgs = {
  checksum: Scalars['Int'];
  content: Scalars['Json'];
  link?: InputMaybe<Scalars['String']>;
  mark: Scalars['Json'];
  postId: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeCreateCommentArgs = {
  checksum: Scalars['Int'];
  content: Scalars['String'];
  mark: Scalars['Json'];
  notifyGroups?: Scalars['Boolean'];
  postId: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeCreateCommentReactionArgs = {
  commentId: Scalars['ID'];
  emoji: Scalars['String'];
};


export type RootMutationTypeCreateCustomDomainArgs = {
  hostname: Scalars['String'];
};


export type RootMutationTypeCreateGroupArgs = {
  description?: InputMaybe<Scalars['Json']>;
  name: Scalars['String'];
  ownerId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeCreateIntegrationLinkArgs = {
  externalId: Scalars['String'];
  externalTitle: Scalars['String'];
  preview?: InputMaybe<Scalars['Upload']>;
  title?: InputMaybe<Scalars['String']>;
  topicId: Scalars['ID'];
  type: MentionType;
};


export type RootMutationTypeCreatePostArgs = {
  libraryName?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topicId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<PostType>;
};


export type RootMutationTypeCreateProvisionArgs = {
  favoritePostIds: Array<Scalars['ID']>;
  favoriteTopicIds: Array<Scalars['ID']>;
  groupIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  postIds: Array<Scalars['ID']>;
  topicIds: Array<Scalars['ID']>;
  type: ProvisionType;
  urlEnabled: Scalars['Boolean'];
};


export type RootMutationTypeCreateReactionArgs = {
  checksum: Scalars['Int'];
  emoji: Scalars['String'];
  mark: Scalars['Json'];
  postId: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeCreateSamlIntegrationArgs = {
  idpMetadata: Scalars['String'];
  platform: Scalars['String'];
};


export type RootMutationTypeCreateSeriesArgs = {
  name: Scalars['String'];
  postIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type RootMutationTypeCreateStaticTokenIntegrationArgs = {
  extra?: InputMaybe<IntegrationExtraInput>;
  platform: Scalars['String'];
  token: Scalars['String'];
};


export type RootMutationTypeCreateSuggestionArgs = {
  checksum: Scalars['Int'];
  content: Scalars['Json'];
  mark: Scalars['Json'];
  postId: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeCreateTopicArgs = {
  description?: InputMaybe<Scalars['Json']>;
  inheritParent?: InputMaybe<Scalars['Boolean']>;
  memberEditable?: InputMaybe<TopicMemberEditable>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<TopicPrivacy>;
};


export type RootMutationTypeCreateVerificationArgs = {
  message?: InputMaybe<Scalars['String']>;
  postId: Scalars['ID'];
  primaryVerifierId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  secondaryVerifierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  unit: VerificationUnit;
};


export type RootMutationTypeCreateVisitorArgs = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateWebhookArgs = {
  enableAllPosts?: InputMaybe<Scalars['Boolean']>;
  events: Array<WebhookEvent>;
  name: Scalars['String'];
  status?: InputMaybe<WebhookStatus>;
  targetUrl: Scalars['String'];
  topics?: InputMaybe<Array<Scalars['ID']>>;
};


export type RootMutationTypeDeactivateUserArgs = {
  id: Scalars['ID'];
  newOwnerId: Scalars['ID'];
};


export type RootMutationTypeDeleteAnnotationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCommentArgs = {
  commentId: Scalars['ID'];
};


export type RootMutationTypeDeleteCommentReactionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCustomDomainArgs = {
  hostname: Scalars['ID'];
};


export type RootMutationTypeDeleteGroupArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteIntegrationArgs = {
  platform: Scalars['String'];
};


export type RootMutationTypeDeleteIntegrationLinkArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteInvitationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeletePostArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteProvisionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteReactionArgs = {
  reactionId: Scalars['ID'];
};


export type RootMutationTypeDeleteSeriesArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteThreadArgs = {
  threadId: Scalars['ID'];
};


export type RootMutationTypeDeleteTopicArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteVerificationArgs = {
  verificationId: Scalars['ID'];
};


export type RootMutationTypeDeleteWebhookArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDuplicatePostArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeExportAllArgs = {
  format: ExportFormat;
  privacy: ExportPrivacy;
};


export type RootMutationTypeFavoritePostArgs = {
  add?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type RootMutationTypeFavoriteTopicArgs = {
  add?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type RootMutationTypeGenerateImportUploadUrlArgs = {
  extension: ImportExtension;
  source?: InputMaybe<ImportSource>;
};


export type RootMutationTypeImportExternalArgs = {
  externalId: Scalars['String'];
  platform: Scalars['String'];
};


export type RootMutationTypeImportFilesArgs = {
  files: Array<InputMaybe<Scalars['Upload']>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<ImportSource>;
  topicId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeImportGithubWikisArgs = {
  repos?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootMutationTypeInviteArgs = {
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provisionChanges?: InputMaybe<ProvisionChangesInput>;
  provisionId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<InvitationSource>;
};


export type RootMutationTypeMagicLoginArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeMarkNotificationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status: NotificationReadStatus;
};


export type RootMutationTypePasswordLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootMutationTypePinPostArgs = {
  pinnedOrder: Scalars['Int'];
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypePostMentionArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeReactivateUserArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeReadPostArgs = {
  id: Scalars['ID'];
  queryId?: InputMaybe<Scalars['String']>;
  resultId?: InputMaybe<Scalars['String']>;
  time: Scalars['Int'];
};


export type RootMutationTypeRegenerateProvisionSecretArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRegenerateScimTokenArgs = {
  platform: Scalars['String'];
};


export type RootMutationTypeRegenerateUserApiTokenArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRegenerateWebhookSecretArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRegisterArgs = {
  adminEmail: Scalars['String'];
  adminName: Scalars['String'];
  adminPassword?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  referral?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeRegisterWithProvisionArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  provisionId: Scalars['String'];
  provisionSecret: Scalars['String'];
};


export type RootMutationTypeRemoveExternalSearchArgs = {
  platform: Scalars['String'];
};


export type RootMutationTypeRemoveGroupFromGroupArgs = {
  childId: Scalars['ID'];
  parentId: Scalars['ID'];
};


export type RootMutationTypeRemoveGroupFromPostArgs = {
  groupId: Scalars['ID'];
  postId: Scalars['ID'];
};


export type RootMutationTypeRemoveGroupFromTopicArgs = {
  groupId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypeRemoveTopicFromPostArgs = {
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypeRemoveUserFromGroupArgs = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeRemoveUserFromPostArgs = {
  postId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeRemoveUserFromTopicArgs = {
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeReorderTopicsArgs = {
  parentId?: InputMaybe<Scalars['ID']>;
  topicIds: Array<Scalars['ID']>;
};


export type RootMutationTypeReorganizeArgs = {
  operations: Array<ReorganizeOperation>;
};


export type RootMutationTypeRequestGroupAccessArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRequestGroupCreationArgs = {
  name: Scalars['String'];
};


export type RootMutationTypeRequestPasswordTokenArgs = {
  email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeRequestPostAccessArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRequestTopicAccessArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeRequestVerificationArgs = {
  message?: InputMaybe<Scalars['String']>;
  postId: Scalars['ID'];
  quantity: Scalars['Int'];
  unit: VerificationUnit;
};


export type RootMutationTypeResendInvitationArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeResetPasswordArgs = {
  id: Scalars['ID'];
  password: Scalars['String'];
};


export type RootMutationTypeResolveThreadArgs = {
  resolveAt?: InputMaybe<Scalars['Datetime']>;
  status?: InputMaybe<ThreadResolveStatus>;
  threadId: Scalars['ID'];
};


export type RootMutationTypeSetDefaultCustomDomainArgs = {
  hostname: Scalars['ID'];
};


export type RootMutationTypeStartTrialArgs = {
  planTier: StartTrialTierInput;
};


export type RootMutationTypeThankPostArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeTrackArgs = {
  event: AnalyticsEvent;
  properties: TrackProperties;
};


export type RootMutationTypeTransferPostOwnershipArgs = {
  newOwnerId: Scalars['ID'];
  ownerId: Scalars['ID'];
};


export type RootMutationTypeUnpinPostArgs = {
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
};


export type RootMutationTypeUnresolveThreadArgs = {
  threadId: Scalars['ID'];
};


export type RootMutationTypeUnthankPostArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeUpdateAnnotationArgs = {
  content?: InputMaybe<Scalars['Json']>;
  id: Scalars['ID'];
  link?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateBillingArgs = {
  coupon?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  planInterval?: InputMaybe<PlanInterval>;
  planTier?: InputMaybe<PlanTier>;
  source?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateCommentArgs = {
  commentId: Scalars['ID'];
  content: Scalars['String'];
};


export type RootMutationTypeUpdateGroupArgs = {
  banner?: InputMaybe<Scalars['Upload']>;
  bannerUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Json']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  unsplashId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateGroupInPostArgs = {
  groupId: Scalars['ID'];
  postId: Scalars['ID'];
  role: PostShareRole;
};


export type RootMutationTypeUpdateGroupInTopicArgs = {
  groupId: Scalars['ID'];
  oldRole: TopicGroupRole;
  role: TopicGroupRole;
  topicId: Scalars['ID'];
};


export type RootMutationTypeUpdateIntegrationArgs = {
  platform: Scalars['String'];
  settings: IntegrationSettingsInput;
};


export type RootMutationTypeUpdateIntegrationLinkArgs = {
  externalTitle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  preview?: InputMaybe<Scalars['Upload']>;
  title?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateOnboardingArgs = {
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  step: Scalars['Int'];
  subject: Scalars['String'];
};


export type RootMutationTypeUpdateOrganizationArgs = {
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<OrganizationSettingsInput>;
  ssoProvisionId?: InputMaybe<Scalars['ID']>;
  subdomain?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['Json']>;
};


export type RootMutationTypeUpdatePasswordArgs = {
  oldPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};


export type RootMutationTypeUpdatePostArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  banner?: InputMaybe<Scalars['Upload']>;
  bannerUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  linkAccess?: InputMaybe<PostLinkAccess>;
  ownerId?: InputMaybe<Scalars['ID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PostType>;
  unsplashId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdatePostContentArgs = {
  checksum: Scalars['Int'];
  delta: Scalars['Json'];
  id: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeUpdateProvisionArgs = {
  favoritePostIds?: InputMaybe<Array<Scalars['ID']>>;
  favoriteTopicIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['ID']>>;
  topicIds?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<ProvisionType>;
  urlEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateSeriesArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type RootMutationTypeUpdateSuggestionArgs = {
  content: Scalars['Json'];
  mark: Scalars['Json'];
  threadId: Scalars['ID'];
  version: Scalars['Int'];
};


export type RootMutationTypeUpdateTopicArgs = {
  banner?: InputMaybe<Scalars['Upload']>;
  bannerUrl?: InputMaybe<Scalars['String']>;
  defaultShow?: InputMaybe<TopicPostsType>;
  defaultSort?: InputMaybe<TopicPostsOrder>;
  description?: InputMaybe<Scalars['Json']>;
  id: Scalars['ID'];
  inheritParent?: InputMaybe<Scalars['Boolean']>;
  memberEditable?: InputMaybe<TopicMemberEditable>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<TopicPrivacy>;
  propagateDefaultShow?: InputMaybe<Scalars['Boolean']>;
  propagateDefaultSort?: InputMaybe<Scalars['Boolean']>;
  propagatePrivacy?: InputMaybe<Scalars['Boolean']>;
  unsplashId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateUserArgs = {
  avatar?: InputMaybe<Scalars['Upload']>;
  description?: InputMaybe<Scalars['Json']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
};


export type RootMutationTypeUpdateUserInGroupArgs = {
  groupId: Scalars['ID'];
  role: GroupUserRole;
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateUserInPostArgs = {
  postId: Scalars['ID'];
  role: PostShareRole;
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateUserInTopicArgs = {
  oldRole: TopicUserRole;
  role: TopicUserRole;
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateUserSettingsArgs = {
  aiAutofix?: InputMaybe<Scalars['Boolean']>;
  aiPredict?: InputMaybe<Scalars['Boolean']>;
  allowAccountAccess?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<UserSettingsNotificationsInput>;
  sidebar?: InputMaybe<UserSettingsSidebarInput>;
  uiTheme?: InputMaybe<UiThemeSetting>;
};


export type RootMutationTypeUpdateVerificationArgs = {
  primaryVerifierId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  secondaryVerifierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  unit?: InputMaybe<VerificationUnit>;
  verificationId: Scalars['ID'];
};


export type RootMutationTypeUpdateVisitorArgs = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateWebhookArgs = {
  enableAllPosts?: InputMaybe<Scalars['Boolean']>;
  events?: InputMaybe<Array<WebhookEvent>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<WebhookStatus>;
  targetUrl?: InputMaybe<Scalars['String']>;
  topics?: InputMaybe<Array<Scalars['ID']>>;
};


export type RootMutationTypeUploadPostAttachmentArgs = {
  file: Scalars['Upload'];
};


export type RootMutationTypeUploadPostImageArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  url?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeVerifyCustomDomainArgs = {
  hostname: Scalars['ID'];
};


export type RootMutationTypeVerifyPostArgs = {
  verificationId: Scalars['ID'];
};


export type RootMutationTypeVerifyReferralArgs = {
  referral: Scalars['String'];
};

export type RootPostFields = {
  id: Scalars['ID'];
  linkAccess: PostLinkAccess;
  series?: Maybe<ObjectWithId>;
  title: Scalars['String'];
  topics: Array<ObjectWithId>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  activities?: Maybe<ActivityConnection>;
  billingCoupon: BillingCoupon;
  billingPricing: BillingPricing;
  billingSummary: BillingSummary;
  convert: Scalars['String'];
  currentSession: Session;
  currentVersion: Version;
  currentVisitorSession: VisitorSession;
  debugAskSearch?: Maybe<DebugAskSearchResult>;
  externalPost: Post;
  externalPostPlatform: ExternalPostPlatform;
  externalPostPlatforms: Array<ExternalPostPlatform>;
  externalSearch: Array<Mention>;
  externalSearchPlatforms: Array<ExternalSearchPlatform>;
  externalSearchPreview?: Maybe<MentionPreview>;
  externalSearchSources: Array<ExternalSearchSource>;
  gitRepos: Array<GitRepo>;
  group: Group;
  insightLeaderboard?: Maybe<InsightUserConnection>;
  insightMetrics: InsightMetrics;
  insightSearchMetrics: InsightMetrics;
  insightTopPosts?: Maybe<PostMetricsConnection>;
  insightTopSearches?: Maybe<InsightSearchConnection>;
  integration?: Maybe<Integration>;
  integrationLink?: Maybe<IntegrationLink>;
  invitation?: Maybe<PublicInvitation>;
  mention: Mention;
  mentionParents: Array<MentionTag>;
  organization: PublicOrganization;
  organizations: Array<PublicOrganization>;
  passwordToken?: Maybe<Scalars['Boolean']>;
  post: Post;
  publicGroup: PublicGroup;
  publicPost: PublicPost;
  publicSearch?: Maybe<PublicSearchResultConnection>;
  publicTopic: PublicTopic;
  publicUser: PublicUser;
  search?: Maybe<SearchResultConnection>;
  series: Series;
  slackUser?: Maybe<SlackUser>;
  topic: Topic;
  unorganized?: Maybe<PostEdgesConnection>;
  unorganizedCount: Scalars['Int'];
  user: User;
  verifyProvisionUrl: PublicProvision;
  webhook?: Maybe<Webhook>;
};


export type RootQueryTypeActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeBillingCouponArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeConvertArgs = {
  delta: Scalars['String'];
};


export type RootQueryTypeCurrentSessionArgs = {
  setActive?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeDebugAskSearchArgs = {
  orgId?: InputMaybe<Scalars['ID']>;
  query: Scalars['String'];
  reset?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeExternalPostArgs = {
  externalId: Scalars['ID'];
  platform: Scalars['String'];
};


export type RootQueryTypeExternalPostPlatformArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeExternalSearchArgs = {
  platform: Scalars['String'];
  query: Scalars['String'];
};


export type RootQueryTypeExternalSearchPlatformsArgs = {
  redirectPath: Scalars['String'];
};


export type RootQueryTypeExternalSearchPreviewArgs = {
  externalId: Scalars['String'];
  platform: Scalars['String'];
};


export type RootQueryTypeExternalSearchSourcesArgs = {
  platform: Scalars['String'];
};


export type RootQueryTypeGitReposArgs = {
  platform: GitRepoPlatform;
};


export type RootQueryTypeGroupArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeInsightLeaderboardArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
  type: InsightLeaderboardType;
};


export type RootQueryTypeInsightMetricsArgs = {
  endDate: Scalars['Date'];
  groupId?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
  type: InsightMetricsType;
};


export type RootQueryTypeInsightSearchMetricsArgs = {
  endDate: Scalars['Date'];
  groupId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Date'];
  type: InsightSearchMetricsType;
};


export type RootQueryTypeInsightTopPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy: InsightTopPostsOrder;
  startDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeInsightTopSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<InsightTopSearchesOrder>;
  startDate: Scalars['Date'];
  type: InsightTopSearchesType;
};


export type RootQueryTypeIntegrationArgs = {
  platform: Scalars['String'];
};


export type RootQueryTypeIntegrationLinkArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeInvitationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeMentionArgs = {
  id: Scalars['ID'];
  type: MentionType;
};


export type RootQueryTypeMentionParentsArgs = {
  type: MentionType;
};


export type RootQueryTypeOrganizationArgs = {
  host: Scalars['String'];
};


export type RootQueryTypeOrganizationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type RootQueryTypePasswordTokenArgs = {
  id: Scalars['ID'];
  type: Scalars['String'];
};


export type RootQueryTypePostArgs = {
  id: Scalars['ID'];
  position?: InputMaybe<Scalars['Int']>;
  queryId?: InputMaybe<Scalars['String']>;
  resultId?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypePublicGroupArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePublicPostArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePublicSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootQueryTypePublicTopicArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypePublicUserArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  ancestorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  byIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contributorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  isStates?: InputMaybe<Array<InputMaybe<SearchIsState>>>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  mentionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  ownerId?: InputMaybe<Scalars['ID']>;
  query: Scalars['String'];
  timestamp?: InputMaybe<TimestampFilter>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RootQueryTypeSeriesArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeSlackUserArgs = {
  slabId: Scalars['ID'];
};


export type RootQueryTypeTopicArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUnorganizedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UnorganizedPostsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UnorganizedPostsOrder>;
};


export type RootQueryTypeUnorganizedCountArgs = {
  filter?: InputMaybe<UnorganizedPostsFilter>;
};


export type RootQueryTypeUserArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeVerifyProvisionUrlArgs = {
  id: Scalars['String'];
  secret: Scalars['String'];
};


export type RootQueryTypeWebhookArgs = {
  id: Scalars['ID'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  annotationCreated?: Maybe<PublicAnnotationFields>;
  annotationDeleted?: Maybe<PublicAnnotationFields>;
  annotationUpdated?: Maybe<PublicAnnotationFields>;
  commentDeleted?: Maybe<PublicCommentFields>;
  commentReactionCreated?: Maybe<PublicCommentReactionFields>;
  commentReactionDeleted?: Maybe<PublicCommentReactionFields>;
  commentUpdated?: Maybe<PublicCommentFields>;
  groupCreated?: Maybe<Group>;
  groupDeleted?: Maybe<Group>;
  groupGroupAdded?: Maybe<GroupGroupSubscription>;
  groupGroupRemoved?: Maybe<GroupGroupSubscription>;
  groupUpdated?: Maybe<Group>;
  groupUserAdded?: Maybe<GroupUserSubscription>;
  groupUserRemoved?: Maybe<GroupUserSubscription>;
  notificationCreated: Notification;
  notificationsUpdated: Array<Notification>;
  postDeleted?: Maybe<Post>;
  postFavoriteAdded?: Maybe<Post>;
  postFavoriteRemoved?: Maybe<Post>;
  postGroupAdded?: Maybe<PostGroupShareSubscription>;
  postGroupRemoved?: Maybe<PostGroupShareSubscription>;
  postGroupUpdated?: Maybe<PostGroupShareSubscription>;
  postTopicAdded?: Maybe<Topic>;
  postTopicRemoved?: Maybe<Topic>;
  postUpdated?: Maybe<Post>;
  postUserAdded?: Maybe<PostShareSubscription>;
  postUserRemoved?: Maybe<PostShareSubscription>;
  postUserUpdated?: Maybe<PostShareSubscription>;
  reactionDeleted?: Maybe<PublicReactionFields>;
  seriesCreated?: Maybe<Series>;
  seriesDeleted?: Maybe<Series>;
  seriesUpdated?: Maybe<Series>;
  sessionLogout?: Maybe<Scalars['Boolean']>;
  threadCreated?: Maybe<PublicThreadFields>;
  threadDeleted?: Maybe<PublicThreadFields>;
  threadReacted?: Maybe<PublicReactionFields>;
  threadReplied?: Maybe<PublicCommentFields>;
  threadResolved?: Maybe<PublicThreadFields>;
  threadUnresolved?: Maybe<PublicThreadFields>;
  topicCreated?: Maybe<Topic>;
  topicDeleted?: Maybe<Topic>;
  topicFavoriteAdded?: Maybe<Topic>;
  topicFavoriteRemoved?: Maybe<Topic>;
  topicUpdated?: Maybe<Topic>;
  userCreated?: Maybe<User>;
  userUpdated?: Maybe<User>;
};


export type RootSubscriptionTypeAnnotationCreatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeAnnotationDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeAnnotationUpdatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentReactionCreatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentReactionDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeCommentUpdatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostGroupAddedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostGroupRemovedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostGroupUpdatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostTopicAddedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostTopicRemovedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostUpdatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostUserAddedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostUserRemovedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypePostUserUpdatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeReactionDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadCreatedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadDeletedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadReactedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadRepliedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadResolvedArgs = {
  postId: Scalars['ID'];
};


export type RootSubscriptionTypeThreadUnresolvedArgs = {
  postId: Scalars['ID'];
};

export enum SearchIsState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Public = 'PUBLIC',
  Published = 'PUBLISHED',
  Template = 'TEMPLATE',
  Verified = 'VERIFIED'
}

export type SearchResult = CommentSearchResult | GroupSearchResult | PostSearchResult | TopicSearchResult | UserSearchResult;

export type SearchResultConnection = {
  __typename?: 'SearchResultConnection';
  edges?: Maybe<Array<Maybe<SearchResultEdge>>>;
  pageInfo: PageInfo;
  queryId?: Maybe<Scalars['String']>;
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SearchResult>;
};

export type Series = ObjectWithId & PublicSeriesFields & {
  __typename?: 'Series';
  id: Scalars['ID'];
  name: Scalars['String'];
  posts: Array<Post>;
};

export type Session = SessionFields & {
  __typename?: 'Session';
  authToken: Scalars['ID'];
  intercomHash: Scalars['String'];
  organization: Organization;
  user: User;
};

export type SessionFields = {
  authToken: Scalars['ID'];
  intercomHash: Scalars['String'];
  organization: PublicOrganizationFields;
  user: PublicUserFields;
};

export enum SidebarItem {
  AllTopics = 'ALL_TOPICS',
  Apps = 'APPS',
  ContentMap = 'CONTENT_MAP',
  Groups = 'GROUPS',
  Insights = 'INSIGHTS',
  MyTopics = 'MY_TOPICS',
  Templates = 'TEMPLATES'
}

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['ID'];
  isGeneral: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SlackMessage = {
  __typename?: 'SlackMessage';
  delta?: Maybe<Scalars['Json']>;
  text?: Maybe<Scalars['String']>;
  ts?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<SlackUser>;
};

export type SlackUser = {
  __typename?: 'SlackUser';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  profile?: Maybe<SlackUserProfile>;
};

export type SlackUserProfile = {
  __typename?: 'SlackUserProfile';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type SlimExternalPost = SlimExternalPostFields & {
  __typename?: 'SlimExternalPost';
  id: Scalars['String'];
  platform: Scalars['String'];
};

export type SlimExternalPostFields = {
  id: Scalars['String'];
  platform: Scalars['String'];
};

export type SlimHistory = SlimHistoryFields & {
  __typename?: 'SlimHistory';
  authors: Array<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
};

export type SlimHistoryFields = {
  authors: Array<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
};

export type SlimPost = RootPostFields & SlimPostFields & {
  __typename?: 'SlimPost';
  archivedAt?: Maybe<Scalars['Datetime']>;
  contributors: Array<SlimUser>;
  externalPost?: Maybe<SlimExternalPost>;
  id: Scalars['ID'];
  linkAccess: PostLinkAccess;
  owner?: Maybe<SlimUser>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  series?: Maybe<SlimSeries>;
  title: Scalars['String'];
  topics: Array<SlimTopic>;
  type: PostType;
  updatedAt: Scalars['Datetime'];
  userViewedAt?: Maybe<Scalars['Datetime']>;
  verifiedAt?: Maybe<Scalars['Datetime']>;
  views: Scalars['Int'];
};

export type SlimPostFields = {
  archivedAt?: Maybe<Scalars['Datetime']>;
  contributors: Array<ObjectWithId>;
  externalPost?: Maybe<SlimExternalPostFields>;
  id: Scalars['ID'];
  linkAccess: PostLinkAccess;
  owner?: Maybe<ObjectWithId>;
  publishedAt?: Maybe<Scalars['Datetime']>;
  series?: Maybe<ObjectWithId>;
  title: Scalars['String'];
  topics: Array<ObjectWithId>;
  type: PostType;
  updatedAt: Scalars['Datetime'];
  userViewedAt?: Maybe<Scalars['Datetime']>;
  verifiedAt?: Maybe<Scalars['Datetime']>;
  views: Scalars['Int'];
};

export type SlimSeries = ObjectWithId & {
  __typename?: 'SlimSeries';
  id: Scalars['ID'];
};

export type SlimTopic = ObjectWithId & {
  __typename?: 'SlimTopic';
  id: Scalars['ID'];
};

export type SlimUser = ObjectWithId & {
  __typename?: 'SlimUser';
  id: Scalars['ID'];
};

export enum StartTrialTierInput {
  Business = 'BUSINESS',
  Startup = 'STARTUP'
}

export type SyncingRepo = {
  __typename?: 'SyncingRepo';
  name: Scalars['String'];
  topicId?: Maybe<Scalars['ID']>;
};

export type SyncingRepoInput = {
  name: Scalars['String'];
  topicId?: InputMaybe<Scalars['ID']>;
};

export type ThankedPostActivity = Activity & {
  __typename?: 'ThankedPostActivity';
  actedAt?: Maybe<Scalars['Datetime']>;
  actor?: Maybe<User>;
  thankedPost?: Maybe<Post>;
};

export type Thread = PublicThreadFields & {
  __typename?: 'Thread';
  author?: Maybe<User>;
  autoresolveAt?: Maybe<Scalars['Datetime']>;
  comments: Array<Comment>;
  content?: Maybe<Scalars['Json']>;
  context?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  post: Post;
  reactions: Array<Reaction>;
  resolveStatus?: Maybe<ThreadResolveStatus>;
  resolvedAt?: Maybe<Scalars['Datetime']>;
  resolver?: Maybe<User>;
  type?: Maybe<ThreadType>;
};

export enum ThreadResolveStatus {
  Accept = 'ACCEPT',
  Auto = 'AUTO',
  Reject = 'REJECT'
}

export enum ThreadType {
  Comment = 'COMMENT',
  Reaction = 'REACTION',
  Suggestion = 'SUGGESTION'
}

export type TimestampFilter = {
  archivedAfter?: InputMaybe<Scalars['Datetime']>;
  archivedBefore?: InputMaybe<Scalars['Datetime']>;
  editedAfter?: InputMaybe<Scalars['Datetime']>;
  editedBefore?: InputMaybe<Scalars['Datetime']>;
  publishedAfter?: InputMaybe<Scalars['Datetime']>;
  publishedBefore?: InputMaybe<Scalars['Datetime']>;
  verifiedAfter?: InputMaybe<Scalars['Datetime']>;
  verifiedBefore?: InputMaybe<Scalars['Datetime']>;
};

export type Topic = ObjectWithId & PublicTopicFields & {
  __typename?: 'Topic';
  activities?: Maybe<ActivityConnection>;
  allPosts?: Maybe<TopicPostConnection>;
  ancestors: Array<Topic>;
  banner?: Maybe<Image>;
  children: Array<Topic>;
  contributors: Array<User>;
  defaultShow?: Maybe<TopicPostsType>;
  defaultSort?: Maybe<TopicPostsOrder>;
  descendants?: Maybe<TopicDescendantConnection>;
  description: Scalars['Json'];
  hierarchy?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  inheritParent: Scalars['Boolean'];
  inheritedAncestors: Array<Topic>;
  integrationLinks: Array<IntegrationLink>;
  memberEditable: TopicMemberEditable;
  memberGroups: Array<Group>;
  members: Array<User>;
  membership: TopicMembership;
  name: Scalars['String'];
  order: Scalars['Int'];
  ownerGroups: Array<Group>;
  owners: Array<User>;
  parent?: Maybe<Topic>;
  postCounts: Array<TopicPostCount>;
  posts?: Maybe<TopicPostConnection>;
  privacy: TopicPrivacy;
  propagateDefaultShow: Scalars['Boolean'];
  propagateDefaultSort: Scalars['Boolean'];
  reads: Scalars['Int'];
  requestors: Array<User>;
  score?: Maybe<Scalars['Float']>;
  templateCount: Scalars['Int'];
  views: Scalars['Int'];
};


export type TopicActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TopicAllPostsArgs = {
  orderBy: TopicPostsOrder;
  type?: InputMaybe<TopicPostsType>;
};


export type TopicDescendantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TopicPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TopicPostsOrder>;
  type?: InputMaybe<TopicPostsType>;
};

export type TopicDescendantConnection = {
  __typename?: 'TopicDescendantConnection';
  edges?: Maybe<Array<Maybe<TopicDescendantEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TopicDescendantEdge = {
  __typename?: 'TopicDescendantEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Topic>;
};

export enum TopicGroupRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum TopicMemberEditable {
  All = 'ALL',
  None = 'NONE',
  Post = 'POST'
}

export type TopicMembership = {
  __typename?: 'TopicMembership';
  memberGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  memberUserIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ownerGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ownerUserIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  requestorUserIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type TopicPostConnection = {
  __typename?: 'TopicPostConnection';
  edges?: Maybe<Array<Maybe<TopicPostEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TopicPostCount = {
  __typename?: 'TopicPostCount';
  count?: Maybe<Scalars['Int']>;
  type?: Maybe<TopicPostsType>;
};

export type TopicPostEdge = {
  __typename?: 'TopicPostEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Post>;
  pinnedOrder?: Maybe<Scalars['Int']>;
};

export enum TopicPostsOrder {
  Popularity = 'POPULARITY',
  PublishedAt = 'PUBLISHED_AT',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT',
  ViewedAt = 'VIEWED_AT'
}

export enum TopicPostsType {
  All = 'ALL',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Template = 'TEMPLATE',
  Verified = 'VERIFIED'
}

export enum TopicPrivacy {
  Open = 'OPEN',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Secret = 'SECRET'
}

export type TopicSearchResult = {
  __typename?: 'TopicSearchResult';
  ancestors: Array<AncestorSearchResult>;
  description?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  topic: Topic;
};

export enum TopicUserRole {
  Member = 'MEMBER',
  Owner = 'OWNER',
  Requestor = 'REQUESTOR'
}

export type TrackProperties = {
  detail?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export enum UiThemeSetting {
  Auto = 'AUTO',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum UnorganizedPostsFilter {
  All = 'ALL',
  Archived = 'ARCHIVED',
  Published = 'PUBLISHED',
  Template = 'TEMPLATE',
  Verified = 'VERIFIED'
}

export enum UnorganizedPostsOrder {
  Alphabetical = 'ALPHABETICAL',
  Popularity = 'POPULARITY',
  RecentlyPublished = 'RECENTLY_PUBLISHED',
  RecentlyUpdated = 'RECENTLY_UPDATED',
  RecentlyViewed = 'RECENTLY_VIEWED'
}

export type User = ObjectWithId & PublicUserFields & {
  __typename?: 'User';
  apiToken?: Maybe<Scalars['String']>;
  avatar?: Maybe<Image>;
  contributedTopics: Array<Topic>;
  deactivatedAt?: Maybe<Scalars['Datetime']>;
  description: Scalars['Json'];
  drafts?: Maybe<PostEdgesConnection>;
  draftsCount: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  favoritePosts: Array<Post>;
  favoriteTopics: Array<Topic>;
  googleDrivePickerAccessToken: ExternalAccessToken;
  id: Scalars['ID'];
  identities: Array<Identity>;
  importedFrom?: Maybe<Scalars['String']>;
  insertedAt?: Maybe<Scalars['Datetime']>;
  membershipGroups: Array<Group>;
  membershipTopics: Array<Topic>;
  name: Scalars['String'];
  onboardings: Array<Onboarding>;
  passwordUpdatedAt?: Maybe<Scalars['Datetime']>;
  posts?: Maybe<PostEdgesConnection>;
  postsCount: Scalars['Int'];
  reads?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Float']>;
  settings?: Maybe<UserSettings>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  viewedPosts?: Maybe<PostConnection>;
  views?: Maybe<Scalars['Int']>;
};


export type UserDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DraftsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DraftsOrder>;
};


export type UserDraftsCountArgs = {
  filter?: InputMaybe<DraftsFilter>;
};


export type UserGoogleDrivePickerAccessTokenArgs = {
  redirectPath?: InputMaybe<Scalars['String']>;
};


export type UserMembershipTopicsArgs = {
  includeGroups?: InputMaybe<Scalars['Boolean']>;
};


export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserPostsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserPostsOrder>;
};


export type UserPostsCountArgs = {
  filter?: InputMaybe<UserPostsFilter>;
};


export type UserViewedPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserNotificationPlatforms = {
  __typename?: 'UserNotificationPlatforms';
  email?: Maybe<Scalars['Boolean']>;
  slack?: Maybe<Scalars['Boolean']>;
  teams?: Maybe<Scalars['Boolean']>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  direct?: Maybe<UserNotificationPlatforms>;
  participant?: Maybe<UserNotificationPlatforms>;
  team?: Maybe<UserNotificationPlatforms>;
};

export enum UserPostsFilter {
  All = 'ALL',
  Contributed = 'CONTRIBUTED',
  Published = 'PUBLISHED',
  Template = 'TEMPLATE',
  Verified = 'VERIFIED'
}

export enum UserPostsOrder {
  Alphabetical = 'ALPHABETICAL',
  Popularity = 'POPULARITY',
  RecentlyPublished = 'RECENTLY_PUBLISHED',
  RecentlyUpdated = 'RECENTLY_UPDATED'
}

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  description?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user: User;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  aiAutofix?: Maybe<Scalars['Boolean']>;
  aiPredict?: Maybe<Scalars['Boolean']>;
  allowAccountAccess?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<UserNotificationSettings>;
  sidebar?: Maybe<UserSidebarSettings>;
  uiTheme?: Maybe<UiThemeSetting>;
};

export type UserSettingsNotificationMethodInput = {
  email?: InputMaybe<Scalars['Boolean']>;
  slack?: InputMaybe<Scalars['Boolean']>;
  teams?: InputMaybe<Scalars['Boolean']>;
};

export type UserSettingsNotificationsInput = {
  direct?: InputMaybe<UserSettingsNotificationMethodInput>;
  participant?: InputMaybe<UserSettingsNotificationMethodInput>;
  team?: InputMaybe<UserSettingsNotificationMethodInput>;
};

export type UserSettingsSidebarInput = {
  favoriteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  hiddenItems?: InputMaybe<Array<InputMaybe<SidebarItem>>>;
  myTopicIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserSidebarSettings = {
  __typename?: 'UserSidebarSettings';
  favoriteIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hiddenItems?: Maybe<Array<Maybe<SidebarItem>>>;
  myTopicIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum UserType {
  Admin = 'ADMIN',
  Bot = 'BOT',
  Guest = 'GUEST',
  User = 'USER',
  Visitor = 'VISITOR'
}

export type Verification = {
  __typename?: 'Verification';
  id: Scalars['ID'];
  insertedAt: Scalars['Datetime'];
  post: Post;
  primaryVerifier: User;
  quantity: Scalars['Int'];
  secondaryVerifiers: Array<Maybe<User>>;
  unit: VerificationUnit;
};

export type VerificationEntry = {
  __typename?: 'VerificationEntry';
  expiredAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['ID'];
  post: Post;
  verifiedAt: Scalars['Datetime'];
  verifier: User;
  version: Scalars['Int'];
};

export enum VerificationUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Version = {
  __typename?: 'Version';
  version: Scalars['String'];
};

export type VisitorSession = SessionFields & {
  __typename?: 'VisitorSession';
  authToken: Scalars['ID'];
  intercomHash: Scalars['String'];
  organization: PublicOrganization;
  user: PublicUser;
};

export type VisitorUser = ObjectWithId & PublicUserFields & {
  __typename?: 'VisitorUser';
  avatar?: Maybe<Image>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Webhook = {
  __typename?: 'Webhook';
  enableAllPosts?: Maybe<Scalars['Boolean']>;
  events?: Maybe<Array<Maybe<WebhookEvent>>>;
  id?: Maybe<Scalars['ID']>;
  insertedAt?: Maybe<Scalars['Datetime']>;
  logs?: Maybe<WebhookLogConnection>;
  name?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  status?: Maybe<WebhookStatus>;
  targetUrl?: Maybe<Scalars['String']>;
  topics?: Maybe<Array<Maybe<Topic>>>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type WebhookLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum WebhookEvent {
  PostEdit = 'POST_EDIT',
  PostPublish = 'POST_PUBLISH',
  PostUpdate = 'POST_UPDATE'
}

export type WebhookLog = {
  __typename?: 'WebhookLog';
  event?: Maybe<WebhookEvent>;
  id?: Maybe<Scalars['ID']>;
  insertedAt?: Maybe<Scalars['Datetime']>;
  payload?: Maybe<Scalars['Json']>;
  response?: Maybe<WebhookResponse>;
  retryCount?: Maybe<Scalars['Int']>;
  targetUrl?: Maybe<Scalars['String']>;
};

export type WebhookLogConnection = {
  __typename?: 'WebhookLogConnection';
  edges?: Maybe<Array<Maybe<WebhookLogEdge>>>;
  pageInfo: PageInfo;
};

export type WebhookLogEdge = {
  __typename?: 'WebhookLogEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<WebhookLog>;
};

export type WebhookResponse = {
  __typename?: 'WebhookResponse';
  body?: Maybe<Scalars['String']>;
  headers?: Maybe<Scalars['Json']>;
  status?: Maybe<Scalars['Int']>;
};

export enum WebhookStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Errored = 'ERRORED'
}

export type InvitationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvitationQuery = { __typename?: 'RootQueryType', invitation?: { __typename?: 'PublicInvitation', id: string, email: string, name?: string | null, acceptedAt?: any | null, type: ProvisionType, provision?: { __typename?: 'PublicProvision', id: string } | null } | null };

export type AcceptInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
  password: Scalars['String'];
  name: Scalars['String'];
}>;


export type AcceptInvitationMutation = { __typename?: 'RootMutationType', session?: { __typename?: 'Session', authToken: string } | null };

export type PasswordLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type PasswordLoginMutation = { __typename?: 'RootMutationType', session: { __typename?: 'Session', authToken: string } };

export type RegisterWithProvisionMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  provisionId: Scalars['String'];
  provisionSecret: Scalars['String'];
}>;


export type RegisterWithProvisionMutation = { __typename?: 'RootMutationType', session: { __typename?: 'Session', authToken: string } };

export type VerifyProvisionUrlQueryVariables = Exact<{
  id: Scalars['String'];
  secret: Scalars['String'];
}>;


export type VerifyProvisionUrlQuery = { __typename?: 'RootQueryType', provision: { __typename?: 'PublicProvision', id: string, type: ProvisionType } };

export type RequestPasswordTokenMutationVariables = Exact<{
  email: Scalars['String'];
  type: Scalars['String'];
}>;


export type RequestPasswordTokenMutation = { __typename?: 'RootMutationType', requestPasswordToken?: boolean | null };

export type MagicLoginMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MagicLoginMutation = { __typename?: 'RootMutationType', magicLogin: { __typename?: 'Session', authToken: string } };

export type PasswordTokenQueryVariables = Exact<{
  id: Scalars['ID'];
  type: Scalars['String'];
}>;


export type PasswordTokenQuery = { __typename?: 'RootQueryType', passwordToken?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'RootMutationType', session: { __typename?: 'Session', authToken: string } };

export type UseVisitorSession_VisitorSessionFragment = { __typename?: 'VisitorSession', authToken: string, intercomHash: string, user: { __typename?: 'PublicUser', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } };

export type VisitorSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type VisitorSessionQuery = { __typename?: 'RootQueryType', visitorSession: { __typename?: 'VisitorSession', authToken: string, intercomHash: string, user: { __typename?: 'PublicUser', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } } };

export type CreateVisitorMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateVisitorMutation = { __typename?: 'RootMutationType', createVisitor: { __typename?: 'VisitorSession', authToken: string, intercomHash: string, user: { __typename?: 'PublicUser', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } } };

type Activities_Activities_CreatedCommentActivity_Fragment = { __typename?: 'CreatedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null };

type Activities_Activities_CreatedHistoryActivity_Fragment = { __typename?: 'CreatedHistoryActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdHistory?: { __typename?: 'History', id: string, diff: any, snapshot: any, versionFrom: number, versionTo: number, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } | null };

type Activities_Activities_CreatedTopicActivity_Fragment = { __typename?: 'CreatedTopicActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null };

type Activities_Activities_FillerActivity_Fragment = { __typename?: 'FillerActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null };

type Activities_Activities_JoinedUserActivity_Fragment = { __typename?: 'JoinedUserActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, joinedUser?: { __typename?: 'User', id: string } | null };

type Activities_Activities_PublishedPostActivity_Fragment = { __typename?: 'PublishedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, publishedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null };

type Activities_Activities_RepliedCommentActivity_Fragment = { __typename?: 'RepliedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, repliedComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null };

type Activities_Activities_ThankedPostActivity_Fragment = { __typename?: 'ThankedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, thankedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, owner: { __typename?: 'User', name: string, id: string }, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null };

export type Activities_ActivitiesFragment = Activities_Activities_CreatedCommentActivity_Fragment | Activities_Activities_CreatedHistoryActivity_Fragment | Activities_Activities_CreatedTopicActivity_Fragment | Activities_Activities_FillerActivity_Fragment | Activities_Activities_JoinedUserActivity_Fragment | Activities_Activities_PublishedPostActivity_Fragment | Activities_Activities_RepliedCommentActivity_Fragment | Activities_Activities_ThankedPostActivity_Fragment;

export type Activity_ActorFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type ActivityCommentCard_CommentFragment = { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } };

export type ActivityCreatedComment_ActivityFragment = { __typename?: 'CreatedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null };

export type ActivityCreatedHistory_ActivityFragment = { __typename?: 'CreatedHistoryActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdHistory?: { __typename?: 'History', id: string, diff: any, snapshot: any, versionFrom: number, versionTo: number, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } | null };

export type ActivityJoinedUser_ActivityFragment = { __typename?: 'JoinedUserActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, joinedUser?: { __typename?: 'User', id: string } | null };

export type ActivityPostCard_PostFragment = { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null };

export type ActivityPublishedPost_ActivityFragment = { __typename?: 'PublishedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, publishedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null };

export type ActivityRepliedComment_ActivityFragment = { __typename?: 'RepliedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, repliedComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null };

export type ActivityThankedPost_ActivityFragment = { __typename?: 'ThankedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, thankedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, owner: { __typename?: 'User', name: string, id: string }, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null };

export type ActivitiesPostTopics_TopicsFragment = { __typename?: 'Topic', id: string, name: string };

export type CustomDomain_CustomDomainFragment = { __typename?: 'CustomDomain', active: boolean, hostname: string };

export type CustomDomainSettings_CustomDomainsFragment = { __typename?: 'CustomDomain', active: boolean, hostname: string };

export type CustomDomainsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDomainsSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, customDomains: Array<{ __typename?: 'CustomDomain', active: boolean, hostname: string }> } } };

export type CreateCustomDomainMutationVariables = Exact<{
  hostname: Scalars['String'];
}>;


export type CreateCustomDomainMutation = { __typename?: 'RootMutationType', customDomain: { __typename?: 'CustomDomain', active: boolean, hostname: string } };

export type DeleteCustomDomainMutationVariables = Exact<{
  hostname: Scalars['ID'];
}>;


export type DeleteCustomDomainMutation = { __typename?: 'RootMutationType', customDomain: { __typename?: 'CustomDomain', hostname: string } };

export type VerifyCustomDomainMutationVariables = Exact<{
  hostname: Scalars['ID'];
}>;


export type VerifyCustomDomainMutation = { __typename?: 'RootMutationType', customDomain: { __typename?: 'CustomDomain', active: boolean, hostname: string } };

export type SetDefaultCustomDomainMutationVariables = Exact<{
  hostname: Scalars['ID'];
}>;


export type SetDefaultCustomDomainMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, effectiveHost: string } };

export type ClearDefaultCustomDomainMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearDefaultCustomDomainMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, effectiveHost: string } };

export type UpdateOrganizationLogoMutationVariables = Exact<{
  logo?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateOrganizationLogoMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, logo?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  subdomain?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, name: string, host: string, effectiveHost: string } };

export type AuditLogContentViewQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AuditLogType> | AuditLogType>;
  user?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type AuditLogContentViewQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, auditLogs?: { __typename?: 'AuditLogConnection', edges?: Array<{ __typename?: 'AuditLogEdge', node?: { __typename?: 'AuditLog', id: string, type: AuditLogType, insertedAt: any, detail?: { __typename?: 'AuditLogDetail', approverId?: string | null, from?: string | null, groupId?: string | null, invitationId?: string | null, inviterId?: string | null, ip?: string | null, name?: string | null, platform?: string | null, postId?: string | null, privacy?: string | null, draft?: boolean | null, provisionId?: string | null, targetId?: string | null, team?: boolean | null, templateId?: string | null, title?: string | null, to?: string | null, topicId?: string | null } | null, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, provisions: Array<{ __typename?: 'Provision', id: string, name: string }> } } };

export type AuditLogRow_ProvisionsFragment = { __typename?: 'Provision', id: string, name: string };

export type AuditLogRow_AuditLogFragment = { __typename?: 'AuditLog', id: string, type: AuditLogType, insertedAt: any, detail?: { __typename?: 'AuditLogDetail', approverId?: string | null, from?: string | null, groupId?: string | null, invitationId?: string | null, inviterId?: string | null, ip?: string | null, name?: string | null, platform?: string | null, postId?: string | null, privacy?: string | null, draft?: boolean | null, provisionId?: string | null, targetId?: string | null, team?: boolean | null, templateId?: string | null, title?: string | null, to?: string | null, topicId?: string | null } | null, user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type AdminBillingNotice_BillingSummaryFragment = { __typename?: 'BillingSummary', status: BillingSummaryStatus, startAt?: any | null, trialEndAt?: any | null, periodEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, plan?: { __typename?: 'BillingSummaryPlan', tier: PlanTier } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string } | null };

export type AdminBillingView_BillingSummaryFragment = { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus, periodEndAt?: any | null, startAt?: any | null, trialEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, userCount: number, seatCount: number, plan?: { __typename?: 'BillingSummaryPlan', id: string, tier: PlanTier, interval: PlanInterval, name: string, type: PlanType } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string, balance?: number | null }, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string, brand: string, last4: string, expMonth: number, expYear: number } | null };

export type AdminBillingView_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } } };

export type GetBillingAndPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingAndPlansQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, referralCode?: string | null, planTier?: PlanTier | null, periodEndAt?: any | null, trialEndAt?: any | null, isTrialEnded?: boolean | null, isTrialEndingSoon?: boolean | null, isLocked?: boolean | null, billingStatus?: BillingSummaryStatus | null } }, billingSummary: { __typename?: 'BillingSummary', id: string, userCount: number, pendingActionUrl?: string | null, status: BillingSummaryStatus, periodEndAt?: any | null, startAt?: any | null, trialEndAt?: any | null, chargeAutomatically?: boolean | null, seatCount: number, plan?: { __typename?: 'BillingSummaryPlan', id: string, tier: PlanTier, interval: PlanInterval, name: string, type: PlanType } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string, balance?: number | null }, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string, brand: string, last4: string, expMonth: number, expYear: number } | null }, billingPricing: { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } } } };

export type StartTrialMutationVariables = Exact<{
  planTier: StartTrialTierInput;
}>;


export type StartTrialMutation = { __typename?: 'RootMutationType', billingSummary: { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus, periodEndAt?: any | null, startAt?: any | null, trialEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, userCount: number, seatCount: number, plan?: { __typename?: 'BillingSummaryPlan', id: string, tier: PlanTier, interval: PlanInterval, name: string, type: PlanType } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string, balance?: number | null }, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string, brand: string, last4: string, expMonth: number, expYear: number } | null } };

export type UpdateBillingMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  coupon?: InputMaybe<Scalars['String']>;
  planTier?: InputMaybe<PlanTier>;
  planInterval?: InputMaybe<PlanInterval>;
}>;


export type UpdateBillingMutation = { __typename?: 'RootMutationType', billingSummary: { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus, periodEndAt?: any | null, startAt?: any | null, trialEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, userCount: number, seatCount: number, plan?: { __typename?: 'BillingSummaryPlan', id: string, tier: PlanTier, interval: PlanInterval, name: string, type: PlanType } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string, balance?: number | null }, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string, brand: string, last4: string, expMonth: number, expYear: number } | null } };

export type CancelBillingMutationVariables = Exact<{
  reason?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
}>;


export type CancelBillingMutation = { __typename?: 'RootMutationType', billingSummary: { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus, periodEndAt?: any | null, startAt?: any | null, trialEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, userCount: number, seatCount: number, plan?: { __typename?: 'BillingSummaryPlan', id: string, tier: PlanTier, interval: PlanInterval, name: string, type: PlanType } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string, balance?: number | null }, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string, brand: string, last4: string, expMonth: number, expYear: number } | null } };

export type BillingCreateView_BillingSummaryFragment = { __typename?: 'BillingSummary', status: BillingSummaryStatus, startAt?: any | null, trialEndAt?: any | null, periodEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, plan?: { __typename?: 'BillingSummaryPlan', tier: PlanTier, interval: PlanInterval } | null, customer: { __typename?: 'BillingSummaryCustomer', id: string, email: string }, coupon?: { __typename?: 'BillingCoupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, source?: { __typename?: 'BillingSummarySource', id: string } | null };

export type BillingCreateView_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } } };

export type BillingStatusView_BillingSummaryFragment = { __typename?: 'BillingSummary', periodEndAt?: any | null, id: string, status: BillingSummaryStatus, startAt?: any | null, trialEndAt?: any | null, pendingActionUrl?: string | null, chargeAutomatically?: boolean | null, userCount: number, seatCount: number, coupon?: { __typename?: 'BillingCoupon', name: string, id: string, amountOff?: number | null, percentOff?: number | null } | null, customer: { __typename?: 'BillingSummaryCustomer', email: string, balance?: number | null }, source?: { __typename?: 'BillingSummarySource', brand: string, last4: string, expMonth: number, expYear: number, id: string } | null, plan?: { __typename?: 'BillingSummaryPlan', tier: PlanTier, name: string, interval: PlanInterval, type: PlanType } | null, planBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any }, overageBill: { __typename?: 'BillingSummaryBill', amount: number, billAt: any } };

export type BillingStatusView_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', amount: number, id: string }, yearly: { __typename?: 'BillingPlan', amount: number, id: string } } };

export type CouponCodeInput_BillingCouponFragment = { __typename?: 'BillingCoupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null };

export type GetCouponQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCouponQuery = { __typename?: 'RootQueryType', billingCoupon: { __typename?: 'BillingCoupon', id: string, name: string, amountOff?: number | null, percentOff?: number | null } };

export type EditPlan_BillingSummaryFragment = { __typename?: 'BillingSummary', status: BillingSummaryStatus, plan?: { __typename?: 'BillingSummaryPlan', tier: PlanTier, interval: PlanInterval, type: PlanType } | null, coupon?: { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null } | null };

export type EditPlan_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } } };

export type PaymentCard_BillingSummaryFragment = { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus, source?: { __typename?: 'BillingSummarySource', brand: string, last4: string, expMonth: number, expYear: number } | null };

export type Plan_BillingSummaryFragment = { __typename?: 'BillingSummary', id: string, userCount: number, seatCount: number, status: BillingSummaryStatus, plan?: { __typename?: 'BillingSummaryPlan', name: string, tier: PlanTier, interval: PlanInterval, type: PlanType } | null, coupon?: { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null } | null };

export type Plan_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } } };

export type PlanChooser_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, startup: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } }, business: { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } } };

export type PlanChooser_BillingCouponFragment = { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null };

export type PlanRow_BillingTierFragment = { __typename?: 'BillingTier', monthly: { __typename?: 'BillingPlan', id: string, amount: number }, yearly: { __typename?: 'BillingPlan', id: string, amount: number } };

export type PlanRow_BillingCouponFragment = { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null };

export type GetTotalForInterval_BillingCouponFragment = { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null };

export type GetMonthlyPrice_BillingCouponFragment = { __typename?: 'BillingCoupon', id: string, amountOff?: number | null, percentOff?: number | null };

export type AdminApiTokenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminApiTokenQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, apiToken?: string | null } };

export type RegenerateUserApiTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegenerateUserApiTokenMutation = { __typename?: 'RootMutationType', regenerateUserApiToken: string };

export type AdminWebhookQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminWebhookQueryQuery = { __typename?: 'RootQueryType', webhook?: { __typename?: 'Webhook', id?: string | null, name?: string | null, targetUrl?: string | null, enableAllPosts?: boolean | null, events?: Array<WebhookEvent | null> | null, secret?: string | null, topics?: Array<{ __typename?: 'Topic', id: string, name: string, score?: number | null } | null> | null } | null };

export type UpdateWebhookMutationVariables = Exact<{
  id: Scalars['ID'];
  enableAllPosts?: InputMaybe<Scalars['Boolean']>;
  events: Array<WebhookEvent> | WebhookEvent;
  name: Scalars['String'];
  targetUrl: Scalars['String'];
  topics?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateWebhookMutation = { __typename?: 'RootMutationType', updateWebhook?: { __typename?: 'Webhook', id?: string | null, name?: string | null, targetUrl?: string | null, enableAllPosts?: boolean | null, events?: Array<WebhookEvent | null> | null, secret?: string | null, topics?: Array<{ __typename?: 'Topic', id: string, name: string, score?: number | null } | null> | null } | null };

export type RegenerateWebhookSecretMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegenerateWebhookSecretMutation = { __typename?: 'RootMutationType', regenerateWebhookSecret?: { __typename?: 'Webhook', id?: string | null, secret?: string | null } | null };

export type DeleteWebhookMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWebhookMutation = { __typename?: 'RootMutationType', deleteWebhook?: { __typename?: 'Webhook', id?: string | null } | null };

export type AdminWebhookFormTopicFragment = { __typename?: 'Topic', id: string, name: string, score?: number | null };

export type AdminWebhookForm_WebhookFragment = { __typename?: 'Webhook', id?: string | null, name?: string | null, targetUrl?: string | null, enableAllPosts?: boolean | null, events?: Array<WebhookEvent | null> | null, secret?: string | null, topics?: Array<{ __typename?: 'Topic', id: string, name: string, score?: number | null } | null> | null };

export type CreateWebhookMutationVariables = Exact<{
  enableAllPosts?: InputMaybe<Scalars['Boolean']>;
  events: Array<WebhookEvent> | WebhookEvent;
  name: Scalars['String'];
  targetUrl: Scalars['String'];
  topics?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateWebhookMutation = { __typename?: 'RootMutationType', createWebhook?: { __typename?: 'Webhook', id?: string | null, name?: string | null, targetUrl?: string | null, secret?: string | null } | null };

export type AllWebhooksQueryVariables = Exact<{ [key: string]: never; }>;


export type AllWebhooksQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, webhooks?: Array<{ __typename?: 'Webhook', id?: string | null, name?: string | null, targetUrl?: string | null, secret?: string | null } | null> | null } } };

export type DeleteOrganizationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteOrganizationMutation = { __typename?: 'RootMutationType', deleteOrganization: { __typename?: 'Organization', id: string } };

export type DeleteTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type DeleteTeamQuery = { __typename?: 'RootQueryType', billingSummary: { __typename?: 'BillingSummary', id: string, status: BillingSummaryStatus } };

export type ImportGithubWikiConfirmation_ResultsFragment = { __typename?: 'GithubWikiImportResult', errorMessage?: string | null, repo?: { __typename?: 'GitRepo', owner: string, name: string } | null, imported?: Array<{ __typename?: 'Post', id: string, publishedAt?: any | null, title: string } | null> | null };

export type ImportGithubWikisMutationVariables = Exact<{
  repos: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type ImportGithubWikisMutation = { __typename?: 'RootMutationType', results?: Array<{ __typename?: 'GithubWikiImportResult', errorMessage?: string | null, repo?: { __typename?: 'GitRepo', owner: string, name: string } | null, imported?: Array<{ __typename?: 'Post', id: string, publishedAt?: any | null, title: string } | null> | null } | null> | null };

export type ImportFilesMutationVariables = Exact<{
  files: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  source?: InputMaybe<ImportSource>;
}>;


export type ImportFilesMutation = { __typename?: 'RootMutationType', importedFiles: Array<{ __typename?: 'ImportedFile', filename?: string | null, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string } }> };

export type GenerateImportUploadUrlMutationVariables = Exact<{
  extension: ImportExtension;
  source: ImportSource;
}>;


export type GenerateImportUploadUrlMutation = { __typename?: 'RootMutationType', url: string };

export type CompleteUploadedImportMutationVariables = Exact<{
  url: Scalars['String'];
}>;


export type CompleteUploadedImportMutation = { __typename?: 'RootMutationType', completeUploadedImport: boolean };

export type ImportFilesConfirmation_ImportedFilesFragment = { __typename?: 'ImportedFile', filename?: string | null, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string } };

export type ExportAllMutationVariables = Exact<{
  format: ExportFormat;
  privacy: ExportPrivacy;
}>;


export type ExportAllMutation = { __typename?: 'RootMutationType', exportAll: { __typename?: 'ExportResult', url: string } };

export type InsightMetricsQueryQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
}>;


export type InsightMetricsQueryQuery = { __typename?: 'RootQueryType', views: { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null }, reads: { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null } };

export type TopPostsPostMetricsFragment = { __typename?: 'PostMetrics', id: string, reads: number, views: number, post: { __typename?: 'Post', id: string, title: string, publishedAt?: any | null } };

export type TopPostsQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  orderBy: InsightTopPostsOrder;
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type TopPostsQuery = { __typename?: 'RootQueryType', insightTopPosts?: { __typename?: 'PostMetricsConnection', edges?: Array<{ __typename?: 'PostMetricsEdge', node?: { __typename?: 'PostMetrics', id: string, reads: number, views: number, post: { __typename?: 'Post', id: string, title: string, publishedAt?: any | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type InsightLeaderboardQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  topicId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  type: InsightLeaderboardType;
  first: Scalars['Int'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type InsightLeaderboardQuery = { __typename?: 'RootQueryType', insightLeaderboard?: { __typename?: 'InsightUserConnection', edges?: Array<{ __typename?: 'InsightUserEdge', node?: { __typename?: 'InsightUser', rank: number, quantity: number, user: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type LeaderboardUser_UserFragment = { __typename?: 'InsightUser', rank: number, quantity: number, user: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type UsersLeaderboard_UsersFragment = { __typename?: 'InsightUser', rank: number, quantity: number, user: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type GroupByQuantity_MetricsFragment = { __typename?: 'InsightMetric', date: any };

export type GetChartData_InsightMetricsFragment = { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null };

export type SearchInsightsMetricsQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  groupId?: InputMaybe<Scalars['String']>;
}>;


export type SearchInsightsMetricsQuery = { __typename?: 'RootQueryType', searches: { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null }, searchers: { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null } };

export type SearchOpportunitiesQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  groupId?: InputMaybe<Scalars['String']>;
  type: InsightTopSearchesType;
  first: Scalars['Int'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type SearchOpportunitiesQuery = { __typename?: 'RootQueryType', insightTopSearches?: { __typename?: 'InsightSearchConnection', edges?: Array<{ __typename?: 'InsightSearchEdge', node?: { __typename?: 'InsightSearch', count: number, query: string, trackedSearchCount?: number | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type SearchTopQueriesInsightSearchFragment = { __typename?: 'InsightSearch', query: string, trackedSearchCount?: number | null, clickThroughRate?: number | null, conversionRate?: number | null, averageClickPosition?: number | null };

export type SearchTopQueriesQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  groupId?: InputMaybe<Scalars['String']>;
  orderBy: InsightTopSearchesOrder;
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type SearchTopQueriesQuery = { __typename?: 'RootQueryType', insightTopSearches?: { __typename?: 'InsightSearchConnection', edges?: Array<{ __typename?: 'InsightSearchEdge', node?: { __typename?: 'InsightSearch', query: string, trackedSearchCount?: number | null, clickThroughRate?: number | null, conversionRate?: number | null, averageClickPosition?: number | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CreateSamlIntegrationMutationVariables = Exact<{
  platform: Scalars['String'];
  idpMetadata: Scalars['String'];
}>;


export type CreateSamlIntegrationMutation = { __typename?: 'RootMutationType', createSamlIntegration: { __typename?: 'Integration', id: string, platform: string } };

export type FeatureIntegrationPrompt_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string };

export type GitReposQueryVariables = Exact<{
  platform: GitRepoPlatform;
}>;


export type GitReposQuery = { __typename?: 'RootQueryType', repos: Array<{ __typename?: 'GitRepo', owner: string, name: string }> };

export type GetGithubReposQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGithubReposQuery = { __typename?: 'RootQueryType', repos: Array<{ __typename?: 'GitRepo', owner: string, name: string }> };

export type GetParentsQueryVariables = Exact<{
  type: MentionType;
}>;


export type GetParentsQuery = { __typename?: 'RootQueryType', parents: Array<{ __typename?: 'MentionTag', id: string, name: string }> };

export type MentionsTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, features?: { __typename?: 'IntegrationFeatures', mention?: IntegrationFeatureStatus | null, teamSearch?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enabledParents?: Array<string> | null, enableAllParents?: boolean | null } | null };

export type UpdateIntegrationMutationVariables = Exact<{
  platform: Scalars['String'];
  settings: IntegrationSettingsInput;
}>;


export type UpdateIntegrationMutation = { __typename?: 'RootMutationType', updateIntegration: { __typename?: 'Integration', id: string, externalId: string, platform: string, status: IntegrationStatus, features?: { __typename?: 'IntegrationFeatures', mention?: IntegrationFeatureStatus | null, profiles?: IntegrationFeatureStatus | null, repoSync?: IntegrationFeatureStatus | null, sso?: IntegrationFeatureStatus | null, saml?: IntegrationFeatureStatus | null, scim?: IntegrationFeatureStatus | null, teamSearch?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, idpMetadata?: string | null, enableScim?: boolean | null, scimToken?: string | null, enableEnrich?: boolean | null, enabledParents?: Array<string> | null, enableAllParents?: boolean | null, enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null, importOwnerId?: string | null, syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null } };

export type MultiFeatureIntegrationModal_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, features?: { __typename?: 'IntegrationFeatures', sso?: IntegrationFeatureStatus | null, scim?: IntegrationFeatureStatus | null, profiles?: IntegrationFeatureStatus | null, mention?: IntegrationFeatureStatus | null, teamSearch?: IntegrationFeatureStatus | null, repoSync?: IntegrationFeatureStatus | null, saml?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, idpMetadata?: string | null, enableScim?: boolean | null, scimToken?: string | null, enableEnrich?: boolean | null, enabledParents?: Array<string> | null, enableAllParents?: boolean | null, enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null, syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null };

export type ProfilesTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, settings?: { __typename?: 'IntegrationSettings', enableEnrich?: boolean | null } | null };

export type RepoSyncTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, settings?: { __typename?: 'IntegrationSettings', syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null };

export type RegenerateScimTokenMutationVariables = Exact<{
  platform: Scalars['String'];
}>;


export type RegenerateScimTokenMutation = { __typename?: 'RootMutationType', regenerateScimToken: { __typename?: 'Integration', id: string, settings?: { __typename?: 'IntegrationSettings', scimToken?: string | null } | null } };

export type ScimTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, settings?: { __typename?: 'IntegrationSettings', enableScim?: boolean | null, scimToken?: string | null } | null };

export type SsoTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, features?: { __typename?: 'IntegrationFeatures', saml?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, idpMetadata?: string | null } | null };

export type TeamSearchTab_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, settings?: { __typename?: 'IntegrationSettings', enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null } | null, features?: { __typename?: 'IntegrationFeatures', teamSearch?: IntegrationFeatureStatus | null } | null };

export type DeleteIntegrationMutationVariables = Exact<{
  platform: Scalars['String'];
}>;


export type DeleteIntegrationMutation = { __typename?: 'RootMutationType', deleteIntegration?: { __typename?: 'Integration', id: string } | null };

export type TrackPlatformRequestMutationVariables = Exact<{
  properties: TrackProperties;
}>;


export type TrackPlatformRequestMutation = { __typename?: 'RootMutationType', track?: boolean | null };

export type ExternalSearchSourcesQueryVariables = Exact<{
  platform: Scalars['String'];
}>;


export type ExternalSearchSourcesQuery = { __typename?: 'RootQueryType', sources: Array<{ __typename?: 'ExternalSearchSource', id: string, name: string }> };

export type UseTeamSearchSources_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, features?: { __typename?: 'IntegrationFeatures', teamSearch?: IntegrationFeatureStatus | null } | null };

export type AdminProvisionEditView_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> };

export type AdminProvisionEditViewQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminProvisionEditViewQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> }> } } };

export type DeleteProvisionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProvisionMutation = { __typename?: 'RootMutationType', deleteProvision: { __typename?: 'Provision', id: string } };

export type UpdateProvisionMutationVariables = Exact<{
  favoritePostIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  favoriteTopicIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  groupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  postIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  topicIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  type?: InputMaybe<ProvisionType>;
  urlEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateProvisionMutation = { __typename?: 'RootMutationType', updateProvision: { __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> } };

export type RegenerateProvisionSecretMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegenerateProvisionSecretMutation = { __typename?: 'RootMutationType', regenerateProvisionSecret: { __typename?: 'Provision', id: string, secret: string } };

export type AdminProvisionForm_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> };

export type AdminProvisionFormQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminProvisionFormQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType }> } } };

export type CreateProvisionMutationVariables = Exact<{
  favoritePostIds: Array<Scalars['ID']> | Scalars['ID'];
  favoriteTopicIds: Array<Scalars['ID']> | Scalars['ID'];
  name: Scalars['String'];
  topicIds: Array<Scalars['ID']> | Scalars['ID'];
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
  postIds: Array<Scalars['ID']> | Scalars['ID'];
  type: ProvisionType;
  urlEnabled: Scalars['Boolean'];
}>;


export type CreateProvisionMutation = { __typename?: 'RootMutationType', createProvision: { __typename?: 'Provision', id: string, name: string, secret: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, favoritePosts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, contributors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, contributors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }>, posts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> }> } };

export type AdminProvisionsView_ProvisionsFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType, isSsoDefault: boolean, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }> };

export type AdminProvisionsViewQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminProvisionsViewQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType, isSsoDefault: boolean, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }> }> } } };

export type AllInvitationsForProvisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllInvitationsForProvisionsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, invitations: Array<{ __typename?: 'Invitation', provision?: { __typename?: 'Provision', id: string } | null }> } } };

export type ProvisionDeletionConfirmMessage_ProvisionFragment = { __typename?: 'Provision', id: string, isSsoDefault: boolean };

export type ProvisionEntitySearchPostPillQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProvisionEntitySearchPostPillQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, parent?: { __typename?: 'Topic', id: string } | null, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type ProvisionSelectValue_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType };

export type ProvisionSelectOption_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType };

export type ProvisionSelectSingleValue_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType };

export type ProvisionTopicPolicyCheck_ProvisionFragment = { __typename?: 'Provision', type: ProvisionType, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> };

export type ProvisionPostPolicyCheck_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, parent?: { __typename?: 'Topic', id: string } | null, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type ProvisionTopicPolicyCheck_Provision_TopicFragment = { __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, memberGroups: Array<{ __typename?: 'Group', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string }> };

export type OrganizationSsoUserCreationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSsoUserCreationSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowSsoUserCreation?: boolean | null } | null, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType, isSsoDefault: boolean }> } } };

export type UpdateOrganizationSsoCreationMutationVariables = Exact<{
  allowSsoUserCreation: Scalars['Boolean'];
  ssoProvisionId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateOrganizationSsoCreationMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowSsoUserCreation?: boolean | null } | null } };

export type AdminSecuritySettingQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSecuritySettingQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null } | null } } };

export type UpdateOrganizationAuthenticationMutationVariables = Exact<{
  settings: OrganizationSettingsInput;
}>;


export type UpdateOrganizationAuthenticationMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null } | null } };

export type OrganizationAllowedEmbedHostsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationAllowedEmbedHostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowedEmbedHosts?: Array<string | null> | null } | null } } };

export type UpdateAllowedEmbedHostsMutationVariables = Exact<{
  allowedEmbedHosts: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateAllowedEmbedHostsMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowedEmbedHosts?: Array<string | null> | null } | null } };

export type UpdateOrganizationInviteSettingMutationVariables = Exact<{
  requireInviteApproval: Scalars['Boolean'];
}>;


export type UpdateOrganizationInviteSettingMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', requireInviteApproval?: boolean | null } | null } };

export type RequireInviteApprovalSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequireInviteApprovalSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', requireInviteApproval?: boolean | null } | null } } };

export type UpdatePublicContentBySettingMutationVariables = Exact<{
  allowPublicContentBy: AllowPublicContentBy;
}>;


export type UpdatePublicContentBySettingMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowPublicContentBy?: AllowPublicContentBy | null } | null } };

export type UpdateOrganizationUserRootTopicSettingsMutationVariables = Exact<{
  allowUserRootTopic: Scalars['Boolean'];
}>;


export type UpdateOrganizationUserRootTopicSettingsMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserRootTopic?: boolean | null } | null } };

export type OrganizationUserRootTopicSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationUserRootTopicSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserRootTopic?: boolean | null } | null } } };

export type UpdateOrganizationUserGroupSettingsMutationVariables = Exact<{
  allowUserGroupCreation: Scalars['Boolean'];
}>;


export type UpdateOrganizationUserGroupSettingsMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserGroupCreation?: boolean | null } | null } };

export type OrganizationUserGroupSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationUserGroupSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserGroupCreation?: boolean | null } | null } } };

export type DeleteInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvitationMutation = { __typename?: 'RootMutationType', invite?: { __typename?: 'Invitation', id: string } | null };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendInvitationMutation = { __typename?: 'RootMutationType', resendInvitation: { __typename?: 'Invitation', id: string } };

export type ApproveInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
  approve: Scalars['Boolean'];
}>;


export type ApproveInvitationMutation = { __typename?: 'RootMutationType', invitation: { __typename?: 'Invitation', id: string, status: InvitationStatus } };

export type TeammateInvitationMenu_InvitationFragment = { __typename?: 'Invitation', id: string, name?: string | null, status: InvitationStatus };

export type TeammatesInvitationMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type TeammatesInvitationMenuQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, invitations: Array<{ __typename?: 'Invitation', id: string }> } } };

export type UpdateUserTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  type: UserType;
}>;


export type UpdateUserTypeMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'User', id: string, type?: UserType | null } };

export type ReactivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReactivateUserMutation = { __typename?: 'RootMutationType', reactivateUser: { __typename?: 'User', id: string, deactivatedAt?: any | null, name: string, email?: string | null, title?: string | null, description: any, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  newOwnerId: Scalars['ID'];
}>;


export type DeactivateUserMutation = { __typename?: 'RootMutationType', deactivateUser: { __typename?: 'User', id: string, deactivatedAt?: any | null } };

export type TransferPostsMutationVariables = Exact<{
  ownerId: Scalars['ID'];
  newOwnerId: Scalars['ID'];
}>;


export type TransferPostsMutation = { __typename?: 'RootMutationType', transferPostOwnership: { __typename?: 'User', id: string } };

export type TeammateUserMenu_UserFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, deactivatedAt?: any | null };

export type TeammatesRow_UserFragment = { __typename?: 'User', id: string, name: string, email?: string | null, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TeammatesRow_InvitationFragment = { __typename?: 'Invitation', id: string, name?: string | null, email: string, status: InvitationStatus, type: ProvisionType, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TeammatesUserFragment = { __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TeammatesInvitationFragment = { __typename?: 'Invitation', id: string, name?: string | null, email: string, type: ProvisionType, status: InvitationStatus, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TeammatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeammatesQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, users: Array<{ __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, invitations: Array<{ __typename?: 'Invitation', id: string, name?: string | null, email: string, type: ProvisionType, status: InvitationStatus, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, settings?: { __typename?: 'OrganizationSettings', requireInviteApproval?: boolean | null } | null } } };

export type TransferPostOwnershipModal_UserFragment = { __typename?: 'User', id: string, name: string };

export type CurrentVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentVersionQuery = { __typename?: 'RootQueryType', currentVersion: { __typename?: 'Version', version: string } };

export type SessionLogoutSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SessionLogoutSubscription = { __typename?: 'RootSubscriptionType', sessionLogout?: boolean | null };

type PublicContentView_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type PublicContentView_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

export type PublicContentView_PostFragment = PublicContentView_Post_Post_Fragment | PublicContentView_Post_PublicPost_Fragment;

type PublicContentView_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', id: string, name: string };

type PublicContentView_Topic_Topic_Fragment = { __typename?: 'Topic', id: string, name: string };

export type PublicContentView_TopicFragment = PublicContentView_Topic_PublicTopic_Fragment | PublicContentView_Topic_Topic_Fragment;

export type PublicContentViewQueryVariables = Exact<{
  host: Scalars['String'];
}>;


export type PublicContentViewQuery = { __typename?: 'RootQueryType', organization: { __typename?: 'PublicOrganization', id: string, name: string } };

export type CurrentSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSessionQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', authToken: string, intercomHash: string, organization: { __typename?: 'Organization', id: string, insertedAt: any, name: string, email: string, host: string, effectiveHost: string, isVerified?: boolean | null, planTier?: PlanTier | null, periodEndAt?: any | null, trialEndAt?: any | null, isTrialEnded?: boolean | null, isTrialEndingSoon?: boolean | null, isLocked?: boolean | null, billingStatus?: BillingSummaryStatus | null, logo?: { __typename?: 'Image', thumb?: string | null } | null, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null, seatLimit?: number | null } | null }, user: { __typename?: 'User', id: string, email?: string | null, name: string, title?: string | null, description: any, type?: UserType | null, insertedAt?: any | null, membershipGroups: Array<{ __typename?: 'Group', id: string }>, settings?: { __typename?: 'UserSettings', allowAccountAccess?: boolean | null, uiTheme?: UiThemeSetting | null, aiAutofix?: boolean | null, aiPredict?: boolean | null, notifications?: { __typename?: 'UserNotificationSettings', direct?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, participant?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, team?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null } | null } | null, identities: Array<{ __typename?: 'Identity', id: string, platform: string }>, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } };

export type SetActiveMutationVariables = Exact<{ [key: string]: never; }>;


export type SetActiveMutation = { __typename?: 'RootMutationType', setActive: boolean };

export type PublicPostRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicPostRedirectQuery = { __typename?: 'RootQueryType', publicPost: { __typename?: 'PublicPost', id: string, title: string } };

export type PublicTopicRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicTopicRedirectQuery = { __typename?: 'RootQueryType', publicTopic: { __typename?: 'PublicTopic', id: string, name: string } };

export type BaseIntegrationBanner_IntegrationFragment = { __typename?: 'Integration', id: string, platform: string, status: IntegrationStatus };

export type IntegrationsBannerIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsBannerIntegrationsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, integrations: Array<{ __typename?: 'Integration', id: string, platform: string, status: IntegrationStatus }> } } };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'RootMutationType', resendVerificationEmail: boolean };

type Avatar_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type Avatar_User_User_Fragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type Avatar_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type Avatar_UserFragment = Avatar_User_PublicUser_Fragment | Avatar_User_User_Fragment | Avatar_User_VisitorUser_Fragment;

export type Avatar_InvitationFragment = { __typename?: 'Invitation', id: string, name?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type Avatar_ExternalUserFragment = { __typename?: 'ExternalUser', name?: string | null, avatar?: string | null };

export type AvatarStack_UsersFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type AvatarStackEditable_UsersFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type AvatarWithAction_UserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type CardBanner_BannerFragment = { __typename?: 'Image', original?: string | null };

export type DesktopLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type DesktopLoginMutation = { __typename?: 'RootMutationType', token: string };

export type DebugAskSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type DebugAskSearchQuery = { __typename?: 'RootQueryType', debugAskSearch?: { __typename?: 'DebugAskSearchResult', response: string, prompt: string, source?: { __typename?: 'Post', id: string, title: string } | null, searchResults: Array<{ __typename?: 'PostSearchResult', content?: any | null, highlight?: any | null, highlightIndex?: number | null, title?: string | null, resultId?: string | null, post: { __typename?: 'Post', id: string, views: number, thanks: number, updatedAt: any, publishedAt?: any | null, userViewedAt?: any | null, title: string, archivedAt?: any | null, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null }, ancestors: Array<{ __typename?: 'AncestorSearchResult', id: string, name: string }> }> } | null };

export type PostMentionMutationVariables = Exact<{
  postId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type PostMentionMutation = { __typename?: 'RootMutationType', postMention: { __typename?: 'Post', id: string } };

type Editor_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string, publishedAt?: any | null, linkAccess: PostLinkAccess, externalPost?: { __typename?: 'ExternalPost', id: string, editUrl: string, platform: string } | null, topics: Array<{ __typename?: 'Topic', id: string }> };

type Editor_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string, linkAccess: PostLinkAccess, topics: Array<{ __typename?: 'PublicTopic', id: string }> };

export type Editor_PostFragment = Editor_Post_Post_Fragment | Editor_Post_PublicPost_Fragment;

export type UpdatePostTitleFragment = { __typename?: 'Post', id: string, title: string };

type EditorPlaceholder_Post_Post_Fragment = { __typename?: 'Post', id: string, topics: Array<{ __typename?: 'Topic', id: string }> };

type EditorPlaceholder_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, topics: Array<{ __typename?: 'PublicTopic', id: string }> };

export type EditorPlaceholder_PostFragment = EditorPlaceholder_Post_Post_Fragment | EditorPlaceholder_Post_PublicPost_Fragment;

export type EditorPlaceholderImportFilesMutationVariables = Exact<{
  files: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
}>;


export type EditorPlaceholderImportFilesMutation = { __typename?: 'RootMutationType', importFiles: Array<{ __typename?: 'ImportedFile', post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string } }> };

export type MentionPickerQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type MentionPickerQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

type AttachmentToolbar_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type AttachmentToolbar_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

export type AttachmentToolbar_PostFragment = AttachmentToolbar_Post_Post_Fragment | AttachmentToolbar_Post_PublicPost_Fragment;

export type AttachmentToolbar_PublicPostFragment = { __typename?: 'PublicPost', id: string, title: string };

export type EditorToolbar_ExternalPostFragment = { __typename?: 'ExternalPost', editUrl: string, platform: string };

export type ImportedToolbar_ExternalPostFragment = { __typename?: 'ExternalPost', editUrl: string, platform: string };

type EditorActions_Post_Post_Fragment = { __typename?: 'Post', publishedAt?: any | null, id: string, title: string, version: number, content: any };

type EditorActions_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string, version: number, content: any };

export type EditorActions_PostFragment = EditorActions_Post_Post_Fragment | EditorActions_Post_PublicPost_Fragment;

type CardPostContent_Post_Post_Fragment = { __typename?: 'Post', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null };

type CardPostContent_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null };

export type CardPostContent_PostFragment = CardPostContent_Post_Post_Fragment | CardPostContent_Post_PublicPost_Fragment;

export type CardPostContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CardPostContentQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type CardPublicPostContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CardPublicPostContentQuery = { __typename?: 'RootQueryType', publicPost: { __typename?: 'PublicPost', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type GetEmbedContentQueryVariables = Exact<{
  type: MentionType;
  id: Scalars['ID'];
}>;


export type GetEmbedContentQuery = { __typename?: 'RootQueryType', mention: { __typename?: 'Mention', id: string, preview?: { __typename?: 'MentionPreview', content?: any | null } | null } };

export type GetEmbedFooterQueryVariables = Exact<{
  type: MentionType;
  id: Scalars['ID'];
}>;


export type GetEmbedFooterQuery = { __typename?: 'RootQueryType', mention: { __typename?: 'Mention', id: string, title: string } };

type EmbedPostContent_Post_Post_Fragment = { __typename?: 'Post', id: string, content: any, version: number, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, banner?: { __typename?: 'Image', original?: string | null } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> };

type EmbedPostContent_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null };

export type EmbedPostContent_PostFragment = EmbedPostContent_Post_Post_Fragment | EmbedPostContent_Post_PublicPost_Fragment;

export type EmbedPostContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmbedPostContentQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, content: any, version: number, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, banner?: { __typename?: 'Image', original?: string | null } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> } };

export type EmbedPublicPostContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmbedPublicPostContentQuery = { __typename?: 'RootQueryType', publicPost: { __typename?: 'PublicPost', id: string, content: any, version: number, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type PostEmbedFooterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostEmbedFooterQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string } };

export type PostEmbedFooterPublicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostEmbedFooterPublicQuery = { __typename?: 'RootQueryType', publicPost: { __typename?: 'PublicPost', id: string, title: string } };

export type ExternalPostMentionQueryVariables = Exact<{
  platform: Scalars['String'];
  externalId: Scalars['ID'];
}>;


export type ExternalPostMentionQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, views: number, content: any, version: number, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owner: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string, editUrl: string, readUrl: string, externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> } | null } };

export type GroupMentionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupMentionQuery = { __typename?: 'RootQueryType', group: { __typename?: 'Group', id: string, name: string } };

export type GroupMentionPublicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupMentionPublicQuery = { __typename?: 'RootQueryType', group: { __typename?: 'PublicGroup', id: string, name: string } };

export type MentionUserFieldsFragment = { __typename?: 'MentionUser', id: string, name: string, role?: string | null, avatar?: string | null };

export type MentionFieldsFragment = { __typename?: 'Mention', id: string, type: MentionType, title: string, importable: boolean, url?: string | null, icon?: string | null, breadcrumbs?: Array<string | null> | null, status?: MentionStatus | null, statusDate?: any | null, content?: { __typename?: 'MentionContentDelta', delta?: any | null } | { __typename?: 'MentionContentHighlights', highlights?: Array<string | null> | null } | { __typename?: 'MentionContentSlack' } | null, tags?: Array<{ __typename?: 'MentionTag', id: string, name: string, color?: string | null } | null> | null, preview?: { __typename?: 'MentionPreview', imageUrl?: string | null, content?: any | null } | null, participants?: Array<{ __typename?: 'MentionUser', id: string, name: string, role?: string | null, avatar?: string | null } | null> | null, assignee?: { __typename?: 'MentionUser', id: string, name: string, role?: string | null, avatar?: string | null } | null };

export type GetMentionQueryVariables = Exact<{
  type: MentionType;
  id: Scalars['ID'];
}>;


export type GetMentionQuery = { __typename?: 'RootQueryType', mention: { __typename?: 'Mention', id: string, type: MentionType, title: string, importable: boolean, url?: string | null, icon?: string | null, breadcrumbs?: Array<string | null> | null, status?: MentionStatus | null, statusDate?: any | null, content?: { __typename?: 'MentionContentDelta', delta?: any | null } | { __typename?: 'MentionContentHighlights', highlights?: Array<string | null> | null } | { __typename?: 'MentionContentSlack' } | null, tags?: Array<{ __typename?: 'MentionTag', id: string, name: string, color?: string | null } | null> | null, preview?: { __typename?: 'MentionPreview', imageUrl?: string | null, content?: any | null } | null, participants?: Array<{ __typename?: 'MentionUser', id: string, name: string, role?: string | null, avatar?: string | null } | null> | null, assignee?: { __typename?: 'MentionUser', id: string, name: string, role?: string | null, avatar?: string | null } | null } };

export type PostMentionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostMentionQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, type: PostType, publishedAt?: any | null, linkAccess: PostLinkAccess } };

export type PostMentionPublicPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostMentionPublicPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, publicUrl?: string | null, title: string, linkAccess: PostLinkAccess } };

export type TopicMentionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TopicMentionQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable } };

export type TopicMentionPublicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TopicMentionPublicQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'PublicTopic', id: string, name: string, privacy: TopicPrivacy } };

export type UserMentionPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserMentionPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type PublicUserMentionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicUserMentionQuery = { __typename?: 'RootQueryType', user: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type UserMentionIconQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserMentionIconQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type PublicUserMentionIconQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicUserMentionIconQuery = { __typename?: 'RootQueryType', user: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type MarkdownContentQueryVariables = Exact<{
  delta: Scalars['String'];
}>;


export type MarkdownContentQuery = { __typename?: 'RootQueryType', markdown: string };

export type FetchPostAnchorTitlePostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchPostAnchorTitlePostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, content: any, version: number } };

export type PostListViewedPostsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type PostListViewedPostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, viewedPosts?: { __typename?: 'PostConnection', edges?: Array<{ __typename?: 'PostEdge', node?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, title: string, type: PostType, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } } };

export type PostListFavoritePostsQueryVariables = Exact<{ [key: string]: never; }>;


export type PostListFavoritePostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, favoritePosts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, title: string, type: PostType, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> }> } } };

export type SearchResultSearchQueryVariables = Exact<{
  query: Scalars['String'];
  first: Scalars['Int'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type SearchResultSearchQuery = { __typename?: 'RootQueryType', search?: { __typename?: 'SearchResultConnection', edges?: Array<{ __typename?: 'SearchResultEdge', node?: { __typename?: 'CommentSearchResult' } | { __typename?: 'GroupSearchResult' } | { __typename?: 'PostSearchResult', title?: string | null, content?: any | null, highlight?: any | null, post: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, title: string, type: PostType, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> } } | { __typename?: 'TopicSearchResult' } | { __typename?: 'UserSearchResult' } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type ExtensionCommentThread_PostFragment = { __typename?: 'Post', id: string, title: string };

export type ExtensionCommentThread_ThreadFragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, insertedAt: any, content: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, reactions: Array<{ __typename?: 'Reaction', id: string }> };

export type ExtensionMagneticWall_PostFragment = { __typename?: 'Post', id: string, title: string, threads: Array<{ __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, insertedAt: any, content: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, reactions: Array<{ __typename?: 'Reaction', id: string }> }> };

export type PostContentPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostContentPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, content: any, version: number, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, threads: Array<{ __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, insertedAt: any, content: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, reactions: Array<{ __typename?: 'Reaction', id: string }> }> } };

export type ExtensionPostRow_PostFragment = { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, title: string, type: PostType, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> };

export type PostRowToolbar_PostFragment = { __typename?: 'Post', id: string, title: string };

export type PostTitleWithVerified_PostFragment = { __typename?: 'Post', id: string, title: string, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> };

export type AllIntegrationsIntegrationFragment = { __typename?: 'Integration', id: string, externalId: string, platform: string, status: IntegrationStatus, features?: { __typename?: 'IntegrationFeatures', mention?: IntegrationFeatureStatus | null, profiles?: IntegrationFeatureStatus | null, repoSync?: IntegrationFeatureStatus | null, sso?: IntegrationFeatureStatus | null, saml?: IntegrationFeatureStatus | null, scim?: IntegrationFeatureStatus | null, teamSearch?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, enableScim?: boolean | null, enableEnrich?: boolean | null, scimToken?: string | null, enableAllParents?: boolean | null, enabledParents?: Array<string> | null, enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null, importOwnerId?: string | null, idpMetadata?: string | null, syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null };

export type AllIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllIntegrationsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, integrations: Array<{ __typename?: 'Integration', id: string, externalId: string, platform: string, status: IntegrationStatus, features?: { __typename?: 'IntegrationFeatures', mention?: IntegrationFeatureStatus | null, profiles?: IntegrationFeatureStatus | null, repoSync?: IntegrationFeatureStatus | null, sso?: IntegrationFeatureStatus | null, saml?: IntegrationFeatureStatus | null, scim?: IntegrationFeatureStatus | null, teamSearch?: IntegrationFeatureStatus | null } | null, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, enableScim?: boolean | null, enableEnrich?: boolean | null, scimToken?: string | null, enableAllParents?: boolean | null, enabledParents?: Array<string> | null, enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null, importOwnerId?: string | null, idpMetadata?: string | null, syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null }> } } };

export type UnorganizedQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UnorganizedPostsFilter>;
  orderBy?: InputMaybe<UnorganizedPostsOrder>;
}>;


export type UnorganizedQuery = { __typename?: 'RootQueryType', unorganized?: { __typename?: 'PostEdgesConnection', totalCount: number, edges?: Array<{ __typename?: 'PostEdgesEdge', node?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, views: number, content: any, version: number, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owner: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string, editUrl: string, readUrl: string, externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type CommentReactionCreatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type CommentReactionCreatedSubscription = { __typename?: 'RootSubscriptionType', commentReaction?: { __typename?: 'CommentReaction', commentId: string, threadId: string, id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } } | { __typename?: 'PublicCommentReaction', commentId: string, threadId: string, id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } } | null };

export type CommentReactionDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type CommentReactionDeletedSubscription = { __typename?: 'RootSubscriptionType', commentReaction?: { __typename?: 'CommentReaction', commentId: string, threadId: string, id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } } | { __typename?: 'PublicCommentReaction', commentId: string, threadId: string, id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } } | null };

export type CreatePostMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']>;
  topicId?: InputMaybe<Scalars['ID']>;
  libraryName?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PostType>;
}>;


export type CreatePostMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, type: PostType, archivedAt?: any | null, views: number, linkAccess: PostLinkAccess, verifiedAt?: any | null, updatedAt: any, userViewedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, owner: { __typename?: 'User', id: string }, series?: { __typename?: 'Series', id: string } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } };

export type CreateStaticTokenIntegrationMutationVariables = Exact<{
  platform: Scalars['String'];
  token: Scalars['String'];
  host?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type CreateStaticTokenIntegrationMutation = { __typename?: 'RootMutationType', createStaticTokenIntegration: { __typename?: 'Integration', id: string, platform: string } };

export type FavoritePostsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritePostsQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', user: { __typename?: 'User', id: string, favoritePosts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> }> } } };

type CommentFields_Comment_Fragment = { __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> };

type CommentFields_PublicComment_Fragment = { __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> };

export type CommentFieldsFragment = CommentFields_Comment_Fragment | CommentFields_PublicComment_Fragment;

type CommentReactionFields_CommentReaction_Fragment = { __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } };

type CommentReactionFields_PublicCommentReaction_Fragment = { __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } };

export type CommentReactionFieldsFragment = CommentReactionFields_CommentReaction_Fragment | CommentReactionFields_PublicCommentReaction_Fragment;

export type CurrentSessionFragment = { __typename?: 'Session', authToken: string, intercomHash: string, organization: { __typename?: 'Organization', id: string, insertedAt: any, name: string, email: string, host: string, effectiveHost: string, isVerified?: boolean | null, planTier?: PlanTier | null, periodEndAt?: any | null, trialEndAt?: any | null, isTrialEnded?: boolean | null, isTrialEndingSoon?: boolean | null, isLocked?: boolean | null, billingStatus?: BillingSummaryStatus | null, logo?: { __typename?: 'Image', thumb?: string | null } | null, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null, seatLimit?: number | null } | null }, user: { __typename?: 'User', id: string, email?: string | null, name: string, title?: string | null, description: any, type?: UserType | null, insertedAt?: any | null, membershipGroups: Array<{ __typename?: 'Group', id: string }>, settings?: { __typename?: 'UserSettings', allowAccountAccess?: boolean | null, uiTheme?: UiThemeSetting | null, aiAutofix?: boolean | null, aiPredict?: boolean | null, notifications?: { __typename?: 'UserNotificationSettings', direct?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, participant?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, team?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null } | null } | null, identities: Array<{ __typename?: 'Identity', id: string, platform: string }>, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type IntegrationSettingsFragment = { __typename?: 'Integration', settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null, enableScim?: boolean | null, enableEnrich?: boolean | null, scimToken?: string | null, enableAllParents?: boolean | null, enabledParents?: Array<string> | null, enableSearch?: IntegrationSettingsSearch | null, enabledSearchSources?: Array<string> | null, importOwnerId?: string | null, idpMetadata?: string | null, syncingRepos?: Array<{ __typename?: 'SyncingRepo', name: string, topicId?: string | null }> | null } | null };

export type OrganizationBillingFragment = { __typename?: 'Organization', id: string, planTier?: PlanTier | null, periodEndAt?: any | null, trialEndAt?: any | null, isTrialEnded?: boolean | null, isTrialEndingSoon?: boolean | null, isLocked?: boolean | null, billingStatus?: BillingSummaryStatus | null };

type PostContent_Post_Fragment = { __typename?: 'Post', content: any, version: number };

type PostContent_PublicPost_Fragment = { __typename?: 'PublicPost', content: any, version: number };

export type PostContentFragment = PostContent_Post_Fragment | PostContent_PublicPost_Fragment;

export type PostFieldsFragment = { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, views: number, content: any, version: number, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owner: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string, editUrl: string, readUrl: string, externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> } | null };

export type PostSummaryFieldsFragment = { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> };

export type ProvisionFieldsFragment = { __typename?: 'Provision', id: string, name: string, secret: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, favoritePosts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, contributors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }>, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, contributors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }>, posts: Array<{ __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> }> };

type ReactionFields_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

type ReactionFields_Reaction_Fragment = { __typename?: 'Reaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type ReactionFieldsFragment = ReactionFields_PublicReaction_Fragment | ReactionFields_Reaction_Fragment;

export type SeriesSummaryFieldsFragment = { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> };

type ThreadFields_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ThreadFields_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ThreadFieldsFragment = ThreadFields_PublicThread_Fragment | ThreadFields_Thread_Fragment;

export type TopicFieldsFragment = { __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null };

export type TopicSummaryFieldsFragment = { __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, contributors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> };

export type TopicUserFieldsFragment = { __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type UserAvatar_PublicUser_Fragment = { __typename?: 'PublicUser', avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type UserAvatar_User_Fragment = { __typename?: 'User', avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type UserAvatar_VisitorUser_Fragment = { __typename?: 'VisitorUser', avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UserAvatarFragment = UserAvatar_PublicUser_Fragment | UserAvatar_User_Fragment | UserAvatar_VisitorUser_Fragment;

export type UserProfileSettingsFragment = { __typename?: 'User', id: string, name: string, title?: string | null, description: any, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null };

export type UserSettingsFieldsFragment = { __typename?: 'UserSettings', allowAccountAccess?: boolean | null, uiTheme?: UiThemeSetting | null, aiAutofix?: boolean | null, aiPredict?: boolean | null, notifications?: { __typename?: 'UserNotificationSettings', direct?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, participant?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, team?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null } | null };

export type OrganizationAuthenticationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationAuthenticationSettingQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null } | null } } };

export type ResolveThreadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResolveThreadMutation = { __typename?: 'RootMutationType', resolveThread: { __typename?: 'PublicThread', id: string } | { __typename?: 'Thread', id: string } };

export type ThreadUnresolvedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadUnresolvedSubscription = { __typename?: 'RootSubscriptionType', thread?: { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } | { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } | null };

export type UnresolveThreadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnresolveThreadMutation = { __typename?: 'RootMutationType', unresolveThread: { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } | { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, emoji: string, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } };

export type UpdateTopicMutationVariables = Exact<{
  id: Scalars['ID'];
  banner?: InputMaybe<Scalars['Upload']>;
  unsplashId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Json']>;
  parentId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<TopicPrivacy>;
  memberEditable?: InputMaybe<TopicMemberEditable>;
  defaultSort?: InputMaybe<TopicPostsOrder>;
  defaultShow?: InputMaybe<TopicPostsType>;
  propagatePrivacy?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTopicMutation = { __typename?: 'RootMutationType', updateTopic: { __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, children: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }> } };

export type AddMemberControl_GroupFragment = { __typename?: 'Group', id: string, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, children: Array<{ __typename?: 'Group', id: string }> };

export type AddMemberSelect_GroupFragment = { __typename?: 'Group', id: string, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, children: Array<{ __typename?: 'Group', id: string }> };

export type GroupCard_GroupFragment = { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

export type GroupCardAvatarStack_GroupFragment = { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

export type GroupDetailCard_GroupFragment = { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

type GroupDetailCard_PublicGroup_Group_Fragment = { __typename?: 'Group', id: string, name: string, banner?: { __typename?: 'Image', original?: string | null } | null };

type GroupDetailCard_PublicGroup_PublicGroup_Fragment = { __typename?: 'PublicGroup', id: string, name: string, banner?: { __typename?: 'Image', original?: string | null } | null };

export type GroupDetailCard_PublicGroupFragment = GroupDetailCard_PublicGroup_Group_Fragment | GroupDetailCard_PublicGroup_PublicGroup_Fragment;

export type GroupDetailContent_GroupFragment = { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

type GroupDetailContent_PublicGroup_Group_Fragment = { __typename?: 'Group', id: string, name: string, banner?: { __typename?: 'Image', original?: string | null } | null };

type GroupDetailContent_PublicGroup_PublicGroup_Fragment = { __typename?: 'PublicGroup', id: string, name: string, banner?: { __typename?: 'Image', original?: string | null } | null };

export type GroupDetailContent_PublicGroupFragment = GroupDetailContent_PublicGroup_Group_Fragment | GroupDetailContent_PublicGroup_PublicGroup_Fragment;

export type GroupDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupDetailPreviewQuery = { __typename?: 'RootQueryType', group: { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } };

export type PublicGroupDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicGroupDetailPreviewQuery = { __typename?: 'RootQueryType', group: { __typename?: 'PublicGroup', id: string, name: string, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type GroupModalCreateMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type GroupModalCreateMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string, name: string } };

export type GroupModalRequestMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type GroupModalRequestMutation = { __typename?: 'RootMutationType', requestGroupCreation: boolean };

export type GroupSubgroupCard_GroupFragment = { __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

export type GroupUserCard_MemberFragment = { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type GroupViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupViewQuery = { __typename?: 'RootQueryType', group: { __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null, requestors: Array<{ __typename?: 'User', id: string }>, membershipTopics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> }>, owners: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, children: Array<{ __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }> } };

export type GroupViewUpdateGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  banner?: InputMaybe<Scalars['Upload']>;
  unsplashId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Json']>;
}>;


export type GroupViewUpdateGroupMutation = { __typename?: 'RootMutationType', updateGroup: { __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type GroupViewAddUserMutationVariables = Exact<{
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GroupViewAddUserMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type GroupViewUpdateUserRoleMutationVariables = Exact<{
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
  role: GroupUserRole;
}>;


export type GroupViewUpdateUserRoleMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type GroupViewRemoveUserMutationVariables = Exact<{
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GroupViewRemoveUserMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type GroupViewRequestAccessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupViewRequestAccessMutation = { __typename?: 'RootMutationType', requestGroupAccess: { __typename?: 'Group', id: string, requestors: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, children: Array<{ __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }> } };

export type GroupsViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupsViewQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, groups: Array<{ __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }>, settings?: { __typename?: 'OrganizationSettings', allowUserGroupCreation?: boolean | null } | null } } };

export type GroupViewCreateMutationVariables = Exact<{
  name: Scalars['String'];
  ownerId: Scalars['ID'];
}>;


export type GroupViewCreateMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } };

export type MembershipGroups_GroupsFragment = { __typename?: 'Group', id: string, name: string };

export type GroupPolicyCheck_UserFragment = { __typename?: 'User', id: string, type?: UserType | null };

export type GroupPolicyCheck_GroupFragment = { __typename?: 'Group', id: string, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, requestors: Array<{ __typename?: 'User', id: string }> };

export type AllowUserGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowUserGroupQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserGroupCreation?: boolean | null } | null } } };

export type UseGroupPolicyCheck_GroupFragment = { __typename?: 'Group', id: string, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, requestors: Array<{ __typename?: 'User', id: string }> };

export type AllGroupFieldsFragment = { __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null, allUsers: Array<{ __typename?: 'User', id: string }> };

export type AllGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGroupsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, groups: Array<{ __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null, allUsers: Array<{ __typename?: 'User', id: string }> }> } } };

export type GroupCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GroupCreatedSubscription = { __typename?: 'RootSubscriptionType', group?: { __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null, allUsers: Array<{ __typename?: 'User', id: string }> } | null };

export type GroupDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GroupDeletedSubscription = { __typename?: 'RootSubscriptionType', group?: { __typename?: 'Group', id: string } | null };

export type GroupUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', group?: { __typename?: 'Group', id: string, name: string, description: any, banner?: { __typename?: 'Image', original?: string | null } | null, allUsers: Array<{ __typename?: 'User', id: string }> } | null };

export type GroupModalDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupModalDeleteMutation = { __typename?: 'RootMutationType', deleteGroup?: { __typename?: 'Group', id: string } | null };

export type UseGroupMembersColumn_MemberFragment = { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UseGroupMembersColumn_GroupFragment = { __typename?: 'Group', id: string, owners: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, deactivatedAt?: any | null, importedFrom?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, children: Array<{ __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }>, requestors: Array<{ __typename?: 'User', id: string }> };

export type GroupMembersColumnAddGroupToGroupMutationVariables = Exact<{
  parentId: Scalars['ID'];
  childId: Scalars['ID'];
}>;


export type GroupMembersColumnAddGroupToGroupMutation = { __typename?: 'RootMutationType', addGroupToGroup: { __typename?: 'Group', id: string, children: Array<{ __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }> } };

export type GroupMembersColumnRemoveGroupFromGroupMutationVariables = Exact<{
  parentId: Scalars['ID'];
  childId: Scalars['ID'];
}>;


export type GroupMembersColumnRemoveGroupFromGroupMutation = { __typename?: 'RootMutationType', removeGroupFromGroup: { __typename?: 'Group', id: string, children: Array<{ __typename?: 'Group', id: string, name: string, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }> } };

export type DraftsList_DraftsFragment = { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type DraftsViewQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DraftsFilter>;
  orderBy?: InputMaybe<DraftsOrder>;
}>;


export type DraftsViewQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', user: { __typename?: 'User', myDraftsCount: number, sharedDraftsCount: number, archivedDraftsCount: number, allDraftsCount: number, drafts?: { __typename?: 'PostEdgesConnection', edges?: Array<{ __typename?: 'PostEdgesEdge', node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } } };

export type ActivitiesQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type ActivitiesQuery = { __typename?: 'RootQueryType', activities?: { __typename?: 'ActivityConnection', edges?: Array<{ __typename?: 'ActivityEdge', node?: { __typename?: 'CreatedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null } | { __typename?: 'CreatedHistoryActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdHistory?: { __typename?: 'History', id: string, diff: any, snapshot: any, versionFrom: number, versionTo: number, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } | null } | { __typename?: 'CreatedTopicActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null } | { __typename?: 'FillerActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null } | { __typename?: 'JoinedUserActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, joinedUser?: { __typename?: 'User', id: string } | null } | { __typename?: 'PublishedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, publishedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null } | { __typename?: 'RepliedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, repliedComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null } | { __typename?: 'ThankedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, thankedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, owner: { __typename?: 'User', name: string, id: string }, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type OrganizationSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSummaryQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, summary?: any | null } } };

export type UpdateOrganizationSummaryMutationVariables = Exact<{
  summary?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateOrganizationSummaryMutation = { __typename?: 'RootMutationType', organization: { __typename?: 'Organization', id: string, summary?: any | null } };

export type UseViewedPostsColumn_PostFragment = { __typename?: 'Post', id: string, userViewedAt?: any | null, insertedAt: any, publishedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type UseUpdateLocalViewedPost_PostFragment = { __typename?: 'Post', id: string, userViewedAt?: any | null, insertedAt: any, publishedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type ViewedPostsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type ViewedPostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, viewedPosts?: { __typename?: 'PostConnection', edges?: Array<{ __typename?: 'PostEdge', node?: { __typename?: 'Post', id: string, userViewedAt?: any | null, insertedAt: any, publishedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } } };

export type IntegrationMentionCard_MentionFragment = { __typename?: 'Mention', icon?: string | null, id: string, status?: MentionStatus | null, statusDate?: any | null, title: string, type: MentionType, assignee?: { __typename?: 'MentionUser', name: string } | null, content?: { __typename?: 'MentionContentDelta', delta?: any | null } | { __typename?: 'MentionContentHighlights', highlights?: Array<string | null> | null } | { __typename?: 'MentionContentSlack', previous?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, message?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, next?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null } | null, participants?: Array<{ __typename?: 'MentionUser', name: string } | null> | null, preview?: { __typename?: 'MentionPreview', content?: any | null, imageUrl?: string | null } | null, tags?: Array<{ __typename?: 'MentionTag', id: string, color?: string | null, name: string } | null> | null };

export type UseSsoPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseSsoPlatformsQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, integrations: Array<{ __typename?: 'Integration', id: string, platform: string, settings?: { __typename?: 'IntegrationSettings', enableSso?: boolean | null } | null }> } } };

export type InvitationModal_InitialPostFragment = { __typename?: 'Post', id: string, title: string };

export type InvitationModal_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> };

export type InvitationModalQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationModalQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, email: string, planTier?: PlanTier | null, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType, urlEnabled: boolean, isSsoDefault: boolean, secret: string, favoritePosts: Array<{ __typename?: 'Post', id: string }>, favoriteTopics: Array<{ __typename?: 'Topic', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, groups: Array<{ __typename?: 'Group', id: string }>, posts: Array<{ __typename?: 'Post', id: string }> }>, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null, requireInviteApproval?: boolean | null } | null } }, google?: { __typename?: 'Integration', features?: { __typename?: 'IntegrationFeatures', externalUsers?: IntegrationFeatureStatus | null } | null } | null };

export type InvitationUserSelect_ExternalUsersFragment = { __typename?: 'ExternalUser', name?: string | null, email?: string | null, avatar?: string | null };

export type SignUpLinkTip_ProvisionFragment = { __typename?: 'Provision', id: string, secret: string };

export type InvitationAutocompleteQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationAutocompleteQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, externalUsers: Array<{ __typename?: 'ExternalUser', name?: string | null, email?: string | null, avatar?: string | null }>, invitations: Array<{ __typename?: 'Invitation', id: string, email: string }>, users: Array<{ __typename?: 'User', id: string, email?: string | null, deactivatedAt?: any | null, importedFrom?: string | null }> } } };

export type UseInviteMutation_InvitationFragment = { __typename?: 'Invitation', id: string, name?: string | null, email: string, status: InvitationStatus, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, provision?: { __typename?: 'Provision', id: string, type: ProvisionType } | null, inviter?: { __typename?: 'User', id: string } | null };

export type InviteMutationVariables = Exact<{
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  provisionId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  provisionChanges?: InputMaybe<ProvisionChangesInput>;
  source?: InputMaybe<InvitationSource>;
}>;


export type InviteMutation = { __typename?: 'RootMutationType', invite: { __typename?: 'Invitation', id: string, name?: string | null, email: string, status: InvitationStatus, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, provision?: { __typename?: 'Provision', id: string, type: ProvisionType } | null, inviter?: { __typename?: 'User', id: string } | null } };

export type OrgInvitationsUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgInvitationsUpdateQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, invitations: Array<{ __typename?: 'Invitation', id: string, name?: string | null, email: string, status: InvitationStatus, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, provision?: { __typename?: 'Provision', id: string, type: ProvisionType } | null, inviter?: { __typename?: 'User', id: string } | null }> } } };

type NotificationFields_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationFields_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, history?: { __typename?: 'History', id: string, versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationFields_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, invitation?: { __typename?: 'Invitation', id: string, acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationFields_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationFields_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', id: string, emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

export type NotificationFieldsFragment = NotificationFields_CommentNotification_Fragment | NotificationFields_HistoryNotification_Fragment | NotificationFields_InvitationNotification_Fragment | NotificationFields_PostNotification_Fragment | NotificationFields_ReactionNotification_Fragment;

export type NotificationButtonUnreadNotificationsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationButtonUnreadNotificationsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, unreadNotifications?: { __typename?: 'NotificationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, history?: { __typename?: 'History', id: string, versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, invitation?: { __typename?: 'Invitation', id: string, acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', id: string, emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | null } | null> | null } | null } } };

export type NotificationsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, notifications?: { __typename?: 'NotificationConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, history?: { __typename?: 'History', id: string, versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, invitation?: { __typename?: 'Invitation', id: string, acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', id: string, emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | null } | null> | null } | null } } };

export type NotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCreatedSubscription = { __typename?: 'RootSubscriptionType', notification: { __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, history?: { __typename?: 'History', id: string, versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, invitation?: { __typename?: 'Invitation', id: string, acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', id: string, emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } };

export type NotificationsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationsUpdatedSubscription = { __typename?: 'RootSubscriptionType', notificationsUpdated: Array<{ __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, history?: { __typename?: 'History', id: string, versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, invitation?: { __typename?: 'Invitation', id: string, acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', id: string, emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } }> };

type NotificationCommentPreview_Notification_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null } } | null };

type NotificationCommentPreview_Notification_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string };

type NotificationCommentPreview_Notification_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string };

type NotificationCommentPreview_Notification_PostNotification_Fragment = { __typename?: 'PostNotification', id: string };

type NotificationCommentPreview_Notification_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string };

export type NotificationCommentPreview_NotificationFragment = NotificationCommentPreview_Notification_CommentNotification_Fragment | NotificationCommentPreview_Notification_HistoryNotification_Fragment | NotificationCommentPreview_Notification_InvitationNotification_Fragment | NotificationCommentPreview_Notification_PostNotification_Fragment | NotificationCommentPreview_Notification_ReactionNotification_Fragment;

type NotificationContent_Notifications_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationContent_Notifications_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, history?: { __typename?: 'History', versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationContent_Notifications_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, invitation?: { __typename?: 'Invitation', acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationContent_Notifications_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, post?: { __typename?: 'Post', id: string, title: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationContent_Notifications_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, reaction?: { __typename?: 'Reaction', emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

export type NotificationContent_NotificationsFragment = NotificationContent_Notifications_CommentNotification_Fragment | NotificationContent_Notifications_HistoryNotification_Fragment | NotificationContent_Notifications_InvitationNotification_Fragment | NotificationContent_Notifications_PostNotification_Fragment | NotificationContent_Notifications_ReactionNotification_Fragment;

export type SetNotificationsStatusMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  status: NotificationReadStatus;
}>;


export type SetNotificationsStatusMutation = { __typename?: 'RootMutationType', markNotifications: Array<{ __typename?: 'CommentNotification', id: string, status: NotificationStatus } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus } | { __typename?: 'PostNotification', id: string, status: NotificationStatus } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus }> };

type NotificationItem_Notifications_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, actor?: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationItem_Notifications_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, actor?: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, history?: { __typename?: 'History', versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationItem_Notifications_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, actor?: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, invitation?: { __typename?: 'Invitation', acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationItem_Notifications_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, actor?: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, post?: { __typename?: 'Post', id: string, title: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationItem_Notifications_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, status: NotificationStatus, type: NotificationType, insertedAt: any, reaction?: { __typename?: 'Reaction', emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

export type NotificationItem_NotificationsFragment = NotificationItem_Notifications_CommentNotification_Fragment | NotificationItem_Notifications_HistoryNotification_Fragment | NotificationItem_Notifications_InvitationNotification_Fragment | NotificationItem_Notifications_PostNotification_Fragment | NotificationItem_Notifications_ReactionNotification_Fragment;

type NotificationMessage_Notifications_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, type: NotificationType, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', name: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationMessage_Notifications_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, type: NotificationType, history?: { __typename?: 'History', post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', name: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationMessage_Notifications_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, type: NotificationType, actor?: { __typename?: 'User', name: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationMessage_Notifications_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, type: NotificationType, post?: { __typename?: 'Post', id: string, title: string } | null, actor?: { __typename?: 'User', name: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationMessage_Notifications_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, type: NotificationType, reaction?: { __typename?: 'Reaction', thread: { __typename?: 'Thread', post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', name: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

export type NotificationMessage_NotificationsFragment = NotificationMessage_Notifications_CommentNotification_Fragment | NotificationMessage_Notifications_HistoryNotification_Fragment | NotificationMessage_Notifications_InvitationNotification_Fragment | NotificationMessage_Notifications_PostNotification_Fragment | NotificationMessage_Notifications_ReactionNotification_Fragment;

export type ClearAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearAllNotificationsMutation = { __typename?: 'RootMutationType', markNotifications: Array<{ __typename?: 'CommentNotification', id: string, status: NotificationStatus } | { __typename?: 'HistoryNotification', id: string, status: NotificationStatus } | { __typename?: 'InvitationNotification', id: string, status: NotificationStatus } | { __typename?: 'PostNotification', id: string, status: NotificationStatus } | { __typename?: 'ReactionNotification', id: string, status: NotificationStatus }> };

export type NotificationPopOverQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPopOverQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, unreadNotifications?: { __typename?: 'NotificationConnection', edges?: Array<{ __typename: 'NotificationEdge' } | null> | null } | null } } };

type NotificationPopOver_Notifications_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, comment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, context?: any | null, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationPopOver_Notifications_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, history?: { __typename?: 'History', versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationPopOver_Notifications_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, invitation?: { __typename?: 'Invitation', acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationPopOver_Notifications_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, post?: { __typename?: 'Post', id: string, title: string } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

type NotificationPopOver_Notifications_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, type: NotificationType, insertedAt: any, status: NotificationStatus, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, reaction?: { __typename?: 'Reaction', emoji: string, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null, metadata: { __typename?: 'NotificationMetadata', message?: string | null } };

export type NotificationPopOver_NotificationsFragment = NotificationPopOver_Notifications_CommentNotification_Fragment | NotificationPopOver_Notifications_HistoryNotification_Fragment | NotificationPopOver_Notifications_InvitationNotification_Fragment | NotificationPopOver_Notifications_PostNotification_Fragment | NotificationPopOver_Notifications_ReactionNotification_Fragment;

type GetNotificationPostId_Notification_CommentNotification_Fragment = { __typename?: 'CommentNotification', comment?: { __typename?: 'Comment', thread: { __typename?: 'Thread', post: { __typename?: 'Post', id: string } } } | null };

type GetNotificationPostId_Notification_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', history?: { __typename?: 'History', post: { __typename?: 'Post', id: string } } | null };

type GetNotificationPostId_Notification_InvitationNotification_Fragment = { __typename?: 'InvitationNotification' };

type GetNotificationPostId_Notification_PostNotification_Fragment = { __typename?: 'PostNotification', post?: { __typename?: 'Post', id: string } | null };

type GetNotificationPostId_Notification_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', reaction?: { __typename?: 'Reaction', thread: { __typename?: 'Thread', post: { __typename?: 'Post', id: string } } } | null };

export type GetNotificationPostId_NotificationFragment = GetNotificationPostId_Notification_CommentNotification_Fragment | GetNotificationPostId_Notification_HistoryNotification_Fragment | GetNotificationPostId_Notification_InvitationNotification_Fragment | GetNotificationPostId_Notification_PostNotification_Fragment | GetNotificationPostId_Notification_ReactionNotification_Fragment;

export type OnboardingStepInvite_ProvisionFragment = { __typename?: 'Provision', id: string, name: string, type: ProvisionType, secret: string };

export type OrganizationOnboardingStepInviteQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationOnboardingStepInviteQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, provisions: Array<{ __typename?: 'Provision', id: string, name: string, type: ProvisionType, secret: string }> } } };

export type OrgOnboardingPasswordSetQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgOnboardingPasswordSetQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', user: { __typename?: 'User', id: string, passwordUpdatedAt?: any | null } } };

export type PricingModalPlanTierQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingModalPlanTierQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, planTier?: PlanTier | null } } };

export type PricingModalBillingQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingModalBillingQuery = { __typename?: 'RootQueryType', billingPricing: { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } }, startup: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } }, business: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } } }, billingSummary: { __typename?: 'BillingSummary', trialEndAt?: any | null, plan?: { __typename?: 'BillingSummaryPlan', interval: PlanInterval } | null } };

export type PricingModalTierLabel_BillingPricingFragment = { __typename?: 'BillingPricing', free: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } }, startup: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } }, business: { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } } };

export type PricingModalTierLabelBillingTierFragment = { __typename?: 'BillingTier', yearly: { __typename?: 'BillingPlan', amount: number }, monthly: { __typename?: 'BillingPlan', amount: number } };

export type ComparePostsViewQueryVariables = Exact<{
  basePostId: Scalars['ID'];
  comparePostId: Scalars['ID'];
}>;


export type ComparePostsViewQuery = { __typename?: 'RootQueryType', basePost: { __typename?: 'Post', id: string, content: any, version: number }, comparePost: { __typename?: 'Post', id: string, content: any, version: number } };

export type CreatePostFromTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreatePostFromTemplateMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, title: string } };

export type CreateVerificationMutationVariables = Exact<{
  postId: Scalars['ID'];
  unit: VerificationUnit;
  quantity: Scalars['Int'];
  primaryVerifierId: Scalars['ID'];
  secondaryVerifierIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CreateVerificationMutation = { __typename?: 'RootMutationType', verification: { __typename?: 'Verification', id: string, post: { __typename?: 'Post', id: string, verifiedAt?: any | null, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, version: number, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } } };

export type CreateVerificationModal_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, topics: Array<{ __typename?: 'Topic', id: string }>, verification?: { __typename?: 'Verification', id: string, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null };

export type UpdateVerificationMutationVariables = Exact<{
  verificationId: Scalars['ID'];
  unit: VerificationUnit;
  quantity: Scalars['Int'];
  primaryVerifierId: Scalars['ID'];
  secondaryVerifierIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateVerificationMutation = { __typename?: 'RootMutationType', verification: { __typename?: 'Verification', id: string, post: { __typename?: 'Post', id: string, verifiedAt?: any | null, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null } } };

export type DeleteVerificationMutationVariables = Exact<{
  verificationId: Scalars['ID'];
}>;


export type DeleteVerificationMutation = { __typename?: 'RootMutationType', verification?: { __typename?: 'Verification', id: string, post: { __typename?: 'Post', id: string, verifiedAt?: any | null, verification?: { __typename?: 'Verification', id: string } | null } } | null };

export type EditVerificationModal_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', expiredAt?: any | null, verifiedAt: any, id: string }>, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, topics: Array<{ __typename?: 'Topic', id: string }>, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null };

type EmbeddedPostView_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string, content: any, version: number };

type EmbeddedPostView_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string, content: any, version: number };

export type EmbeddedPostView_PostFragment = EmbeddedPostView_Post_Post_Fragment | EmbeddedPostView_Post_PublicPost_Fragment;

export type EmbeddedPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmbeddedPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, content: any, version: number } };

export type PublicPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, title: string, content: any, version: number } };

export type ExternalPostsQueryVariables = Exact<{
  id: Scalars['String'];
  orderBy?: InputMaybe<ExternalPostsOrder>;
  filter?: InputMaybe<ExternalPostsFilter>;
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type ExternalPostsQuery = { __typename?: 'RootQueryType', platform: { __typename?: 'ExternalPostPlatform', id: string, allPostsCount: number, verifiedPostsCount: number, publishedPostsCount: number, archivedPostsCount: number, templatePostsCount: number, posts?: { __typename?: 'PostConnection', edges?: Array<{ __typename?: 'PostEdge', node?: { __typename?: 'Post', insertedAt: any, id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type IntegrationLinkRow_IntegrationLinkFragment = { __typename?: 'IntegrationLink', id: string, title?: string | null, type: MentionType, externalId: string, insertedBy: { __typename?: 'User', id: string }, preview?: { __typename?: 'Image', original?: string | null } | null };

type MagneticWall_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type MagneticWall_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

export type MagneticWall_PostFragment = MagneticWall_Post_Post_Fragment | MagneticWall_Post_PublicPost_Fragment;

type MagneticWall_Threads_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'PublicUser', id: string } | null };

type MagneticWall_Threads_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'User', id: string } | null };

export type MagneticWall_ThreadsFragment = MagneticWall_Threads_PublicThread_Fragment | MagneticWall_Threads_Thread_Fragment;

type MagneticWall_Annotations_Annotation_Fragment = { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null };

type MagneticWall_Annotations_PublicAnnotation_Fragment = { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null };

export type MagneticWall_AnnotationsFragment = MagneticWall_Annotations_Annotation_Fragment | MagneticWall_Annotations_PublicAnnotation_Fragment;

export type PostCommentThreadsQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostCommentThreadsQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, threads: Array<{ __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'User', id: string } | null }>, annotations: Array<{ __typename?: 'Annotation', id: string, content?: any | null, link?: string | null }> } };

export type PublicPostCommentThreadsQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PublicPostCommentThreadsQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, threads: Array<{ __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'PublicUser', id: string } | null }>, annotations: Array<{ __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null }> } };

export type CreateReactionMutationVariables = Exact<{
  postId: Scalars['ID'];
  version: Scalars['Int'];
  checksum: Scalars['Int'];
  mark: Scalars['Json'];
  emoji: Scalars['String'];
}>;


export type CreateReactionMutation = { __typename?: 'RootMutationType', createReaction: { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'PublicUser', id: string } | null } | { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'User', id: string } | null } };

export type AnnotationCreatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type AnnotationCreatedSubscription = { __typename?: 'RootSubscriptionType', annotation?: { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null } | { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null } | null };

export type AnnotationDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type AnnotationDeletedSubscription = { __typename?: 'RootSubscriptionType', annotation?: { __typename?: 'Annotation', id: string } | { __typename?: 'PublicAnnotation', id: string } | null };

export type AnnotationUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type AnnotationUpdatedSubscription = { __typename?: 'RootSubscriptionType', annotation?: { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null } | { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null } | null };

export type ThreadCreatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadCreatedSubscription = { __typename?: 'RootSubscriptionType', thread?: { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'PublicUser', id: string } | null } | { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, author?: { __typename?: 'User', id: string } | null } | null };

export type ThreadDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadDeletedSubscription = { __typename?: 'RootSubscriptionType', thread?: { __typename?: 'PublicThread', id: string } | { __typename?: 'Thread', id: string } | null };

export type ThreadResolvedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadResolvedSubscription = { __typename?: 'RootSubscriptionType', thread?: { __typename?: 'PublicThread', id: string } | { __typename?: 'Thread', id: string } | null };

export type ThreadRepliedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadRepliedSubscription = { __typename?: 'RootSubscriptionType', comment?: { __typename?: 'Comment', id: string, content: any, insertedAt: any, thread: { __typename?: 'Thread', id: string }, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> } | { __typename?: 'PublicComment', id: string, content: any, insertedAt: any, thread: { __typename?: 'PublicThread', id: string }, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> } | null };

export type ThreadReactedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ThreadReactedSubscription = { __typename?: 'RootSubscriptionType', reaction?: { __typename?: 'PublicReaction', id: string, emoji: string, insertedAt: any, thread: { __typename?: 'PublicThread', id: string }, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } | { __typename?: 'Reaction', id: string, emoji: string, insertedAt: any, thread: { __typename?: 'Thread', id: string }, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } | null };

export type CommentDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type CommentDeletedSubscription = { __typename?: 'RootSubscriptionType', comment?: { __typename?: 'Comment', id: string, thread: { __typename?: 'Thread', id: string } } | { __typename?: 'PublicComment', id: string, thread: { __typename?: 'PublicThread', id: string } } | null };

export type CommentUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type CommentUpdatedSubscription = { __typename?: 'RootSubscriptionType', comment?: { __typename?: 'Comment', id: string, content: any, insertedAt: any, thread: { __typename?: 'Thread', id: string }, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> } | { __typename?: 'PublicComment', id: string, content: any, insertedAt: any, thread: { __typename?: 'PublicThread', id: string }, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> } | null };

export type ReactionDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type ReactionDeletedSubscription = { __typename?: 'RootSubscriptionType', reaction?: { __typename?: 'PublicReaction', id: string, thread: { __typename?: 'PublicThread', id: string } } | { __typename?: 'Reaction', id: string, thread: { __typename?: 'Thread', id: string } } | null };

type MagneticWallItemAvatar_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type MagneticWallItemAvatar_User_User_Fragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type MagneticWallItemAvatar_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type MagneticWallItemAvatar_UserFragment = MagneticWallItemAvatar_User_PublicUser_Fragment | MagneticWallItemAvatar_User_User_Fragment | MagneticWallItemAvatar_User_VisitorUser_Fragment;

export type ReadPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  time: Scalars['Int'];
  queryId?: InputMaybe<Scalars['String']>;
  resultId?: InputMaybe<Scalars['String']>;
}>;


export type ReadPostMutation = { __typename?: 'RootMutationType', readPost: { __typename?: 'Post', id: string } };

export type PostArchivedBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostArchivedBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, type: PostType, publishedAt?: any | null, archivedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type PostBadge_PostFragment = { __typename?: 'Post', archivedAt?: any | null, publishedAt?: any | null };

export type PostBreadcrumbs_TopicFragment = { __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> };

export type PostContributorFragment = { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type PostOwnerContributorsQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostOwnerContributorsQueryQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, contributors: Array<{ __typename?: 'User', id: string, name: string, title?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, topics: Array<{ __typename?: 'Topic', id: string }>, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type PostDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
  queryId?: InputMaybe<Scalars['String']>;
  resultId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
}>;


export type PostDetailPreviewQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, content: any, version: number, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, banner?: { __typename?: 'Image', original?: string | null } | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> } };

export type PostDetailPreviewStateBar_PostFragment = { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> };

export type PostDraftBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostDraftBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, type: PostType, linkAccess: PostLinkAccess, publishedAt?: any | null } };

export type PostDraftBarPublishButton_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, type: PostType };

export type PostHistoryRedirectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostHistoryRedirectQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, isEditing?: boolean | null, version: number, title: string, lastHistory?: { __typename?: 'SlimHistory', id: string, versionFrom: number, versionTo: number } | null } };

type PostIcon_Post_Post_Fragment = { __typename?: 'Post', archivedAt?: any | null, publishedAt?: any | null, type: PostType, id: string, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

type PostIcon_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string };

type PostIcon_Post_SlimPost_Fragment = { __typename?: 'SlimPost', archivedAt?: any | null, publishedAt?: any | null, type: PostType, id: string, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null };

export type PostIcon_PostFragment = PostIcon_Post_Post_Fragment | PostIcon_Post_PublicPost_Fragment | PostIcon_Post_SlimPost_Fragment;

export type PostInsightsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostInsightsQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, insertedAt: any, updatedAt: any, publishedAt?: any | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, viewers: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, backlinks: Array<{ __typename?: 'Group', id: string, name: string } | { __typename?: 'Post', id: string, title: string, type: PostType, archivedAt?: any | null } | { __typename?: 'Topic', id: string, name: string } | { __typename?: 'User', id: string, name: string, deactivatedAt?: any | null }> } };

export type PostInsightsBacklinks_PostFragment = { __typename?: 'Post', id: string, backlinks: Array<{ __typename?: 'Group', id: string, name: string } | { __typename?: 'Post', id: string, title: string, type: PostType, archivedAt?: any | null } | { __typename?: 'Topic', id: string, name: string } | { __typename?: 'User', id: string, name: string, deactivatedAt?: any | null }> };

export type PostInsightsMetricsQueryVariables = Exact<{
  id: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  type: InsightMetricsType;
}>;


export type PostInsightsMetricsQuery = { __typename?: 'RootQueryType', insightMetrics: { __typename?: 'InsightMetrics', total: number, change?: number | null, metrics?: Array<{ __typename?: 'InsightMetric', date: any, quantity: number } | null> | null } };

export type PostOwnerSelect_PostFragment = { __typename?: 'Post', id: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type PostPill_PostFragment = { __typename?: 'Post', id: string, title: string };

type PostPreview_Post_Post_Fragment = { __typename?: 'Post', content: any, version: number };

type PostPreview_Post_PublicPost_Fragment = { __typename?: 'PublicPost', content: any, version: number };

export type PostPreview_PostFragment = PostPreview_Post_Post_Fragment | PostPreview_Post_PublicPost_Fragment;

type PostRow_Post_Post_Fragment = { __typename?: 'Post', insertedAt: any, id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

type PostRow_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'SlimSeries', id: string } | null, contributors: Array<{ __typename?: 'SlimUser', id: string }>, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null };

export type PostRow_PostFragment = PostRow_Post_Post_Fragment | PostRow_Post_SlimPost_Fragment;

export type PostSelectOption_PostFragment = { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

type PostSeriesBar_Series_PublicSeries_Fragment = { __typename?: 'PublicSeries', name: string, posts: Array<{ __typename?: 'PublicPost', id: string }> };

type PostSeriesBar_Series_Series_Fragment = { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> };

export type PostSeriesBar_SeriesFragment = PostSeriesBar_Series_PublicSeries_Fragment | PostSeriesBar_Series_Series_Fragment;

export type PostStateBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostStateBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, type: PostType, verification?: { __typename?: 'Verification', id: string, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> } };

export type PostTemplateBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostTemplateBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, linkAccess: PostLinkAccess } };

type PostTitleWithIcons_Post_Post_Fragment = { __typename?: 'Post', verifiedAt?: any | null, id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null };

type PostTitleWithIcons_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string, linkAccess: PostLinkAccess };

type PostTitleWithIcons_Post_SlimPost_Fragment = { __typename?: 'SlimPost', verifiedAt?: any | null, id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null };

export type PostTitleWithIcons_PostFragment = PostTitleWithIcons_Post_Post_Fragment | PostTitleWithIcons_Post_PublicPost_Fragment | PostTitleWithIcons_Post_SlimPost_Fragment;

export type PostVerificationExpiredBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostVerificationExpiredBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, type: PostType, archivedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null, version: number, verifiedAt: any, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null } };

export type PostVerificationRequestedBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostVerificationRequestedBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, type: PostType, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null }> } };

export type PostVerifiedBarQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostVerifiedBarQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, type: PostType, archivedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, version: number, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null } };

export type PostVerifyFooter_PostFragment = { __typename?: 'Post', id: string, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null }> };

export type PostVerifyViewQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostVerifyViewQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, isEditing?: boolean | null, version: number, title: string, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, version: number, verifiedAt: any, expiredAt?: any | null }> } };

export type PostViewQueryVariables = Exact<{
  id: Scalars['ID'];
  queryId?: InputMaybe<Scalars['String']>;
  resultId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
}>;


export type PostViewQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, version: number, content: any, linkAccess: PostLinkAccess, archivedAt?: any | null, views: number, userViewedAt?: any | null, insertedAt: any, updatedAt: any, type: PostType, verifiedAt?: any | null, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string }> } | null, externalPost?: { __typename?: 'ExternalPost', externalId: string, id: string, platform: string, editUrl: string } | null, banner?: { __typename?: 'Image', original?: string | null } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string } }>, topics: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, name: string, parent?: { __typename?: 'Topic', id: string } | null, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, contributors: Array<{ __typename?: 'User', id: string }> } };

export type PostUpdateSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostUpdateSubscription = { __typename?: 'RootSubscriptionType', postUpdated?: { __typename?: 'Post', id: string, publishedAt?: any | null, archivedAt?: any | null } | null };

export type PostDeletedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostDeletedSubscription = { __typename?: 'RootSubscriptionType', post?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> } | null };

export type PostViewBannerEditor_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, externalPost?: { __typename?: 'ExternalPost', externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UpdatePostBannerMutationVariables = Exact<{
  postId: Scalars['ID'];
  banner?: InputMaybe<Scalars['Upload']>;
  unsplashId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePostBannerMutation = { __typename?: 'RootMutationType', updatePost: { __typename?: 'Post', id: string, banner?: { __typename?: 'Image', original?: string | null } | null } };

export type PresenceAvatar_UserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type PresenceAvatarStack_UserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type PublicPostFieldsFragment = { __typename?: 'PublicPost', id: string, title: string, content: any, version: number, series?: { __typename?: 'PublicSeries', id: string, name: string, posts: Array<{ __typename?: 'PublicPost', id: string, title: string }> } | null, banner?: { __typename?: 'Image', original?: string | null } | null, topics: Array<{ __typename?: 'PublicTopic', id: string, name: string, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string }> }> };

export type PublicPostViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicPostViewQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, linkAccess: PostLinkAccess, title: string, version: number, content: any, series?: { __typename?: 'PublicSeries', id: string, name: string, posts: Array<{ __typename?: 'PublicPost', id: string, title: string }> } | null, banner?: { __typename?: 'Image', original?: string | null } | null, topics: Array<{ __typename?: 'PublicTopic', id: string, name: string, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string }> }> } };

export type VerificationEntries_VerificationEntriesFragment = { __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type VerificationEntry_VerificationEntryFragment = { __typename?: 'VerificationEntry', verifiedAt: any, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type VerificationVerifiersFields_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, topics: Array<{ __typename?: 'Topic', id: string }>, verification?: { __typename?: 'Verification', id: string, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null };

export type VerifyHistoryMenuItem_PostFragment = { __typename?: 'Post', id: string, title: string, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, version: number }> };

export type VerifyMenuItems_PostFragment = { __typename?: 'Post', archivedAt?: any | null, id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, title: string, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, topics: Array<{ __typename?: 'Topic', id: string }>, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null, version: number }>, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null };

export type VerifyPostModal_PostFragment = { __typename?: 'Post', id: string, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null }> };

export type VerifyPostMutationVariables = Exact<{
  verificationId: Scalars['ID'];
}>;


export type VerifyPostMutation = { __typename?: 'RootMutationType', verificationEntry: { __typename?: 'VerificationEntry', id: string, post: { __typename?: 'Post', id: string, verifiedAt?: any | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null, verifier: { __typename?: 'User', id: string, name: string, title?: string | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> } } };

export type PostFavoriteButtonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostFavoriteButtonQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> } };

export type FavoritePostMutationVariables = Exact<{
  id: Scalars['ID'];
  add?: InputMaybe<Scalars['Boolean']>;
}>;


export type FavoritePostMutation = { __typename?: 'RootMutationType', favoritePost: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> } };

export type ThankPostFieldsFragment = { __typename?: 'Post', id: string, thanks: number, thankers: Array<{ __typename?: 'User', id: string, name: string }> };

export type ThankPostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ThankPostMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, thanks: number, thankers: Array<{ __typename?: 'User', id: string, name: string }> } };

export type UnthankPostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnthankPostMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, thanks: number, thankers: Array<{ __typename?: 'User', id: string, name: string }> } };

export type ThankButtonQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ThankButtonQueryQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', publishedAt?: any | null, id: string, thanks: number, thankers: Array<{ __typename?: 'User', id: string, name: string }> } };

type Annotation_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type Annotation_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type Annotation_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type Annotation_PostFragment = Annotation_Post_Post_Fragment | Annotation_Post_PublicPost_Fragment | Annotation_Post_SlimPost_Fragment;

type Annotation_Annotation_Annotation_Fragment = { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null };

type Annotation_Annotation_PublicAnnotation_Fragment = { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null };

export type Annotation_AnnotationFragment = Annotation_Annotation_Annotation_Fragment | Annotation_Annotation_PublicAnnotation_Fragment;

type AnnotationCreate_Annotation_Annotation_Fragment = { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null };

type AnnotationCreate_Annotation_PublicAnnotation_Fragment = { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null };

export type AnnotationCreate_AnnotationFragment = AnnotationCreate_Annotation_Annotation_Fragment | AnnotationCreate_Annotation_PublicAnnotation_Fragment;

export type CreateAnnotationMutationVariables = Exact<{
  checksum: Scalars['Int'];
  content: Scalars['Json'];
  link?: InputMaybe<Scalars['String']>;
  mark: Scalars['Json'];
  postId: Scalars['ID'];
  version: Scalars['Int'];
}>;


export type CreateAnnotationMutation = { __typename?: 'RootMutationType', createAnnotation: { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null } | { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null } };

type AnnotationPreview_Annotation_Annotation_Fragment = { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null };

type AnnotationPreview_Annotation_PublicAnnotation_Fragment = { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null };

export type AnnotationPreview_AnnotationFragment = AnnotationPreview_Annotation_Annotation_Fragment | AnnotationPreview_Annotation_PublicAnnotation_Fragment;

type AnnotationSheet_Annotation_Annotation_Fragment = { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null };

type AnnotationSheet_Annotation_PublicAnnotation_Fragment = { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null };

export type AnnotationSheet_AnnotationFragment = AnnotationSheet_Annotation_Annotation_Fragment | AnnotationSheet_Annotation_PublicAnnotation_Fragment;

export type DeleteAnnotationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAnnotationMutation = { __typename?: 'RootMutationType', deleteAnnotation: { __typename?: 'Annotation', id: string } | { __typename?: 'PublicAnnotation', id: string } };

export type UpdateAnnotationMutationVariables = Exact<{
  id: Scalars['ID'];
  content?: InputMaybe<Scalars['Json']>;
  link?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAnnotationMutation = { __typename?: 'RootMutationType', updateAnnotation: { __typename?: 'Annotation', id: string, content?: any | null, link?: string | null } | { __typename?: 'PublicAnnotation', id: string, content?: any | null, link?: string | null } };

type Comment_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type Comment_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type Comment_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type Comment_PostFragment = Comment_Post_Post_Fragment | Comment_Post_PublicPost_Fragment | Comment_Post_SlimPost_Fragment;

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCommentMutation = { __typename?: 'RootMutationType', deleteComment: { __typename?: 'Comment', id: string } | { __typename?: 'PublicComment', id: string } };

export type DeleteThreadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'PublicThread', id: string } | { __typename?: 'Thread', id: string } };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  content: Scalars['String'];
}>;


export type UpdateCommentMutation = { __typename?: 'RootMutationType', updateComment: { __typename?: 'Comment', id: string, content: any } | { __typename?: 'PublicComment', id: string, content: any } };

type Comment_Comment_Comment_Fragment = { __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> };

type Comment_Comment_PublicComment_Fragment = { __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> };

export type Comment_CommentFragment = Comment_Comment_Comment_Fragment | Comment_Comment_PublicComment_Fragment;

export type CreateCommentReactionMutationVariables = Exact<{
  commentId: Scalars['ID'];
  emoji: Scalars['String'];
}>;


export type CreateCommentReactionMutation = { __typename?: 'RootMutationType', commentReaction: { __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } } | { __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } } };

export type DeleteCommentReactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCommentReactionMutation = { __typename?: 'RootMutationType', commentReaction: { __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } } | { __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } } };

export type UpdateCommentReactionQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type UpdateCommentReactionQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, threads: Array<{ __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, reactions: Array<{ __typename?: 'CommentReaction', id: string }> }> }> } };

type CommentAuthor_Author_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string };

type CommentAuthor_Author_User_Fragment = { __typename?: 'User', id: string, name: string };

type CommentAuthor_Author_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string };

export type CommentAuthor_AuthorFragment = CommentAuthor_Author_PublicUser_Fragment | CommentAuthor_Author_User_Fragment | CommentAuthor_Author_VisitorUser_Fragment;

export type CommentCreateQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type CommentCreateQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type AddCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  content: Scalars['String'];
  notifyGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddCommentMutation = { __typename?: 'RootMutationType', addComment: { __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> } | { __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> } };

export type AddCommentQueryQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type AddCommentQueryQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, threads: Array<{ __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string }> }> } };

export type CreateCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  version: Scalars['Int'];
  checksum: Scalars['Int'];
  mark: Scalars['Json'];
  content: Scalars['String'];
  notifyGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCommentMutation = { __typename?: 'RootMutationType', createComment: { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'PublicReaction', id: string }> } | { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, reactions: Array<{ __typename?: 'Reaction', id: string }> } };

type CommentCreate_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, author?: { __typename?: 'PublicUser', id: string } | null };

type CommentCreate_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, author?: { __typename?: 'User', id: string } | null };

export type CommentCreate_ThreadFragment = CommentCreate_Thread_PublicThread_Fragment | CommentCreate_Thread_Thread_Fragment;

export type CommentHistory_PostFragment = { __typename?: 'Post', id: string, title: string };

export type HistoricalThreadsQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type HistoricalThreadsQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, threads: Array<{ __typename?: 'Thread', id: string, resolvedAt?: any | null, context?: any | null, resolver?: { __typename?: 'User', id: string, name: string } | null, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> }> } };

export type CommentHistoryViewPostQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CommentHistoryViewPostQueryQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, content: any, version: number } };

type CommentReactionList_Reactions_CommentReaction_Fragment = { __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } };

type CommentReactionList_Reactions_PublicCommentReaction_Fragment = { __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } };

export type CommentReactionList_ReactionsFragment = CommentReactionList_Reactions_CommentReaction_Fragment | CommentReactionList_Reactions_PublicCommentReaction_Fragment;

type CommentThread_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type CommentThread_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type CommentThread_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type CommentThread_PostFragment = CommentThread_Post_Post_Fragment | CommentThread_Post_PublicPost_Fragment | CommentThread_Post_SlimPost_Fragment;

type CommentThread_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, author?: { __typename?: 'PublicUser', id: string } | null };

type CommentThread_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, author?: { __typename?: 'User', id: string } | null };

export type CommentThread_ThreadFragment = CommentThread_Thread_PublicThread_Fragment | CommentThread_Thread_Thread_Fragment;

type CommentThreadCompact_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type CommentThreadCompact_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type CommentThreadCompact_ThreadFragment = CommentThreadCompact_Thread_PublicThread_Fragment | CommentThreadCompact_Thread_Thread_Fragment;

type CommentThreadCompactAvatar_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type CommentThreadCompactAvatar_User_User_Fragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type CommentThreadCompactAvatar_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type CommentThreadCompactAvatar_UserFragment = CommentThreadCompactAvatar_User_PublicUser_Fragment | CommentThreadCompactAvatar_User_User_Fragment | CommentThreadCompactAvatar_User_VisitorUser_Fragment;

type CommentThreadCompactAvatarStack_Comment_Comment_Fragment = { __typename?: 'Comment', id: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

type CommentThreadCompactAvatarStack_Comment_PublicComment_Fragment = { __typename?: 'PublicComment', id: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type CommentThreadCompactAvatarStack_CommentFragment = CommentThreadCompactAvatarStack_Comment_Comment_Fragment | CommentThreadCompactAvatarStack_Comment_PublicComment_Fragment;

type CommentThreadFull_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type CommentThreadFull_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type CommentThreadFull_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type CommentThreadFull_PostFragment = CommentThreadFull_Post_Post_Fragment | CommentThreadFull_Post_PublicPost_Fragment | CommentThreadFull_Post_SlimPost_Fragment;

type CommentThreadFull_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, author?: { __typename?: 'PublicUser', id: string } | null };

type CommentThreadFull_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, author?: { __typename?: 'User', id: string } | null };

export type CommentThreadFull_ThreadFragment = CommentThreadFull_Thread_PublicThread_Fragment | CommentThreadFull_Thread_Thread_Fragment;

type CommentThreadMinimized_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type CommentThreadMinimized_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type CommentThreadMinimized_ThreadFragment = CommentThreadMinimized_Thread_PublicThread_Fragment | CommentThreadMinimized_Thread_Thread_Fragment;

type CommentThreadSheet_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type CommentThreadSheet_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type CommentThreadSheet_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type CommentThreadSheet_PostFragment = CommentThreadSheet_Post_Post_Fragment | CommentThreadSheet_Post_PublicPost_Fragment | CommentThreadSheet_Post_SlimPost_Fragment;

type CommentThreadSheet_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string, content: any, insertedAt: any, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string } }> }>, author?: { __typename?: 'PublicUser', id: string } | null };

type CommentThreadSheet_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, reactions: Array<{ __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string } }> }>, author?: { __typename?: 'User', id: string } | null };

export type CommentThreadSheet_ThreadFragment = CommentThreadSheet_Thread_PublicThread_Fragment | CommentThreadSheet_Thread_Thread_Fragment;

export type HistoricalComment_CommentFragment = { __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type HistoricalCommentThread_ThreadFragment = { __typename?: 'Thread', id: string, resolvedAt?: any | null, context?: any | null, resolver?: { __typename?: 'User', id: string, name: string } | null, comments: Array<{ __typename?: 'Comment', id: string, content: any, insertedAt: any, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionAvatar_Reaction_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

type ReactionAvatar_Reaction_Reaction_Fragment = { __typename?: 'Reaction', id: string, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type ReactionAvatar_ReactionFragment = ReactionAvatar_Reaction_PublicReaction_Fragment | ReactionAvatar_Reaction_Reaction_Fragment;

type ReactionAvatarStack_Reaction_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

type ReactionAvatarStack_Reaction_Reaction_Fragment = { __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type ReactionAvatarStack_ReactionFragment = ReactionAvatarStack_Reaction_PublicReaction_Fragment | ReactionAvatarStack_Reaction_Reaction_Fragment;

type ReactionThread_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, author?: { __typename?: 'PublicUser', id: string } | null, comments: Array<{ __typename?: 'PublicComment', id: string }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionThread_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, author?: { __typename?: 'User', id: string } | null, comments: Array<{ __typename?: 'Comment', id: string }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ReactionThread_ThreadFragment = ReactionThread_Thread_PublicThread_Fragment | ReactionThread_Thread_Thread_Fragment;

type ReactionThreadCompact_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionThreadCompact_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ReactionThreadCompact_ThreadFragment = ReactionThreadCompact_Thread_PublicThread_Fragment | ReactionThreadCompact_Thread_Thread_Fragment;

type ReactionThreadFull_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, author?: { __typename?: 'PublicUser', id: string } | null, comments: Array<{ __typename?: 'PublicComment', id: string }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionThreadFull_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, author?: { __typename?: 'User', id: string } | null, comments: Array<{ __typename?: 'Comment', id: string }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ReactionThreadFull_ThreadFragment = ReactionThreadFull_Thread_PublicThread_Fragment | ReactionThreadFull_Thread_Thread_Fragment;

type ReactionThreadMinimized_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionThreadMinimized_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ReactionThreadMinimized_ThreadFragment = ReactionThreadMinimized_Thread_PublicThread_Fragment | ReactionThreadMinimized_Thread_Thread_Fragment;

type ReactionThreadSheet_Thread_PublicThread_Fragment = { __typename?: 'PublicThread', id: string, comments: Array<{ __typename?: 'PublicComment', id: string }>, reactions: Array<{ __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

type ReactionThreadSheet_Thread_Thread_Fragment = { __typename?: 'Thread', id: string, comments: Array<{ __typename?: 'Comment', id: string }>, reactions: Array<{ __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } }> };

export type ReactionThreadSheet_ThreadFragment = ReactionThreadSheet_Thread_PublicThread_Fragment | ReactionThreadSheet_Thread_Thread_Fragment;

type ThreadReactionList_Reactions_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

type ThreadReactionList_Reactions_Reaction_Fragment = { __typename?: 'Reaction', id: string, insertedAt: any, emoji: string, author: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type ThreadReactionList_ReactionsFragment = ThreadReactionList_Reactions_PublicReaction_Fragment | ThreadReactionList_Reactions_Reaction_Fragment;

type GroupReactions_CommentReactions_CommentReaction_Fragment = { __typename?: 'CommentReaction', id: string, emoji: string, author: { __typename?: 'User', id: string } };

type GroupReactions_CommentReactions_PublicCommentReaction_Fragment = { __typename?: 'PublicCommentReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string } };

export type GroupReactions_CommentReactionsFragment = GroupReactions_CommentReactions_CommentReaction_Fragment | GroupReactions_CommentReactions_PublicCommentReaction_Fragment;

type GroupReactions_ThreadReactions_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, emoji: string, author: { __typename?: 'PublicUser', id: string } };

type GroupReactions_ThreadReactions_Reaction_Fragment = { __typename?: 'Reaction', id: string, emoji: string, author: { __typename?: 'User', id: string } };

export type GroupReactions_ThreadReactionsFragment = GroupReactions_ThreadReactions_PublicReaction_Fragment | GroupReactions_ThreadReactions_Reaction_Fragment;

type AddReaction_PublicReaction_Fragment = { __typename?: 'PublicReaction', id: string, emoji: string };

type AddReaction_Reaction_Fragment = { __typename?: 'Reaction', id: string, emoji: string };

export type AddReactionFragment = AddReaction_PublicReaction_Fragment | AddReaction_Reaction_Fragment;

export type AddReactionMutationVariables = Exact<{
  emoji: Scalars['String'];
  threadId: Scalars['ID'];
}>;


export type AddReactionMutation = { __typename?: 'RootMutationType', addReaction: { __typename?: 'PublicReaction', id: string, emoji: string } | { __typename?: 'Reaction', id: string, emoji: string } };

export type DeleteReactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReactionMutation = { __typename?: 'RootMutationType', deleteReaction: { __typename?: 'PublicReaction', id: string } | { __typename?: 'Reaction', id: string } };

export type DeleteReactionThreadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReactionThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'PublicThread', id: string } | { __typename?: 'Thread', id: string } };

export type GetVerificationStatus_PostFragment = { __typename?: 'Post', verification?: { __typename?: 'Verification', id: string, insertedAt: any } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, expiredAt?: any | null }> };

export type HistoryRow_AuthorsFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UpdatePostContentMutationVariables = Exact<{
  id: Scalars['ID'];
  delta: Scalars['Json'];
  version: Scalars['Int'];
  checksum: Scalars['Int'];
}>;


export type UpdatePostContentMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string } };

export type PostHistoryContentQueryVariables = Exact<{
  postId: Scalars['ID'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
}>;


export type PostHistoryContentQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, content: any, version: number, title: string, history?: { __typename?: 'History', id: string, snapshot: any, delta: any } | null } };

export type HistorySidebarPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HistorySidebarPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, publishedAt?: any | null } };

export type PostHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostHistoryQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, publishedAt?: any | null, updatedAt: any, isEditing?: boolean | null, content: any, version: number, linkAccess: PostLinkAccess, histories: Array<{ __typename?: 'SlimHistory', id: string, insertedAt: any, versionFrom: number, versionTo: number, authors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> }>, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type PostHistoryViewQueryVariables = Exact<{
  postId: Scalars['ID'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
}>;


export type PostHistoryViewQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, history?: { __typename?: 'History', id: string, insertedAt: any } | null } };

export type VersionChangesWrapper_PostFragment = { __typename?: 'Post', id: string, title: string };

export type HistoryVersionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HistoryVersionQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, histories: Array<{ __typename?: 'SlimHistory', id: string, insertedAt: any, versionFrom: number, versionTo: number }> } };

type VersionChangesWallAuthorCard_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type VersionChangesWallAuthorCard_User_User_Fragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type VersionChangesWallAuthorCard_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type VersionChangesWallAuthorCard_UserFragment = VersionChangesWallAuthorCard_User_PublicUser_Fragment | VersionChangesWallAuthorCard_User_User_Fragment | VersionChangesWallAuthorCard_User_VisitorUser_Fragment;

export type VersionChangesWallAuthorCard_HistoryFragment = { __typename?: 'SlimHistory', id: string, insertedAt: any, versionFrom: number, versionTo: number };

export type VersionChangesWallAuthorCard_PostFragment = { __typename?: 'Post', id: string, title: string };

export type GetVersionChangesWithContent_HistoryFragment = { __typename?: 'History', id: string, snapshot: any, diff: any };

export type HistoryRangeQueryVariables = Exact<{
  postId: Scalars['ID'];
  versionFrom: Scalars['Int'];
  versionTo: Scalars['Int'];
}>;


export type HistoryRangeQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, history?: { __typename?: 'History', id: string, snapshot: any, diff: any } | null } };

type PopulatePostsWithFullTopics_Posts_Post_Fragment = { __typename?: 'Post', topics: Array<{ __typename?: 'Topic', id: string }> };

type PopulatePostsWithFullTopics_Posts_SlimPost_Fragment = { __typename?: 'SlimPost', topics: Array<{ __typename?: 'SlimTopic', id: string }> };

export type PopulatePostsWithFullTopics_PostsFragment = PopulatePostsWithFullTopics_Posts_Post_Fragment | PopulatePostsWithFullTopics_Posts_SlimPost_Fragment;

type PostPolicyCheck_Post_ExcludeTopics_Post_Fragment = { __typename?: 'Post', linkAccess: PostLinkAccess, publishedAt?: any | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

type PostPolicyCheck_Post_ExcludeTopics_SlimPost_Fragment = { __typename?: 'SlimPost', linkAccess: PostLinkAccess, publishedAt?: any | null };

export type PostPolicyCheck_Post_ExcludeTopicsFragment = PostPolicyCheck_Post_ExcludeTopics_Post_Fragment | PostPolicyCheck_Post_ExcludeTopics_SlimPost_Fragment;

type IsAllowedThroughLinkAccess_Post_Post_Fragment = { __typename?: 'Post', publishedAt?: any | null, linkAccess: PostLinkAccess };

type IsAllowedThroughLinkAccess_Post_PublicPost_Fragment = { __typename?: 'PublicPost', linkAccess: PostLinkAccess };

type IsAllowedThroughLinkAccess_Post_SlimPost_Fragment = { __typename?: 'SlimPost', publishedAt?: any | null, linkAccess: PostLinkAccess };

export type IsAllowedThroughLinkAccess_PostFragment = IsAllowedThroughLinkAccess_Post_Post_Fragment | IsAllowedThroughLinkAccess_Post_PublicPost_Fragment | IsAllowedThroughLinkAccess_Post_SlimPost_Fragment;

export type IsAllowedThroughGroupSharing_PostFragment = { __typename?: 'Post', id: string, sharing?: { __typename?: 'PostDirectShare', editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null };

export type IsAllowedThroughGroupSharing_UserFragment = { __typename?: 'User', id: string, membershipGroups: Array<{ __typename?: 'Group', id: string }> };

type PostPolicyCheck_Post_Post_Fragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

type PostPolicyCheck_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null };

export type PostPolicyCheck_PostFragment = PostPolicyCheck_Post_Post_Fragment | PostPolicyCheck_Post_SlimPost_Fragment;

export type PostPolicyCheck_PublicPostFragment = { __typename?: 'PublicPost', id: string, linkAccess: PostLinkAccess };

export type IsVerifier_PostFragment = { __typename?: 'Post', verification?: { __typename?: 'Verification', id: string, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null };

type UsePostPolicyCheck_Post_Post_Fragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

type UsePostPolicyCheck_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'SlimTopic', id: string }> };

export type UsePostPolicyCheck_PostFragment = UsePostPolicyCheck_Post_Post_Fragment | UsePostPolicyCheck_Post_SlimPost_Fragment;

type PaginationItem_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type PaginationItem_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

export type PaginationItem_PostFragment = PaginationItem_Post_Post_Fragment | PaginationItem_Post_PublicPost_Fragment;

type PostSeriesFooter_Series_PublicSeries_Fragment = { __typename?: 'PublicSeries', posts: Array<{ __typename?: 'PublicPost', id: string, title: string }> };

type PostSeriesFooter_Series_Series_Fragment = { __typename?: 'Series', posts: Array<{ __typename?: 'Post', id: string, title: string }> };

export type PostSeriesFooter_SeriesFragment = PostSeriesFooter_Series_PublicSeries_Fragment | PostSeriesFooter_Series_Series_Fragment;

type PostSeriesMeta_Series_PublicSeries_Fragment = { __typename?: 'PublicSeries', name: string, posts: Array<{ __typename?: 'PublicPost', id: string }> };

type PostSeriesMeta_Series_Series_Fragment = { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> };

export type PostSeriesMeta_SeriesFragment = PostSeriesMeta_Series_PublicSeries_Fragment | PostSeriesMeta_Series_Series_Fragment;

export type SharingDropdown_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, title: string, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, topics: Array<{ __typename?: 'Topic', id: string }>, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type SharingDropdownQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type SharingDropdownQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string }>, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, verification?: { __typename?: 'Verification', id: string } | null } };

export type SharingDropdownAccessList_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, topics: Array<{ __typename?: 'Topic', id: string }>, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type SharingDropdownAddSelect_PostFragment = { __typename?: 'Post', id: string, title: string, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, topics: Array<{ __typename?: 'Topic', id: string }> };

export type SharingDropdownLink_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type GetRemoveTopicDisabledMessage_TopicFragment = { __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type GetRemoveTopicDisabledMessage_PostFragment = { __typename?: 'Post', id: string, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }> };

export type UpdatePostSharingCacheQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type UpdatePostSharingCacheQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null } };

export type PostPermissionOperationsPostViewersQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostPermissionOperationsPostViewersQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, viewers: Array<{ __typename?: 'User', name: string, title?: string | null, id: string, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } };

export type UpdatePostLinkAccessMutationVariables = Exact<{
  postId: Scalars['ID'];
  linkAccess: PostLinkAccess;
}>;


export type UpdatePostLinkAccessMutation = { __typename?: 'RootMutationType', updatePost: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess } };

export type UpdateUserInPostMutationVariables = Exact<{
  userId: Scalars['ID'];
  postId: Scalars['ID'];
  role: PostShareRole;
}>;


export type UpdateUserInPostMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string } };

export type AddUserToPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AddUserToPostMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string } };

export type RemoveUserFromPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveUserFromPostMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string } };

export type AddTopicToPostTopicFragment = { __typename?: 'Topic', id: string };

export type AddTopicToPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
}>;


export type AddTopicToPostMutation = { __typename?: 'RootMutationType', topic: { __typename?: 'Topic', id: string } };

export type RemoveTopicFromPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
}>;


export type RemoveTopicFromPostMutation = { __typename?: 'RootMutationType', topic: { __typename?: 'Topic', id: string } };

export type AddGroupToPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  groupId: Scalars['ID'];
}>;


export type AddGroupToPostMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string } };

export type RemoveGroupFromPostMutationVariables = Exact<{
  postId: Scalars['ID'];
  groupId: Scalars['ID'];
}>;


export type RemoveGroupFromPostMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string } };

export type UpdateGroupInPostMutationVariables = Exact<{
  groupId: Scalars['ID'];
  postId: Scalars['ID'];
  role: PostShareRole;
}>;


export type UpdateGroupInPostMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string } };

export type UpdatePostOwnerMutationVariables = Exact<{
  id: Scalars['ID'];
  ownerId: Scalars['ID'];
}>;


export type UpdatePostOwnerMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, owner: { __typename?: 'User', id: string, name: string } } };

export type UseConfirmThenMutate_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseUpdatePostLinkAccess_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseUpdatePostUser_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseRemovePostUser_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseAddPostUser_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseRemoveTopicFromPost_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseRemoveGroupFromPost_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseUpdatePostGroup_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type UseUpdatePostOwner_PostFragment = { __typename?: 'Post', verifiedAt?: any | null, id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type PostUserAddedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostUserAddedSubscription = { __typename?: 'RootSubscriptionType', postUserAdded?: { __typename?: 'PostShareSubscription', role?: PostShareRole | null, user?: { __typename?: 'User', id: string } | null } | null };

export type PostUserRemovedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostUserRemovedSubscription = { __typename?: 'RootSubscriptionType', postUserRemoved?: { __typename?: 'PostShareSubscription', user?: { __typename?: 'User', id: string } | null } | null };

export type PostUserUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostUserUpdatedSubscription = { __typename?: 'RootSubscriptionType', postUserUpdated?: { __typename?: 'PostShareSubscription', role?: PostShareRole | null, user?: { __typename?: 'User', id: string } | null } | null };

export type PostGroupAddedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostGroupAddedSubscription = { __typename?: 'RootSubscriptionType', postGroupAdded?: { __typename?: 'PostGroupShareSubscription', role?: PostShareRole | null, group?: { __typename?: 'Group', id: string } | null } | null };

export type PostGroupRemovedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostGroupRemovedSubscription = { __typename?: 'RootSubscriptionType', postGroupRemoved?: { __typename?: 'PostGroupShareSubscription', group?: { __typename?: 'Group', id: string } | null } | null };

export type PostGroupUpdatedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostGroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', postGroupUpdated?: { __typename?: 'PostGroupShareSubscription', role?: PostShareRole | null, group?: { __typename?: 'Group', id: string } | null } | null };

export type CopyEmbedMenuItem_PostFragment = { __typename?: 'Post', id: string, title: string };

export type DuplicatePostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicatePostMutation = { __typename?: 'RootMutationType', duplicatePost: { __typename?: 'Post', id: string, title: string } };

export type PostEditButton_PostFragment = { __typename?: 'Post', id: string, publishedAt?: any | null };

export type PostEditButtonMenuQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostEditButtonMenuQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, archivedAt?: any | null, title: string, type: PostType, linkAccess: PostLinkAccess, externalPost?: { __typename?: 'ExternalPost', id: string } | null, series?: { __typename?: 'Series', id: string } | null, banner?: { __typename?: 'Image', original?: string | null } | null, topics: Array<{ __typename?: 'Topic', id: string }>, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any, primaryVerifier: { __typename?: 'User', id: string }, secondaryVerifiers: Array<{ __typename?: 'User', id: string } | null> } | null, backlinks: Array<{ __typename?: 'Group', id: string, name: string } | { __typename?: 'Post', id: string, title: string, type: PostType, archivedAt?: any | null } | { __typename?: 'Topic', id: string, name: string } | { __typename?: 'User', id: string, name: string, deactivatedAt?: any | null }>, owner: { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, verifiedAt: any, expiredAt?: any | null, version: number }> } };

export type PostLastEdited_PostFragment = { __typename?: 'Post', version: number, content: any, updatedAt: any, externalPost?: { __typename?: 'ExternalPost', id: string } | null };

export type PostLastEdited_LastHistoryFragment = { __typename?: 'SlimHistory', id: string, insertedAt: any, versionTo: number, authors: Array<{ __typename?: 'User', id: string, name: string }> };

export type TemplatizeMenuItem_PostFragment = { __typename?: 'Post', id: string, type: PostType };

export type UpdatePostTypeMutationVariables = Exact<{
  postId: Scalars['ID'];
  type: PostType;
}>;


export type UpdatePostTypeMutation = { __typename?: 'RootMutationType', updatePost: { __typename?: 'Post', id: string, type: PostType } };

export type PostTopicAdd_TopicFragment = { __typename?: 'Topic', id: string };

export type PostTopicBar_PostFragment = { __typename?: 'Post', id: string, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }> };

export type PostTopicBarEditingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostTopicBarEditingQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } };

export type PostTopicListWithBreadcrumbs_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type PostTopicListWithBreadcrumbs_PostFragment = { __typename?: 'Post', id: string, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }> };

export type PostTopicWithBreadcrumbs_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type PostTopicWithBreadcrumbs_PostFragment = { __typename?: 'Post', id: string, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }> };

type AllSlimPostFields_Post_Fragment = { __typename?: 'Post', id: string, title: string, type: PostType, archivedAt?: any | null, views: number, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner: { __typename?: 'User', id: string }, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string }>, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

type AllSlimPostFields_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string, type: PostType, archivedAt?: any | null, views: number, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner?: { __typename?: 'SlimUser', id: string } | null, series?: { __typename?: 'SlimSeries', id: string } | null, topics: Array<{ __typename?: 'SlimTopic', id: string }>, contributors: Array<{ __typename?: 'SlimUser', id: string }>, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null };

export type AllSlimPostFieldsFragment = AllSlimPostFields_Post_Fragment | AllSlimPostFields_SlimPost_Fragment;

export type AllSlimPostsFragment = { __typename?: 'SlimPost', id: string, title: string, type: PostType, archivedAt?: any | null, views: number, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner?: { __typename?: 'SlimUser', id: string } | null, series?: { __typename?: 'SlimSeries', id: string } | null, topics: Array<{ __typename?: 'SlimTopic', id: string }>, contributors: Array<{ __typename?: 'SlimUser', id: string }>, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null };

export type AllSlimPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSlimPostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, posts: Array<{ __typename?: 'SlimPost', id: string, title: string, type: PostType, archivedAt?: any | null, views: number, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner?: { __typename?: 'SlimUser', id: string } | null, series?: { __typename?: 'SlimSeries', id: string } | null, topics: Array<{ __typename?: 'SlimTopic', id: string }>, contributors: Array<{ __typename?: 'SlimUser', id: string }>, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null }> } } };

export type PostTopicIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostTopicIdsQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, topics: Array<{ __typename?: 'Topic', id: string }> } };

export type PostTopicIdAddedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostTopicIdAddedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string } | null };

export type PostTopicIdRemovedSubscriptionVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostTopicIdRemovedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string } | null };

export type DeletePostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostMutation = { __typename?: 'RootMutationType', deletePost?: { __typename?: 'Post', id: string } | null };

export type PostFavoriteAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PostFavoriteAddedSubscription = { __typename?: 'RootSubscriptionType', post?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> } | null };

export type PostFavoriteRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PostFavoriteRemovedSubscription = { __typename?: 'RootSubscriptionType', post?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, inheritedAncestors: Array<{ __typename?: 'Topic', id: string }> }> } | null };

export type UsePublishPostCachedPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UsePublishPostCachedPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', topics: Array<{ __typename?: 'Topic', id: string }> } };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['ID'];
  published: Scalars['Boolean'];
}>;


export type UpdatePostMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string }> } };

export type UseStartReverification_PostFragment = { __typename?: 'Post', id: string, title: string, verificationEntries: Array<{ __typename?: 'VerificationEntry', id: string, version: number, verifiedAt: any, expiredAt?: any | null }>, verification?: { __typename?: 'Verification', id: string, unit: VerificationUnit, quantity: number, insertedAt: any } | null };

type UseToggleArchived_Post_Post_Fragment = { __typename?: 'Post', id: string, archivedAt?: any | null, title: string, publishedAt?: any | null };

type UseToggleArchived_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, archivedAt?: any | null, title: string, publishedAt?: any | null };

export type UseToggleArchived_PostFragment = UseToggleArchived_Post_Post_Fragment | UseToggleArchived_Post_SlimPost_Fragment;

export type ArchivePostMutationVariables = Exact<{
  id: Scalars['ID'];
  archived: Scalars['Boolean'];
}>;


export type ArchivePostMutation = { __typename?: 'RootMutationType', post: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, archiver?: { __typename?: 'User', id: string, name: string } | null } };

type ReplacePostPath_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type ReplacePostPath_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

export type ReplacePostPath_PostFragment = ReplacePostPath_Post_Post_Fragment | ReplacePostPath_Post_PublicPost_Fragment;

export type CommentResultCard_CommentFragment = { __typename?: 'Comment', insertedAt: any, author: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } };

export type EncourageInstallationPlatform_PlatformFragment = { __typename?: 'ExternalSearchPlatform', platform: string, personalAuthUrl?: string | null, teamAuthUrl?: string | null };

export type ExternalSearchPreview_PreviewFragment = { __typename?: 'MentionPreview', content?: any | null, imageUrl?: string | null };

export type ExternalSearchPreviewQueryVariables = Exact<{
  externalId: Scalars['String'];
  platform: Scalars['String'];
}>;


export type ExternalSearchPreviewQuery = { __typename?: 'RootQueryType', externalSearchPreview?: { __typename?: 'MentionPreview', imageUrl?: string | null, content?: any | null } | null };

export type GoogleImportMutationVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GoogleImportMutation = { __typename?: 'RootMutationType', importExternal: { __typename?: 'Post', id: string, title: string } };

export type GoogleDrivePickerQueryVariables = Exact<{
  redirectPath: Scalars['String'];
}>;


export type GoogleDrivePickerQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', user: { __typename?: 'User', googleDrivePickerAccessToken: { __typename?: 'ExternalAccessToken', authorizationUrl: string, publishableKey: string, token?: string | null } } } };

export type PostResultCard_PostFragment = { __typename?: 'Post', id: string, views: number, thanks: number, updatedAt: any, publishedAt?: any | null, userViewedAt?: any | null, title: string, archivedAt?: any | null, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type PostResultCard_AncestorsFragment = { __typename?: 'AncestorSearchResult', id: string, name: string };

export type RemoveExternalSearchMutationVariables = Exact<{
  platform: Scalars['String'];
}>;


export type RemoveExternalSearchMutation = { __typename?: 'RootMutationType', removeExternalSearch?: boolean | null };

export type SearchManagePlatformButton_PlatformsFragment = { __typename?: 'ExternalSearchPlatform', personalAuthorized: boolean, teamAuthorized: boolean, installModes: Array<ExternalSearchMode>, personalAuthUrl?: string | null, platform: string, teamAuthUrl?: string | null };

export type SearchPlatformExternalPlatformTabQueryVariables = Exact<{
  platform: Scalars['String'];
  query: Scalars['String'];
}>;


export type SearchPlatformExternalPlatformTabQuery = { __typename?: 'RootQueryType', externalSearch: Array<{ __typename?: 'Mention', id: string }> };

export type SearchPlatformMenuItem_PlatformFragment = { __typename?: 'ExternalSearchPlatform', installModes: Array<ExternalSearchMode>, personalAuthorized: boolean, personalAuthUrl?: string | null, platform: string, teamAuthorized: boolean, teamAuthUrl?: string | null };

export type SearchPlatformTabs_PlatformsFragment = { __typename?: 'ExternalSearchPlatform', platform: string, personalAuthorized: boolean, teamAuthorized: boolean };

export type SearchViewSlabSearchQueryVariables = Exact<{
  query: Scalars['String'];
  ancestorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  ownerId?: InputMaybe<Scalars['ID']>;
  contributorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  byIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  mentionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  isStates?: InputMaybe<Array<InputMaybe<SearchIsState>> | InputMaybe<SearchIsState>>;
  first: Scalars['Int'];
  afterCursor?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  timestamp?: InputMaybe<TimestampFilter>;
}>;


export type SearchViewSlabSearchQuery = { __typename?: 'RootQueryType', search?: { __typename?: 'SearchResultConnection', queryId?: string | null, edges?: Array<{ __typename?: 'SearchResultEdge', node?: { __typename?: 'CommentSearchResult', content?: any | null, comment: { __typename?: 'Comment', id: string, insertedAt: any, author: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } } | { __typename?: 'GroupSearchResult', name?: string | null, description?: any | null, group: { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } } | { __typename?: 'PostSearchResult', content?: any | null, highlight?: any | null, highlightIndex?: number | null, title?: string | null, resultId?: string | null, post: { __typename?: 'Post', id: string, views: number, thanks: number, updatedAt: any, publishedAt?: any | null, userViewedAt?: any | null, title: string, archivedAt?: any | null, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null }, ancestors: Array<{ __typename?: 'AncestorSearchResult', id: string, name: string }> } | { __typename?: 'TopicSearchResult', name?: string | null, description?: any | null, topic: { __typename?: 'Topic', id: string, description: any, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> }, ancestors: Array<{ __typename?: 'AncestorSearchResult', id: string, name: string }> } | { __typename?: 'UserSearchResult', description?: any | null, name?: string | null, title?: string | null, user: { __typename?: 'User', email?: string | null, insertedAt?: any | null, name: string, title?: string | null, description: any, id: string, importedFrom?: string | null, deactivatedAt?: any | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type SearchViewExternalResultsQueryVariables = Exact<{
  platform: Scalars['String'];
  query: Scalars['String'];
}>;


export type SearchViewExternalResultsQuery = { __typename?: 'RootQueryType', externalSearch: Array<{ __typename?: 'Mention', id: string, url?: string | null, icon?: string | null, status?: MentionStatus | null, statusDate?: any | null, title: string, type: MentionType, assignee?: { __typename?: 'MentionUser', name: string } | null, content?: { __typename?: 'MentionContentDelta', delta?: any | null } | { __typename?: 'MentionContentHighlights', highlights?: Array<string | null> | null } | { __typename?: 'MentionContentSlack', previous?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, message?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, next?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null } | null, participants?: Array<{ __typename?: 'MentionUser', name: string } | null> | null, preview?: { __typename?: 'MentionPreview', content?: any | null, imageUrl?: string | null } | null, tags?: Array<{ __typename?: 'MentionTag', id: string, color?: string | null, name: string } | null> | null }> };

export type UseExternalSearchQuery_PlatformFragment = { __typename?: 'ExternalSearchPlatform', platform: string, personalAuthorized: boolean, teamAuthorized: boolean };

export type SearchViewExternalPlatformsQueryVariables = Exact<{
  redirectPath: Scalars['String'];
}>;


export type SearchViewExternalPlatformsQuery = { __typename?: 'RootQueryType', externalSearchPlatforms: Array<{ __typename?: 'ExternalSearchPlatform', platform: string, personalAuthorized: boolean, teamAuthorized: boolean, installModes: Array<ExternalSearchMode>, personalAuthUrl?: string | null, teamAuthUrl?: string | null }> };

export type SearchViewExternalResults_PlatformFragment = { __typename?: 'ExternalSearchPlatform', platform: string, personalAuthorized: boolean, personalAuthUrl?: string | null, teamAuthorized: boolean, teamAuthUrl?: string | null };

export type SearchViewExternalResults_MentionFragment = { __typename?: 'Mention', id: string, url?: string | null, icon?: string | null, status?: MentionStatus | null, statusDate?: any | null, title: string, type: MentionType, assignee?: { __typename?: 'MentionUser', name: string } | null, content?: { __typename?: 'MentionContentDelta', delta?: any | null } | { __typename?: 'MentionContentHighlights', highlights?: Array<string | null> | null } | { __typename?: 'MentionContentSlack', previous?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, message?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, next?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null } | null, participants?: Array<{ __typename?: 'MentionUser', name: string } | null> | null, preview?: { __typename?: 'MentionPreview', content?: any | null, imageUrl?: string | null } | null, tags?: Array<{ __typename?: 'MentionTag', id: string, color?: string | null, name: string } | null> | null };

export type SearchViewHeader_PlatformsFragment = { __typename?: 'ExternalSearchPlatform', platform: string, personalAuthorized: boolean, teamAuthorized: boolean };

type SearchViewSlabResults_Results_CommentSearchResult_Fragment = { __typename?: 'CommentSearchResult', content?: any | null, comment: { __typename?: 'Comment', id: string, insertedAt: any, author: { __typename?: 'User', name: string, id: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } };

type SearchViewSlabResults_Results_GroupSearchResult_Fragment = { __typename?: 'GroupSearchResult', name?: string | null, description?: any | null, group: { __typename?: 'Group', id: string, description: any, name: string, banner?: { __typename?: 'Image', original?: string | null } | null, owners: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, members: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } };

type SearchViewSlabResults_Results_PostSearchResult_Fragment = { __typename?: 'PostSearchResult', content?: any | null, highlight?: any | null, highlightIndex?: number | null, title?: string | null, resultId?: string | null, post: { __typename?: 'Post', id: string, views: number, thanks: number, updatedAt: any, publishedAt?: any | null, userViewedAt?: any | null, title: string, archivedAt?: any | null, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null }, ancestors: Array<{ __typename?: 'AncestorSearchResult', id: string, name: string }> };

type SearchViewSlabResults_Results_TopicSearchResult_Fragment = { __typename?: 'TopicSearchResult', name?: string | null, description?: any | null, topic: { __typename?: 'Topic', id: string, description: any, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> }, ancestors: Array<{ __typename?: 'AncestorSearchResult', id: string, name: string }> };

type SearchViewSlabResults_Results_UserSearchResult_Fragment = { __typename?: 'UserSearchResult', description?: any | null, name?: string | null, title?: string | null, user: { __typename?: 'User', email?: string | null, insertedAt?: any | null, name: string, title?: string | null, description: any, id: string, importedFrom?: string | null, deactivatedAt?: any | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> } };

export type SearchViewSlabResults_ResultsFragment = SearchViewSlabResults_Results_CommentSearchResult_Fragment | SearchViewSlabResults_Results_GroupSearchResult_Fragment | SearchViewSlabResults_Results_PostSearchResult_Fragment | SearchViewSlabResults_Results_TopicSearchResult_Fragment | SearchViewSlabResults_Results_UserSearchResult_Fragment;

export type SlackSearchResultContent_ContentFragment = { __typename?: 'MentionContentSlack', previous?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, message?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null, next?: { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null } | null };

export type NewSelectOption_AvatarFragment = { __typename?: 'Image', thumb?: string | null, original?: string | null };

export type SlackMessage_MessageFragment = { __typename?: 'SlackMessage', delta?: any | null, ts?: string | null, user?: { __typename?: 'SlackUser', name?: string | null, profile?: { __typename?: 'SlackUserProfile', avatar?: string | null } | null } | null };

type SeriesHoverCard_Series_PublicSeries_Fragment = { __typename?: 'PublicSeries', id: string, name: string, posts: Array<{ __typename?: 'PublicPost', id: string, title: string, linkAccess: PostLinkAccess }> };

type SeriesHoverCard_Series_Series_Fragment = { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> };

export type SeriesHoverCard_SeriesFragment = SeriesHoverCard_Series_PublicSeries_Fragment | SeriesHoverCard_Series_Series_Fragment;

export type SeriesHoverCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SeriesHoverCardQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> } | null } };

export type PublicSeriesHoverCardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicSeriesHoverCardQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, series?: { __typename?: 'PublicSeries', id: string, name: string, posts: Array<{ __typename?: 'PublicPost', id: string, title: string, linkAccess: PostLinkAccess }> } | null } };

type SeriesRow_Post_Post_Fragment = { __typename?: 'Post', title: string, id: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null };

type SeriesRow_Post_PublicPost_Fragment = { __typename?: 'PublicPost', title: string, id: string, linkAccess: PostLinkAccess };

type SeriesRow_Post_SlimPost_Fragment = { __typename?: 'SlimPost', title: string, id: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null };

export type SeriesRow_PostFragment = SeriesRow_Post_Post_Fragment | SeriesRow_Post_PublicPost_Fragment | SeriesRow_Post_SlimPost_Fragment;

export type AddSeriesModal_PostFragment = { __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type AddSeriesModal_SeriesFragment = { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, series?: { __typename?: 'Series', id: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> };

export type AllSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSeriesQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, series: Array<{ __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, series?: { __typename?: 'Series', id: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> }> } } };

export type AddSeriesModalCreateSeriesMutationVariables = Exact<{
  name: Scalars['String'];
  postIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type AddSeriesModalCreateSeriesMutation = { __typename?: 'RootMutationType', createSeries: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, series?: { __typename?: 'Series', id: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> } };

export type AddSeriesModalUpdateSeriesMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  postIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type AddSeriesModalUpdateSeriesMutation = { __typename?: 'RootMutationType', updateSeries: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, verifiedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, series?: { __typename?: 'Series', id: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> } };

export type EditSeriesModal_SeriesFragment = { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null }> };

export type DeleteSeriesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSeriesMutation = { __typename?: 'RootMutationType', deleteSeries?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null }> } | null };

export type EditSeriesModalUpdateSeriesMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  postIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type EditSeriesModalUpdateSeriesMutation = { __typename?: 'RootMutationType', updateSeries: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null }> } };

export type EditSeriesModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EditSeriesModalQuery = { __typename?: 'RootQueryType', series: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null }> } };

type SeriesAddPost_Post_Post_Fragment = { __typename?: 'Post', id: string, series?: { __typename?: 'Series', id: string } | null };

type SeriesAddPost_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, series?: { __typename?: 'SlimSeries', id: string } | null };

export type SeriesAddPost_PostFragment = SeriesAddPost_Post_Post_Fragment | SeriesAddPost_Post_SlimPost_Fragment;

export type SeriesPostManager_PostsFragment = { __typename?: 'Post', id: string, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, publishedAt?: any | null, series?: { __typename?: 'Series', id: string } | null };

export type SeriesSelect_PostFragment = { __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

export type SeriesSelect_SeriesFragment = { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> };

export type UpdatePostSeriesCacheQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdatePostSeriesCacheQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } };

export type UseSeriesPolicyCheck_PostFragment = { __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

type UseSeriesPolicyCheck_Series_PublicSeries_Fragment = { __typename?: 'PublicSeries' };

type UseSeriesPolicyCheck_Series_Series_Fragment = { __typename?: 'Series', posts: Array<{ __typename?: 'Post', id: string, linkAccess: PostLinkAccess, publishedAt?: any | null, topics: Array<{ __typename?: 'Topic', id: string }>, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null }> };

export type UseSeriesPolicyCheck_SeriesFragment = UseSeriesPolicyCheck_Series_PublicSeries_Fragment | UseSeriesPolicyCheck_Series_Series_Fragment;

export type Favorites_PostFragment = { __typename?: 'Post', id: string, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null };

export type ReorderFavoriteIdsMutationVariables = Exact<{
  favoriteIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderFavoriteIdsMutation = { __typename?: 'RootMutationType', updateUserSettings: { __typename?: 'UserSettings', sidebar?: { __typename?: 'UserSidebarSettings', favoriteIds?: Array<string | null> | null } | null } };

export type ReorderMyTopicIdsMutationVariables = Exact<{
  topicIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderMyTopicIdsMutation = { __typename?: 'RootMutationType', updateUserSettings: { __typename?: 'UserSettings', sidebar?: { __typename?: 'UserSidebarSettings', myTopicIds?: Array<string | null> | null } | null } };

export type ReorderTopicsModal_TopicsFragment = { __typename?: 'Topic', id: string, name: string };

export type ReorderTopicsModal_ParentTopicFragment = { __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type ReorderTopicsMutationVariables = Exact<{
  parentId?: InputMaybe<Scalars['ID']>;
  topicIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderTopicsMutation = { __typename?: 'RootMutationType', reorderTopics: Array<{ __typename?: 'Topic', id: string, order: number }> };

export type SidebarItems_PostFragment = { __typename?: 'Post', id: string, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null };

export type HideSidebarItemsMutationVariables = Exact<{
  hiddenItems: Array<SidebarItem> | SidebarItem;
}>;


export type HideSidebarItemsMutation = { __typename?: 'RootMutationType', updateUserSettings: { __typename?: 'UserSettings', sidebar?: { __typename?: 'UserSidebarSettings', hiddenItems?: Array<SidebarItem | null> | null } | null } };

export type TeamUpgradeInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamUpgradeInfoQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, billingStatus?: BillingSummaryStatus | null, planTier?: PlanTier | null, insertedAt: any, trialEndAt?: any | null } }, billingSummary: { __typename?: 'BillingSummary', userCount: number, seatLimit?: number | null } };

export type ExternalPostPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalPostPlatformsQuery = { __typename?: 'RootQueryType', platforms: Array<{ __typename?: 'ExternalPostPlatform', id: string }> };

export type SidebarSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SidebarSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, settings?: { __typename?: 'UserSettings', sidebar?: { __typename?: 'UserSidebarSettings', favoriteIds?: Array<string | null> | null, myTopicIds?: Array<string | null> | null, hiddenItems?: Array<SidebarItem | null> | null } | null } | null } } };

export type TemplateContent_TemplatePostFragment = { __typename?: 'Post', id: string, title: string, content: any, version: number };

export type TemplateContent_OwnerFragment = { __typename?: 'User', id: string, name: string };

export type TemplateContent_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TemplateHeader_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TemplateHeader_OwnerFragment = { __typename?: 'User', id: string, name: string };

export type TemplateRow_TemplatePostFragment = { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }> };

export type TemplateSidebarItem_PostFragment = { __typename?: 'Post', id: string, title: string };

export type TemplateMenuItemQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type TemplateMenuItemQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, membershipTopics: Array<{ __typename?: 'Topic', id: string, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }> } | null } | null> | null } | null }> } };

export type TemplatesMenuItemAllTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplatesMenuItemAllTopicsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, inheritParent: boolean, order: number, score?: number | null, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string, name: string } | null }> } } };

export type TemplateMenuItemRow_TemplatePostFragment = { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }> };

export type TemplateMenuItemRowTemplatePostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TemplateMenuItemRowTemplatePostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }> } };

export type TemplatesModalTemplatePostFragment = { __typename?: 'Post', id: string, title: string };

export type TemplatesModalTopicFragment = { __typename?: 'Topic', id: string, name: string, inheritParent: boolean, order: number, score?: number | null, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string, name: string } | null, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> };

export type AllTopicsWithTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTopicsWithTemplatesQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, inheritParent: boolean, order: number, score?: number | null, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string, name: string } | null, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }> } } };

export type TemplatesModalTemplatePostContentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TemplatesModalTemplatePostContentQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, title: string, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owner: { __typename?: 'User', id: string, name: string } } };

export type TemplatesModalPersonalTemplatesQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type TemplatesModalPersonalTemplatesQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, posts?: { __typename?: 'PostEdgesConnection', edges?: Array<{ __typename?: 'PostEdgesEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, membershipTopics: Array<{ __typename?: 'Topic', id: string }> } } };

export type TemplatesSidebar_TemplatePostsFragment = { __typename?: 'Post', id: string, title: string };

export type TemplatesSidebar_TopicFragment = { __typename?: 'Topic', id: string, name: string, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null } | null };

export type TemplatesSidebarTopic_TopicFragment = { __typename?: 'Topic', id: string, name: string, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null } | null };

export type TemplatesSidebarTopics_TopicFragment = { __typename?: 'Topic', id: string, name: string, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', node?: { __typename?: 'Post', id: string, title: string } | null } | null> | null } | null };

export type TemplatesViewPersonalQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplatesViewPersonalQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, membershipTopics: Array<{ __typename?: 'Topic', id: string }> } } };

type SortTemplates_Template_Post_Fragment = { __typename?: 'Post', id: string, title: string, views: number, publishedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner: { __typename?: 'User', id: string }, contributors: Array<{ __typename?: 'User', id: string }> };

type SortTemplates_Template_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string, views: number, publishedAt?: any | null, updatedAt: any, userViewedAt?: any | null, owner?: { __typename?: 'SlimUser', id: string } | null, contributors: Array<{ __typename?: 'SlimUser', id: string }> };

export type SortTemplates_TemplateFragment = SortTemplates_Template_Post_Fragment | SortTemplates_Template_SlimPost_Fragment;

export type ExternalSearchInputPublicPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExternalSearchInputPublicPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'PublicPost', id: string, topics: Array<{ __typename?: 'PublicTopic', id: string, name: string, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string, ancestors: Array<{ __typename?: 'PublicTopic', id: string }> }> }> } };

export type ExternalTopbarPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExternalTopbarPostQuery = { __typename?: 'RootQueryType', publicPost: { __typename?: 'PublicPost', id: string, linkAccess: PostLinkAccess } };

export type UnreadNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, unreadNotifications?: { __typename?: 'NotificationConnection', totalCount: number } | null } } };

export type InternalTopbarPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InternalTopbarPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, publishedAt?: any | null, externalPost?: { __typename?: 'ExternalPost', id: string, editUrl: string, platform: string } | null } };

export type PostStatusPostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostStatusPostQuery = { __typename?: 'RootQueryType', post: { __typename?: 'Post', id: string, version: number, content: any, updatedAt: any, lastHistory?: { __typename?: 'SlimHistory', id: string, insertedAt: any, versionTo: number, authors: Array<{ __typename?: 'User', id: string, name: string }> } | null, externalPost?: { __typename?: 'ExternalPost', id: string } | null } };

export type SearchBarRecentlyViewedPostFragment = { __typename?: 'Post', id: string, title: string, publishedAt?: any | null, archivedAt?: any | null, views: number, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type SearchBarViewedPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchBarViewedPostsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', user: { __typename?: 'User', id: string, viewedPosts?: { __typename?: 'PostConnection', edges?: Array<{ __typename?: 'PostEdge', node?: { __typename?: 'Post', id: string, title: string, publishedAt?: any | null, archivedAt?: any | null, views: number, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null } | null } } };

export type UseSavePostToRecentlyViewed_PostFragment = { __typename?: 'Post', id: string, title: string, publishedAt?: any | null, archivedAt?: any | null, views: number, type: PostType, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, ancestors: Array<{ __typename?: 'Topic', id: string, name: string }> }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null };

export type CreateFileWithImportMutationVariables = Exact<{
  files: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  topicId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateFileWithImportMutation = { __typename?: 'RootMutationType', importFiles: Array<{ __typename?: 'ImportedFile', post: { __typename?: 'Post', publishedAt?: any | null, id: string, title: string } }> };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'RootMutationType', logout: boolean };

export type MembershipTopic_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type MembershipTopics_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type PublicSearchResults_PublicPostSearchResultFragment = { __typename?: 'PublicPostSearchResult', content?: any | null, highlight?: any | null, highlightIndex?: number | null, title?: string | null, post: { __typename?: 'PublicPost', id: string, title: string, topics: Array<{ __typename?: 'PublicTopic', id: string, name: string, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string }> }> } };

export type PublicTopicFieldsFragment = { __typename?: 'PublicTopic', id: string, name: string, description: any, posts: Array<{ __typename?: 'PublicPost', id: string, title: string }>, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string }> };

export type PublicTopicViewQueryVariables = Exact<{
  id: Scalars['ID'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type PublicTopicViewQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'PublicTopic', id: string, name: string, description: any, descendants?: { __typename?: 'PublicTopicConnection', edges?: Array<{ __typename?: 'PublicTopicEdge', node?: { __typename?: 'PublicTopic', id: string, name: string, description: any, posts: Array<{ __typename?: 'PublicPost', id: string, title: string }>, ancestors: Array<{ __typename?: 'PublicTopic', id: string }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string, privacy: TopicPrivacy }>, posts: Array<{ __typename?: 'PublicPost', id: string, title: string }> } };

export type PublicSearchQueryVariables = Exact<{
  first: Scalars['Int'];
  query: Scalars['String'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type PublicSearchQuery = { __typename?: 'RootQueryType', publicSearch?: { __typename?: 'PublicSearchResultConnection', edges?: Array<{ __typename?: 'PublicSearchResultEdge', node?: { __typename?: 'PublicPostSearchResult', content?: any | null, highlight?: any | null, highlightIndex?: number | null, title?: string | null, post: { __typename?: 'PublicPost', id: string, title: string, topics: Array<{ __typename?: 'PublicTopic', id: string, name: string, ancestors: Array<{ __typename?: 'PublicTopic', id: string, name: string }> }> } } | { __typename?: 'PublicTopicSearchResult' } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type TopicAccess_TopicFragment = { __typename?: 'Topic', privacy: TopicPrivacy, id: string, requestors: Array<{ __typename?: 'User', id: string }>, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, members: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TopicActionButtons_UsersFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicActivitiesQueryVariables = Exact<{
  id: Scalars['ID'];
  afterCursor?: InputMaybe<Scalars['String']>;
}>;


export type TopicActivitiesQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, activities?: { __typename?: 'ActivityConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ActivityEdge', node?: { __typename?: 'CreatedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null } | { __typename?: 'CreatedHistoryActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, createdHistory?: { __typename?: 'History', id: string, diff: any, snapshot: any, versionFrom: number, versionTo: number, post: { __typename?: 'Post', id: string, publishedAt?: any | null, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } | null } | { __typename?: 'CreatedTopicActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null } | { __typename?: 'FillerActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string } | null } | { __typename?: 'JoinedUserActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, joinedUser?: { __typename?: 'User', id: string } | null } | { __typename?: 'PublishedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, publishedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null } | { __typename?: 'RepliedCommentActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, repliedComment?: { __typename?: 'Comment', id: string, content: any, thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string, topics: Array<{ __typename?: 'Topic', id: string, name: string }> } } } | null } | { __typename?: 'ThankedPostActivity', actedAt?: any | null, actor?: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null, thankedPost?: { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null, verifiedAt?: any | null, linkAccess: PostLinkAccess, content: any, version: number, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, owner: { __typename?: 'User', name: string, id: string }, series?: { __typename?: 'Series', name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null } | null } | null } | null> | null } | null } };

type TopicBreadcrumbs_Topics_PublicTopic_Fragment = { __typename?: 'PublicTopic', name: string, id: string, privacy: TopicPrivacy };

type TopicBreadcrumbs_Topics_Topic_Fragment = { __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy };

export type TopicBreadcrumbs_TopicsFragment = TopicBreadcrumbs_Topics_PublicTopic_Fragment | TopicBreadcrumbs_Topics_Topic_Fragment;

export type TopicCard_TopicFragment = { __typename?: 'Topic', id: string, description: any, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type TopicCard_AncestorsFragment = { __typename?: 'AncestorSearchResult', id: string, name: string };

type TopicCardContent_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', id: string, description: any, name: string, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'PublicTopic', name: string, id: string, privacy: TopicPrivacy }> };

type TopicCardContent_Topic_Topic_Fragment = { __typename?: 'Topic', id: string, description: any, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type TopicCardContent_TopicFragment = TopicCardContent_Topic_PublicTopic_Fragment | TopicCardContent_Topic_Topic_Fragment;

export type TopicCardContent_AncestorsFragment = { __typename?: 'AncestorSearchResult', id: string, name: string };

export type PublicTopicDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicTopicDetailPreviewQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'PublicTopic', id: string, name: string, description: any, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'PublicTopic', name: string, id: string, privacy: TopicPrivacy }> } };

export type TopicDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TopicDetailPreviewQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, name: string, description: any, templateCount: number, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, banner?: { __typename?: 'Image', original?: string | null } | null, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, postCounts: Array<{ __typename?: 'TopicPostCount', count?: number | null, type?: TopicPostsType | null }>, descendants?: { __typename?: 'TopicDescendantConnection', totalCount: number } | null } };

type TopicNameWithIcon_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', id: string, name: string, privacy: TopicPrivacy };

type TopicNameWithIcon_Topic_Topic_Fragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy };

export type TopicNameWithIcon_TopicFragment = TopicNameWithIcon_Topic_PublicTopic_Fragment | TopicNameWithIcon_Topic_Topic_Fragment;

export type TopicPill_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy };

export type TopicPills_TopicsFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy };

type TopicPrivacyIcon_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', privacy: TopicPrivacy };

type TopicPrivacyIcon_Topic_Topic_Fragment = { __typename?: 'Topic', memberEditable: TopicMemberEditable, privacy: TopicPrivacy };

export type TopicPrivacyIcon_TopicFragment = TopicPrivacyIcon_Topic_PublicTopic_Fragment | TopicPrivacyIcon_Topic_Topic_Fragment;

export type TopicSelectOption_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }> };

export type SubtopicsViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubtopicsViewQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, name: string } };

export type TopicView_TopicFragment = { __typename?: 'Topic', id: string, name: string, description: any, defaultShow?: TopicPostsType | null, defaultSort?: TopicPostsOrder | null, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, templateCount: number, banner?: { __typename?: 'Image', original?: string | null } | null, children: Array<{ __typename?: 'Topic', order: number, name: string, score?: number | null, id: string }>, postCounts: Array<{ __typename?: 'TopicPostCount', type?: TopicPostsType | null, count?: number | null }>, ancestors: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, requestors: Array<{ __typename?: 'User', id: string }>, descendants?: { __typename?: 'TopicDescendantConnection', totalCount: number } | null, parent?: { __typename?: 'Topic', id: string } | null, members: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string }> };

export type TopicViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TopicViewQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, name: string, description: any, defaultShow?: TopicPostsType | null, defaultSort?: TopicPostsOrder | null, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, templateCount: number, banner?: { __typename?: 'Image', original?: string | null } | null, children: Array<{ __typename?: 'Topic', order: number, name: string, score?: number | null, id: string }>, postCounts: Array<{ __typename?: 'TopicPostCount', type?: TopicPostsType | null, count?: number | null }>, ancestors: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, requestors: Array<{ __typename?: 'User', id: string }>, descendants?: { __typename?: 'TopicDescendantConnection', totalCount: number } | null, parent?: { __typename?: 'Topic', id: string } | null, members: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string }> } };

export type TopicViewHeader_TopicFragment = { __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, description: any, templateCount: number, postCounts: Array<{ __typename?: 'TopicPostCount', type?: TopicPostsType | null, count?: number | null }>, ancestors: Array<{ __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, banner?: { __typename?: 'Image', original?: string | null } | null, children: Array<{ __typename?: 'Topic', id: string, name: string }>, requestors: Array<{ __typename?: 'User', id: string }>, descendants?: { __typename?: 'TopicDescendantConnection', totalCount: number } | null, parent?: { __typename?: 'Topic', id: string } | null, members: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string }> };

export type UnorganizedViewQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UnorganizedPostsFilter>;
  orderBy?: InputMaybe<UnorganizedPostsOrder>;
}>;


export type UnorganizedViewQuery = { __typename?: 'RootQueryType', allPostsCount: number, archivedPostsCount: number, publishedPostsCount: number, verifiedPostsCount: number, templatePostsCount: number, unorganized?: { __typename?: 'PostEdgesConnection', totalCount: number, edges?: Array<{ __typename?: 'PostEdgesEdge', node?: { __typename?: 'Post', insertedAt: any, id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type EditTopicModal_TopicFragment = { __typename?: 'Topic', id: string, name: string, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, parent?: { __typename?: 'Topic', id: string } | null };

export type CreateTopicMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['Json']>;
  memberEditable?: InputMaybe<TopicMemberEditable>;
  parentId?: InputMaybe<Scalars['ID']>;
  privacy?: InputMaybe<TopicPrivacy>;
  inheritParent?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateTopicMutation = { __typename?: 'RootMutationType', createTopic: { __typename?: 'Topic', id: string } };

export type AllowUserRootTopicQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowUserRootTopicQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowUserRootTopic?: boolean | null } | null } } };

export type SubtopicPostsSection_TopicFragment = { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, posts?: { __typename?: 'TopicPostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, cursor?: string | null, node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type SubtopicIntegrationLinksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubtopicIntegrationLinksQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, integrationLinks: Array<{ __typename?: 'IntegrationLink', id: string, title?: string | null, type: MentionType, externalId: string, insertedBy: { __typename?: 'User', id: string }, preview?: { __typename?: 'Image', original?: string | null } | null }> } };

export type SubtopicPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  postsAfterCursor?: InputMaybe<Scalars['String']>;
  postsFirst: Scalars['Int'];
  orderBy: TopicPostsOrder;
  type?: InputMaybe<TopicPostsType>;
}>;


export type SubtopicPostsQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, posts?: { __typename?: 'TopicPostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, cursor?: string | null, node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> } };

type TopicPostOverflowMenuContent_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null };

type TopicPostOverflowMenuContent_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string, archivedAt?: any | null, publishedAt?: any | null };

export type TopicPostOverflowMenuContent_PostFragment = TopicPostOverflowMenuContent_Post_Post_Fragment | TopicPostOverflowMenuContent_Post_SlimPost_Fragment;

export type TopicPostSection_IntegrationLinkFragment = { __typename?: 'IntegrationLink', id: string, title?: string | null, type: MentionType, externalId: string, insertedBy: { __typename?: 'User', id: string }, preview?: { __typename?: 'Image', original?: string | null } | null };

type TopicPostSection_Post_Post_Fragment = { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null };

type TopicPostSection_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'SlimSeries', id: string } | null, contributors: Array<{ __typename?: 'SlimUser', id: string }>, topics: Array<{ __typename?: 'SlimTopic', id: string }>, externalPost?: { __typename?: 'SlimExternalPost', id: string, platform: string } | null };

export type TopicPostSection_PostFragment = TopicPostSection_Post_Post_Fragment | TopicPostSection_Post_SlimPost_Fragment;

export type TopicPostSection_PostsFragment = { __typename?: 'TopicPostConnection', totalCount: number, edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, cursor?: string | null, node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } };

export type TopicIntegrationLinksQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TopicIntegrationLinksQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, integrationLinks: Array<{ __typename?: 'IntegrationLink', id: string, title?: string | null, type: MentionType, externalId: string, insertedBy: { __typename?: 'User', id: string }, preview?: { __typename?: 'Image', original?: string | null } | null }> } };

export type TopicPostsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderBy?: InputMaybe<TopicPostsOrder>;
  type?: InputMaybe<TopicPostsType>;
}>;


export type TopicPostsQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, postCounts: Array<{ __typename?: 'TopicPostCount', type?: TopicPostsType | null, count?: number | null }>, posts?: { __typename?: 'TopicPostConnection', totalCount: number, edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, cursor?: string | null, node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> } };

export type TopicDescendantsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  postsFirst?: InputMaybe<Scalars['Int']>;
  postsAfterCursor?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<TopicPostsOrder>;
  type?: InputMaybe<TopicPostsType>;
}>;


export type TopicDescendantsQuery = { __typename?: 'RootQueryType', topic: { __typename?: 'Topic', id: string, descendants?: { __typename?: 'TopicDescendantConnection', edges?: Array<{ __typename?: 'TopicDescendantEdge', node?: { __typename?: 'Topic', id: string, order: number, name: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ancestors: Array<{ __typename?: 'Topic', name: string, id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy }>, posts?: { __typename?: 'TopicPostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, cursor?: string | null, node?: { __typename?: 'Post', id: string, insertedAt: any, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, topics: Array<{ __typename?: 'Topic', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null, owner: { __typename?: 'User', id: string }, sharing?: { __typename?: 'PostDirectShare', editorIds?: Array<string | null> | null, viewerIds?: Array<string | null> | null, editorGroupIds?: Array<string | null> | null, viewerGroupIds?: Array<string | null> | null } | null, verification?: { __typename?: 'Verification', id: string } | null } | null } | null> | null } | null, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };

export type UseTopicPostsData_TopicFragment = { __typename?: 'Topic', id: string, defaultShow?: TopicPostsType | null, defaultSort?: TopicPostsOrder | null };

export type TopicPosts_TopicFragment = { __typename?: 'Topic', id: string, defaultShow?: TopicPostsType | null, defaultSort?: TopicPostsOrder | null };

export type TopicReorderablePosts_PostEdgesFragment = { __typename?: 'TopicPostEdge', pinnedOrder?: number | null, node?: { __typename?: 'Post', id: string } | null };

export type PinPostMutationVariables = Exact<{
  first: Scalars['Int'];
  pinnedOrder: Scalars['Int'];
  orderBy: TopicPostsOrder;
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
  type?: InputMaybe<TopicPostsType>;
}>;


export type PinPostMutation = { __typename?: 'RootMutationType', pinPost: { __typename?: 'Topic', id: string, posts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', cursor?: string | null, pinnedOrder?: number | null, node?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, views: number, content: any, version: number, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owner: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string, editUrl: string, readUrl: string, externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> } | null } | null } | null> | null } | null } };

export type UnpinPostMutationVariables = Exact<{
  first: Scalars['Int'];
  orderBy: TopicPostsOrder;
  postId: Scalars['ID'];
  topicId: Scalars['ID'];
  type?: InputMaybe<TopicPostsType>;
}>;


export type UnpinPostMutation = { __typename?: 'RootMutationType', unpinPost: { __typename?: 'Topic', id: string, posts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', cursor?: string | null, pinnedOrder?: number | null, node?: { __typename?: 'Post', id: string, archivedAt?: any | null, publishedAt?: any | null, updatedAt: any, views: number, content: any, version: number, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, archiver?: { __typename?: 'User', id: string, name: string } | null, contributors: Array<{ __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }>, owner: { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string, editUrl: string, readUrl: string, externalId: string } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess, publishedAt?: any | null }> } | null } | null } | null> | null } | null } };

export type UsePinMutations_TopicFragment = { __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type ToTopicTreeList_TopicFragment = { __typename?: 'Topic', id: string, name: string, inheritParent: boolean, order: number, score?: number | null, parent?: { __typename?: 'Topic', id: string, name: string } | null };

export type TopicPolicyCheck_TopicFragment = { __typename?: 'Topic', memberEditable: TopicMemberEditable, privacy: TopicPrivacy, id: string, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TopicPolicyCheck_UserFragment = { __typename?: 'User', id: string, type?: UserType | null };

export type AllTopicsWithPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTopicsWithPostsQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, topics: Array<{ __typename?: 'Topic', id: string, allPosts?: { __typename?: 'TopicPostConnection', edges?: Array<{ __typename?: 'TopicPostEdge', pinnedOrder?: number | null, node?: { __typename?: 'Post', id: string, publishedAt?: any | null, type: PostType, verifiedAt?: any | null, title: string, linkAccess: PostLinkAccess } | null } | null> | null } | null }> } } };

export type AllTopicFieldsFragment = { __typename?: 'Topic', id: string, name: string, description: any, score?: number | null, order: number, inheritParent: boolean, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, parent?: { __typename?: 'Topic', id: string, name: string } | null, membership: { __typename?: 'TopicMembership', ownerUserIds?: Array<string | null> | null, memberUserIds?: Array<string | null> | null, requestorUserIds?: Array<string | null> | null, ownerGroupIds?: Array<string | null> | null, memberGroupIds?: Array<string | null> | null } };

export type AllTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTopicsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, score?: number | null, order: number, inheritParent: boolean, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, parent?: { __typename?: 'Topic', id: string, name: string } | null, membership: { __typename?: 'TopicMembership', ownerUserIds?: Array<string | null> | null, memberUserIds?: Array<string | null> | null, requestorUserIds?: Array<string | null> | null, ownerGroupIds?: Array<string | null> | null, memberGroupIds?: Array<string | null> | null } }> } } };

export type TopicCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TopicCreatedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string, name: string, description: any, score?: number | null, order: number, inheritParent: boolean, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, parent?: { __typename?: 'Topic', id: string, name: string } | null, membership: { __typename?: 'TopicMembership', ownerUserIds?: Array<string | null> | null, memberUserIds?: Array<string | null> | null, requestorUserIds?: Array<string | null> | null, ownerGroupIds?: Array<string | null> | null, memberGroupIds?: Array<string | null> | null } } | null };

export type TopicDeletedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TopicDeletedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string, parent?: { __typename?: 'Topic', id: string } | null } | null };

export type TopicUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TopicUpdatedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string, name: string, description: any, score?: number | null, order: number, inheritParent: boolean, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, parent?: { __typename?: 'Topic', id: string, name: string } | null, membership: { __typename?: 'TopicMembership', ownerUserIds?: Array<string | null> | null, memberUserIds?: Array<string | null> | null, requestorUserIds?: Array<string | null> | null, ownerGroupIds?: Array<string | null> | null, memberGroupIds?: Array<string | null> | null } } | null };

export type DeleteTopicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTopicMutation = { __typename?: 'RootMutationType', deleteTopic?: { __typename?: 'Topic', id: string } | null };

export type UseFavoriteTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseFavoriteTopicsQuery = { __typename?: 'RootQueryType', currentSession: { __typename?: 'Session', user: { __typename?: 'User', id: string, favoriteTopics: Array<{ __typename?: 'Topic', id: string }> } } };

export type TopicFavoriteAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TopicFavoriteAddedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string } | null };

export type TopicFavoriteRemovedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TopicFavoriteRemovedSubscription = { __typename?: 'RootSubscriptionType', topic?: { __typename?: 'Topic', id: string } | null };

export type UseMembershipTopics_TopicFragment = { __typename?: 'Topic', id: string };

export type FavoriteTopicMutationVariables = Exact<{
  id: Scalars['ID'];
  add?: InputMaybe<Scalars['Boolean']>;
}>;


export type FavoriteTopicMutation = { __typename?: 'RootMutationType', favoriteTopic: { __typename?: 'Topic', id: string } };

export type ReorganizeMutationVariables = Exact<{
  operations: Array<ReorganizeOperation> | ReorganizeOperation;
}>;


export type ReorganizeMutation = { __typename?: 'RootMutationType', reorganize?: boolean | null };

export type AddUserToTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AddUserToTopicMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type RemoveUserFromTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveUserFromTopicMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type UpdateUserInTopicMutationVariables = Exact<{
  oldRole: TopicUserRole;
  topicId: Scalars['ID'];
  userId: Scalars['ID'];
  role: TopicUserRole;
}>;


export type UpdateUserInTopicMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type UpdateInheritParentMutationVariables = Exact<{
  topicId: Scalars['ID'];
  inheritParent: Scalars['Boolean'];
}>;


export type UpdateInheritParentMutation = { __typename?: 'RootMutationType', updateTopic: { __typename?: 'Topic', id: string } };

export type RemoveGroupFromTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
  groupId: Scalars['ID'];
}>;


export type RemoveGroupFromTopicMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string } };

export type UpdateGroupInTopicMutationVariables = Exact<{
  oldRole: TopicGroupRole;
  topicId: Scalars['ID'];
  groupId: Scalars['ID'];
  role: TopicGroupRole;
}>;


export type UpdateGroupInTopicMutation = { __typename?: 'RootMutationType', group: { __typename?: 'User', id: string } };

export type AddGroupToTopicMutationVariables = Exact<{
  topicId: Scalars['ID'];
  groupId: Scalars['ID'];
}>;


export type AddGroupToTopicMutation = { __typename?: 'RootMutationType', group: { __typename?: 'Group', id: string, name: string, allUsers: Array<{ __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } };

export type RequestTopicAccessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RequestTopicAccessMutation = { __typename?: 'RootMutationType', user: { __typename?: 'User', id: string, name: string, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type UseUpdateTopicUser_TopicFragment = { __typename?: 'Topic', id: string };

export type UseAddTopicUser_TopicFragment = { __typename?: 'Topic', id: string, members: Array<{ __typename?: 'User', id: string }>, owners: Array<{ __typename?: 'User', id: string }>, requestors: Array<{ __typename?: 'User', id: string }> };

export type UseAddTopicGroup_TopicFragment = { __typename?: 'Topic', id: string, ownerGroups: Array<{ __typename?: 'Group', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string }> };

export type UseRemoveTopicGroup_TopicFragment = { __typename?: 'Topic', id: string, ownerGroups: Array<{ __typename?: 'Group', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string }> };

export type UseUpdateTopicGroup_TopicFragment = { __typename?: 'Topic', id: string };

export type UseUpdateInheritParent_TopicFragment = { __typename?: 'Topic', id: string };

export type TopicGroupRow_GroupFragment = { __typename?: 'Group', id: string, name: string, allUsers: Array<{ __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> };

export type TopicUserCollapsibleList_MembersFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserCollapsibleList_OwnersFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserList_MembersFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserList_OwnersFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserList_RequestorsFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserList_TopicFragment = { __typename?: 'Topic', memberEditable: TopicMemberEditable, privacy: TopicPrivacy, id: string, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TopicUserRow_TopicFragment = { __typename?: 'Topic', memberEditable: TopicMemberEditable, privacy: TopicPrivacy, id: string, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type TopicUserRow_UserFragment = { __typename?: 'User', id: string, type?: UserType | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type TopicUserSelect_TopicFragment = { __typename?: 'Topic', id: string, name: string, parent?: { __typename?: 'Topic', id: string } | null, membership: { __typename?: 'TopicMembership', ownerUserIds?: Array<string | null> | null, memberUserIds?: Array<string | null> | null, ownerGroupIds?: Array<string | null> | null, memberGroupIds?: Array<string | null> | null } };

export type GetTopicAccessWarnings_TopicFragment = { __typename?: 'Topic', id: string, inheritParent: boolean, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, parent?: { __typename?: 'Topic', id: string, memberEditable: TopicMemberEditable, privacy: TopicPrivacy, parent?: { __typename?: 'Topic', id: string } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> } | null, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }> };

export type GetTopicAccessWarnings_UserFragment = { __typename?: 'User', id: string, name: string };

export type GetTopicUsers_Topic_BaseFragment = { __typename?: 'Topic', owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type GetTopicUsers_TopicFragment = { __typename?: 'Topic', id: string, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type GetInheritedUsers_TopicFragment = { __typename?: 'Topic', id: string, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type GetTopicUserIdSet_TopicFragment = { __typename?: 'Topic', id: string, inheritedAncestors: Array<{ __typename?: 'Topic', id: string, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> }>, owners: Array<{ __typename?: 'User', id: string }>, ownerGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }>, members: Array<{ __typename?: 'User', id: string }>, memberGroups: Array<{ __typename?: 'Group', id: string, allUsers: Array<{ __typename?: 'User', id: string }> }> };

export type SortTopic_TopicFragment = { __typename?: 'Topic', order: number, name: string, score?: number | null };

export type UserCard_UserFragment = { __typename?: 'User', email?: string | null, insertedAt?: any | null, name: string, title?: string | null, description: any, id: string, importedFrom?: string | null, deactivatedAt?: any | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> };

export type UserDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserDetailPreviewQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, title?: string | null, name: string, description: any, email?: string | null, importedFrom?: string | null, deactivatedAt?: any | null, type?: UserType | null, ownedPostsCount: number, membershipGroups: Array<{ __typename?: 'Group', id: string, name: string }>, membershipTopics: Array<{ __typename?: 'Topic', id: string }>, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }>, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }, microsoftIntegration?: { __typename?: 'Integration', id: string } | null, slackIntegration?: { __typename?: 'Integration', externalId: string } | null, slackUser?: { __typename?: 'SlackUser', id?: string | null } | null };

export type PublicUserDetailPreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicUserDetailPreviewQuery = { __typename?: 'RootQueryType', publicUser: { __typename?: 'PublicUser', id: string, title?: string | null, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } };

export type HoverListHoverCard_UserFragment = { __typename?: 'User', id: string, name: string, title?: string | null, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UserRow_UserFragment = { __typename?: 'User', name: string, title?: string | null, id: string, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UserSelectOption_UserFragment = { __typename?: 'User', id: string, title?: string | null, email?: string | null, name: string, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

type GetUserNames_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string };

type GetUserNames_User_User_Fragment = { __typename?: 'User', id: string, name: string };

type GetUserNames_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string };

export type GetUserNames_UserFragment = GetUserNames_User_PublicUser_Fragment | GetUserNames_User_User_Fragment | GetUserNames_User_VisitorUser_Fragment;

export type ExternalProfilesQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type ExternalProfilesQuery = { __typename?: 'RootQueryType', microsoftIntegration?: { __typename?: 'Integration', id: string } | null, slackIntegration?: { __typename?: 'Integration', externalId: string } | null, slackUser?: { __typename?: 'SlackUser', id?: string | null } | null };

export type ExternalProfileButtons_UserFragment = { __typename?: 'User', id: string, email?: string | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> };

export type UserBadge_UserFragment = { __typename?: 'User', deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null };

export type UserPostsQueryVariables = Exact<{
  id: Scalars['ID'];
  afterCursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserPostsFilter>;
  orderBy?: InputMaybe<UserPostsOrder>;
}>;


export type UserPostsQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, name: string, posts?: { __typename?: 'PostEdgesConnection', totalCount: number, edges?: Array<{ __typename?: 'PostEdgesEdge', node?: { __typename?: 'Post', insertedAt: any, id: string, publishedAt?: any | null, userViewedAt?: any | null, updatedAt: any, views: number, type: PostType, archivedAt?: any | null, title: string, verifiedAt?: any | null, linkAccess: PostLinkAccess, topics: Array<{ __typename?: 'Topic', id: string, name: string, description: any, privacy: TopicPrivacy, memberEditable: TopicMemberEditable, defaultSort?: TopicPostsOrder | null, defaultShow?: TopicPostsType | null }>, series?: { __typename?: 'Series', id: string, name: string, posts: Array<{ __typename?: 'Post', id: string }> } | null, contributors: Array<{ __typename?: 'User', id: string }>, externalPost?: { __typename?: 'ExternalPost', id: string, platform: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };

export type UserProfileButtons_UserFragment = { __typename?: 'User', id: string, email?: string | null, importedFrom?: string | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> };

export type UserProfileHeader_UserFragment = { __typename?: 'User', id: string, name: string, title?: string | null, description: any, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, email?: string | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> };

export type UserProfileUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserProfileUserQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, name: string, title?: string | null, description: any, deactivatedAt?: any | null, importedFrom?: string | null, type?: UserType | null, email?: string | null, allPostsCount: number, contributedPostsCount: number, publishedPostsCount: number, verifiedPostsCount: number, templatePostsCount: number, membershipTopics: Array<{ __typename?: 'Topic', id: string }>, membershipGroups: Array<{ __typename?: 'Group', id: string, name: string }>, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null, identities: Array<{ __typename?: 'Identity', id: string, externalId: string, platform: string }> } };

export type UserProfileAvatarEditor_UserFragment = { __typename?: 'User', id: string, name: string, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type UserProfileSettingsForm_UserFragment = { __typename?: 'User', id: string, name: string, title?: string | null, description: any, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type SettingsModalUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SettingsModalUserQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, name: string, title?: string | null, description: any, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  id: Scalars['ID'];
  avatar?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'User', id: string, name: string, title?: string | null, description: any, avatar?: { __typename?: 'Image', original?: string | null, thumb?: string | null } | null } };

export type UpdateUserSettingsMutationVariables = Exact<{
  allowAccountAccess?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<UserSettingsNotificationsInput>;
  uiTheme?: InputMaybe<UiThemeSetting>;
  aiAutofix?: InputMaybe<Scalars['Boolean']>;
  aiPredict?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'RootMutationType', settings: { __typename?: 'UserSettings', allowAccountAccess?: boolean | null, uiTheme?: UiThemeSetting | null, aiAutofix?: boolean | null, aiPredict?: boolean | null, notifications?: { __typename?: 'UserNotificationSettings', direct?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, participant?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, team?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null } | null } };

export type UseAllUsers_UserFragment = { __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, description: any, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null };

export type AllUsersQueryVariables = Exact<{
  includeDeactivated?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllUsersQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, users: Array<{ __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, description: any, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null }> } } };

export type UserCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserCreatedSubscription = { __typename?: 'RootSubscriptionType', user?: { __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, description: any, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null };

export type UserUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserUpdatedSubscription = { __typename?: 'RootSubscriptionType', user?: { __typename?: 'User', id: string, name: string, email?: string | null, title?: string | null, description: any, type?: UserType | null, deactivatedAt?: any | null, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } | null };

export type UpdateUserEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
}>;


export type UpdateUserEmailMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'User', id: string, email?: string | null } };

export type UpdatePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  oldPassword?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePasswordMutation = { __typename?: 'RootMutationType', updatePassword: { __typename?: 'Session', authToken: string, intercomHash: string, organization: { __typename?: 'Organization', id: string, insertedAt: any, name: string, email: string, host: string, effectiveHost: string, isVerified?: boolean | null, planTier?: PlanTier | null, periodEndAt?: any | null, trialEndAt?: any | null, isTrialEnded?: boolean | null, isTrialEndingSoon?: boolean | null, isLocked?: boolean | null, billingStatus?: BillingSummaryStatus | null, logo?: { __typename?: 'Image', thumb?: string | null } | null, settings?: { __typename?: 'OrganizationSettings', authentication?: AuthenticationMode | null, seatLimit?: number | null } | null }, user: { __typename?: 'User', id: string, email?: string | null, name: string, title?: string | null, description: any, type?: UserType | null, insertedAt?: any | null, membershipGroups: Array<{ __typename?: 'Group', id: string }>, settings?: { __typename?: 'UserSettings', allowAccountAccess?: boolean | null, uiTheme?: UiThemeSetting | null, aiAutofix?: boolean | null, aiPredict?: boolean | null, notifications?: { __typename?: 'UserNotificationSettings', direct?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, participant?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null, team?: { __typename?: 'UserNotificationPlatforms', email?: boolean | null, slack?: boolean | null } | null } | null } | null, identities: Array<{ __typename?: 'Identity', id: string, platform: string }>, avatar?: { __typename?: 'Image', thumb?: string | null, original?: string | null } | null } } };

export type UserMembershipTopicsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserMembershipTopicsQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id: string, membershipTopics: Array<{ __typename?: 'Topic', id: string, name: string }> } };

export type UserActionPermissionCheck_UserFragment = { __typename?: 'User', id: string, type?: UserType | null, deactivatedAt?: any | null };

export type UploadPostAttachmentMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadPostAttachmentMutation = { __typename?: 'RootMutationType', attachment: { __typename?: 'PostUpload', url?: string | null } };

export type UploadPostImageMutationVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']>;
  url?: InputMaybe<Scalars['String']>;
}>;


export type UploadPostImageMutation = { __typename?: 'RootMutationType', image: { __typename?: 'PostUpload', url?: string | null } };

export type CommentThreadPath_ThreadFragment = { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } };

type GroupPath_Group_Group_Fragment = { __typename?: 'Group', id: string, name: string };

type GroupPath_Group_PublicGroup_Fragment = { __typename?: 'PublicGroup', id: string, name: string };

export type GroupPath_GroupFragment = GroupPath_Group_Group_Fragment | GroupPath_Group_PublicGroup_Fragment;

export type HistoryPath_PostFragment = { __typename?: 'Post', id: string, title: string };

type NotificationPath_Notifications_CommentNotification_Fragment = { __typename?: 'CommentNotification', id: string, comment?: { __typename?: 'Comment', thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null };

type NotificationPath_Notifications_HistoryNotification_Fragment = { __typename?: 'HistoryNotification', id: string, history?: { __typename?: 'History', versionTo: number, versionFrom: number, post: { __typename?: 'Post', id: string, title: string } } | null };

type NotificationPath_Notifications_InvitationNotification_Fragment = { __typename?: 'InvitationNotification', id: string, invitation?: { __typename?: 'Invitation', acceptedUser?: { __typename?: 'User', id: string, name: string } | null } | null };

type NotificationPath_Notifications_PostNotification_Fragment = { __typename?: 'PostNotification', id: string, post?: { __typename?: 'Post', id: string, title: string } | null };

type NotificationPath_Notifications_ReactionNotification_Fragment = { __typename?: 'ReactionNotification', id: string, reaction?: { __typename?: 'Reaction', thread: { __typename?: 'Thread', id: string, resolvedAt?: any | null, post: { __typename?: 'Post', id: string, title: string } } } | null };

export type NotificationPath_NotificationsFragment = NotificationPath_Notifications_CommentNotification_Fragment | NotificationPath_Notifications_HistoryNotification_Fragment | NotificationPath_Notifications_InvitationNotification_Fragment | NotificationPath_Notifications_PostNotification_Fragment | NotificationPath_Notifications_ReactionNotification_Fragment;

type PostPath_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type PostPath_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type PostPath_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type PostPath_PostFragment = PostPath_Post_Post_Fragment | PostPath_Post_PublicPost_Fragment | PostPath_Post_SlimPost_Fragment;

type PostEmbedPath_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type PostEmbedPath_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type PostEmbedPath_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type PostEmbedPath_PostFragment = PostEmbedPath_Post_Post_Fragment | PostEmbedPath_Post_PublicPost_Fragment | PostEmbedPath_Post_SlimPost_Fragment;

type PublicPostPath_Post_Post_Fragment = { __typename?: 'Post', id: string, title: string };

type PublicPostPath_Post_PublicPost_Fragment = { __typename?: 'PublicPost', id: string, title: string };

type PublicPostPath_Post_SlimPost_Fragment = { __typename?: 'SlimPost', id: string, title: string };

export type PublicPostPath_PostFragment = PublicPostPath_Post_Post_Fragment | PublicPostPath_Post_PublicPost_Fragment | PublicPostPath_Post_SlimPost_Fragment;

export type ProvisionRegisterUrl_ProvisionFragment = { __typename?: 'Provision', id: string, secret: string };

type TopicPath_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', id: string, name: string };

type TopicPath_Topic_Topic_Fragment = { __typename?: 'Topic', id: string, name: string };

export type TopicPath_TopicFragment = TopicPath_Topic_PublicTopic_Fragment | TopicPath_Topic_Topic_Fragment;

type PublicTopicPath_Topic_PublicTopic_Fragment = { __typename?: 'PublicTopic', id: string, name: string };

type PublicTopicPath_Topic_Topic_Fragment = { __typename?: 'Topic', id: string, name: string };

export type PublicTopicPath_TopicFragment = PublicTopicPath_Topic_PublicTopic_Fragment | PublicTopicPath_Topic_Topic_Fragment;

type UserPath_User_PublicUser_Fragment = { __typename?: 'PublicUser', id: string, name: string };

type UserPath_User_User_Fragment = { __typename?: 'User', id: string, name: string };

type UserPath_User_VisitorUser_Fragment = { __typename?: 'VisitorUser', id: string, name: string };

export type UserPath_UserFragment = UserPath_User_PublicUser_Fragment | UserPath_User_User_Fragment | UserPath_User_VisitorUser_Fragment;

export type AllowPublicContentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowPublicContentSettingsQuery = { __typename?: 'RootQueryType', session: { __typename?: 'Session', organization: { __typename?: 'Organization', id: string, settings?: { __typename?: 'OrganizationSettings', allowPublicContentBy?: AllowPublicContentBy | null } | null } } };
